webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return services; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__(345);

var services = __WEBPACK_IMPORTED_MODULE_0__services__["a" /* default */];

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    serverURI: 'https://mypa.website:3900',
    fixedLayout: false,
    hideLogoOnMobile: false
});

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(508)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(381),
  /* template */
  __webpack_require__(716),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(527)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(416),
  /* template */
  __webpack_require__(740),
  /* scopeId */
  "data-v-a942fe4c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(641);



__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

var messages = {
    'en': {
        welcomeMsg: 'Welcome to Your Vue.js App',
        guide: 'For a guide and recipes on how to configure / customize this project,',
        checkout: 'check out the',
        plugins: 'Installed CLI Plugins',
        links: 'Essential Links',
        ecosystem: 'Ecosystem',
        name: 'Name',
        age: 'Age',
        weight: 'Weight',
        height: 'Height',
        address: 'Address',
        city: 'City',
        zipcode: 'Zipcode',
        contactNumber: 'Contact Number',
        status: 'Status',
        registerDate: 'Register',
        lastUpdate: 'Last Update',
        weightData: ['Extra skinny', 'skinny', 'Average', 'fat', 'extra fatty', 'en-N/A'],
        heightData: ['short', 'average', 'tall', 'extra tall', 'en-N/A'],
        condition: 'Health condition',
        sex: ['Male', 'Female'],
        gender: 'Gender',
        statusData: ['Reported', 'Forwarded to '],
        conditionData: ['Not evaluated', 'Stable'],
        ageFrom: 'Age Min',
        ageTo: 'Age Max',
        search: 'Search',
        pre_health_condition: 'Pre health condition',
        diabetics: 'Diabetics',
        heart: 'Heart diseases',
        lungs: 'Lungs diseases/asthma',
        skomking: 'Smoking habit',
        not_sure: 'Not sure',
        dont_have: 'Dont have',
        have_but_controlled: 'Mild or controlled',
        high_condition: 'High or severe',
        never_smoke: 'Never Smoked',
        smoker_quit: 'Smoker but quited',
        smoker: 'Smoker',
        duration_na: 'Note sure',
        duration_less_5: 'Less than 5 years',
        duration_more_5: 'More than 5  years',
        form_birth: 'By born',
        fever: 'Fever',
        cough: 'Cough',
        chest_pain: 'Chest pain',
        breathing_problem: 'Breathing problem',
        consciousness: 'Consciousness',
        symptomData: ['None', 'Mild', 'Moderate', 'Severe', ''],
        hour: 'Hour',
        years: 'Years',
        dashboard: 'Dashboard',
        task_list_urgent: 'Task (Urgent)',
        task_list_pending: 'Task (Pending)',
        patient_list: 'Patient list',
        user_list_admin: 'User List(admin)',
        hotline_users: 'User List(Hotline)',
        consultants: 'Consultants / Doctors',
        field_supervisor: 'Field Supervisor',
        procedures: 'Procedures',
        medicines: 'Medicines',
        location: 'Location',
        patient_report: 'Case Statistics',
        location_report: 'Location Report',
        hotline_report: 'Hotline Statistics',
        reports: 'Reports',
        users: 'Users',
        settings: 'Settings',
        task_list: 'Tasks',
        user_list: 'User List',
        userType: ['admin', 'hotline_users', 'consultants', 'field ambulance', 'field delivery'],
        userOptionsConsultant: ['medicine', 'chest', 'asthama', 'pedoatry'],
        userOptionsAmbulance: ['Ambulance', 'Mobile test-kit', 'Deleivery Medicine'],
        userOptionsDelivery: ['delivery Van', 'Motor cycle', 'Cycle', 'On-foot'],
        userStatus: ['Disabled', 'Active'],
        medicineGroups: ['Digestive system', 'Cardiovascular system', 'Central nervous system', 'For pain', 'Musculo-skeletal disorders', 'Respiratory system', 'allergic disorders', 'immune system'],
        medicineType: ['Tablet', 'Capsule', 'Suspension', 'Injection'],
        medicineWarning: ['Not for Infant', 'Not for Kid', 'Prohibited during Pregnancy', 'Prohibited for Cardiac patient'],
        medicine_list: 'Medicine List',
        medicineGroupName: 'Medicine for',
        medicineTypeName: 'Product Type',
        warning: 'Warning if Any',
        priorityLbl: 'Priority',
        priorityData: ['Normal', 'Moderate', 'Urgent'],
        contactNumber_name: 'Contact Number / Name',
        consultantTasks: ['Request for Video/Voice conference', 'Prescribe Medicine', 'Suggest for medical examination if required', ''],
        ambulanceTasks: ['Hospitalize Patient', 'Isolate patient and house', 'Conduct Covid19 TEST', 'Collect specimen', ''],
        deliveryTasks: ['Supply medicine', 'Supply groceries ', 'Supply emergency Relief goods', 'Supply emergency Relief fund'],
        beforeAftermealData: ['After Meal', 'Before meal'],
        durationData: ['1 day', '2 days', '3 days', '5 days', '1 week', '2 Week', '3 week', '1 Month', '2 Month', '3 month', '1 Year', 'Continue'],
        quantityData: ['½', '1', '1 ½', '2', '2 ½', '3'],
        spoon: 'Spoon',
        duration: 'Duration',
        prescriptionTasks: ['Purchase and start using the medicines ASAP', 'Please update patient\'s condition through app', 'Please take  the medicines in proscribed time interval', 'Please complete the course in prescribed time'],
        tasklist: ['Case forwarded to consultant', 'Case forwarded to ambulance', 'case forwarded to mobile Test Unit', 'Medicine has been prescribed'],
        distributorTypeData: ['Govt', 'Local', 'Company', 'Individual'],
        preconditionStatus: ['Don\'t have', 'Not sure', 'Moderate or controlled', 'Severe/High'],
        riskFactor: ['Normal', 'Moderate', 'High', 'Severe'],
        trendData: ['Unchanged', 'Good', 'Bad'],
        closeContactData: ['Never', 'Not sure', 'May be', 'Yes'],
        locationData: ['Not affected zone', 'Not sure', 'Mild Affected zone', 'Heavily affected area'],
        ageGroupDate: ['Child', 'Middle age', 'Pre Elderly', 'Elderly'],
        taskGroupData: ['', '', '', 'Forwarded to Consultant', 'Forwarded to Ambulance', 'Forwarded to Field', 'Prescribed Medicine'],
        taskStatus: ['Pending', 'Done', 'Cancelled'],
        activeData: ['Inactive', 'Active'],
        rationRequestStatus: ['Pending', 'Processing', 'Delivered', 'Declined'],
        validityDays: [3, 7, 15, 30],
        statusRationData: ['Declined', 'Delivered'],
        casesData: ['Covid Suspect', 'Non Covid case', 'Mental health'],
        ageGroup: ['Unknown', 'Below 10', '10 to 30 years', '31 to 50 years', '50 to 70 years', '70 ++'],
        ageGroupRation: ['Below 18', '18 to 30 years', '31 to 50 years', '50 to 70 years', '70 ++'],
        vehicleStatusData: ['Idle and waiting for new order', 'Transit with full capacity', 'Transit but not full capacity', 'Transit  empty', 'in-service', 'Damaged in transit'],
        capacityData: ['5 ton', '10 ton', '15 ton', '25 ton', '30++ ton'],
        loadingSettingData: ['Carry vegetables', 'Can carry fruits', 'Fish and processed meat', 'Dairy', 'Eggs', 'Live chickens'],
        loadingSetting: 'Load setting',
        capacityLbl: 'Load Capacity',
        packagingTypeLbl: 'Packing type',
        packagingTypeData: ['Cartoon', 'Busket', 'Drum', 'Sacks', 'Others'],
        itemTypeLbl: 'Item type',
        itemTypeData: ['Vegetables', 'Fruits', 'Fish', 'Processed meat', 'Live chciken', 'Live goats', 'Live cows', 'Dairy Milk', 'Eggs'],
        packageQuantity: 'Package quantity',
        approxQuantity: 'Approximate Quanity',
        pickupPointName: 'Pickup point',
        deliveryName: 'Delivery Point name',
        transport_request: 'Transport Request',
        vehicle: 'Listed Vehicles',
        transport: 'Transport Request',
        add_new: 'Add new',
        transportrequest_list: 'List of Transport Request',
        transportvehicle_list: 'Listed Vehicles',
        submit: 'Submit',
        rationdistributor_list: 'Ration Distributor\'s list',
        locationName: 'location Name',
        idNumber: 'ID/IC Number',
        ward_village: 'Ward/Village',
        city_union: 'City/Union',
        district: 'District',
        state: 'State',
        enterBy: 'Added by',
        active: 'Active',
        action: 'Action',
        distributorOrgName: 'Organization Name',
        insertTime: 'Time',
        risk: 'Risk',
        symptom: 'Symptom',
        trend: 'Trend',
        patientName: 'Patient name',
        patientContact: 'Patient Contact',
        taskGroup: 'Task Group',
        taskType: 'Task Type',
        priority: 'Priority',
        comments: 'Comments',
        sync1: 'Sync(C)',
        sync2: 'Sync(P)',
        userTypeLbl: 'User Type',
        optionsLbl: 'Options',
        user_form: 'User Registration form',
        riskFactorLbl: 'Risk Factor'

    },
    'my': {
        welcomeMsg: 'Bienvenido a tu aplicación Vue.js',
        guide: 'Para una guía y recetas sobre cómo configurar / personalizar este proyecto,',
        checkout: 'revisar la',
        plugins: 'Plugins de CLI instalados',
        links: 'Enlaces esenciales',
        ecosystem: 'Ecosistema',
        name: 'Nama',
        age: 'Umur',
        weight: 'Berat badan',
        height: 'ketinggian',
        address: 'Alamat',
        city: 'City',
        zipcode: 'Kod zip',
        contactNumber: 'Telefon',
        status: 'Status',
        registerDate: 'Tarikh pendaftaran',
        lastUpdate: 'kemaskini terakhir',
        weightData: ['Lebih kurus', 'Kurus', 'Rata-rata', 'Lemak', 'Tambahan lemak', 'N/A'],
        heightData: ['Pendek', 'Rata-rata', 'Tinggi', 'Lebih tinggi', 'N/A'],
        condition: 'Keadaan kesihatan',
        sex: ['Lelaki', 'Perempuan'],
        gender: 'Jantina',
        statusData: ['Reported', 'Forwarded to '],
        conditionData: ['Tidak dinilai', 'Stabil'],
        ageFrom: 'Umur min',
        ageTo: 'Umur Max',
        search: 'Carian',
        pre_health_condition: 'Keadaan kesihatan pra',
        diabetics: 'Pesakit kencing manis',
        heart: 'Penyakit jantung',
        lungs: 'Penyakit paru-paru / asma',
        skomking: 'Tabiat merokok',
        not_sure: 'Tidak pasti',
        dont_have: 'Tidak ada',
        have_but_controlled: 'Ringan atau terkawal',
        high_condition: 'Tinggi atau teruk',
        never_smoke: 'Tidak merokok',
        smoker_quit: 'Perokok tetapi diketepikan',
        smoker: 'Masih Merokok',
        duration_na: 'Perhatikan pasti',
        duration_less_5: 'Kurang dari 5 tahun',
        duration_more_5: 'Lebih daripada 5 tahun',
        form_birth: 'Oleh lahir',
        fever: 'Demam',
        cough: 'Batuk',
        chest_pain: 'Sakit dada',
        breathing_problem: 'Masalah pernafasan',
        consciousness: 'Kesedaran',
        symptomData: ['Tiada', 'Ringan', 'Sederhana', 'Teruk', ''],
        hour: 'Jam',
        years: 'tahun',
        dashboard: 'Papan Pemuka',
        task_list_urgent: 'Tugas (Segera)',
        task_list_pending: 'Tugas (belum selesai)',
        patient_list: 'senarai pesakit',
        user_list_admin: 'Senarai Pengguna (admin)',
        hotline_users: 'Senarai Pengguna(HotLine)',
        consultants: 'Perunding / Doktor',
        field_supervisor: 'Penyelia Bidang',
        procedures: 'Prosedur',
        medicines: 'ubat-ubatan',
        location: 'Lokasi',
        patient_report: 'Statistics kes',
        location_report: 'Laporan Lokasi',
        hotline_report: 'Statistik Hotline',
        reports: 'Laporan',
        users: 'Pengguna',
        settings: 'Menetapkan',
        task_list: 'Tugas',
        user_list: 'Pengguna',
        userType: ['admin', 'hotline_users', 'consultants', 'field ambulance', 'field delivery'],
        userOptionsConsultant: ['medicine', 'chest', 'asthama', 'pedoatry'],
        userOptionsAmbulance: ['Ambulance', 'Mobile test-kit', 'Deleivery Medicine'],
        userOptionsDelivery: ['delivery Van', 'Motor cycle', 'Cycle', 'On-foot'],
        userStatus: ['Disabled', 'Aktif'],
        medicineGroups: ['Digestive system', 'Cardiovascular system', 'Central nervous system', 'For pain', 'Musculo-skeletal disorders', 'Respiratory system', 'allergic disorders', 'immune system'],
        medicineType: ['Tablet', 'Capsule', 'Suspension', 'Injection'],
        medicineWarning: ['Not for Infant', 'Not for Kid', 'Prohibited during Pregnancy', 'Prohibited for Cardiac ptient'],
        medicine_list: 'Medicine List',
        medicineGroupName: 'Medicine for',
        medicineTypeName: 'Product Type',
        warning: 'Warning if Any',
        priorityLbl: 'Keutamaan',
        priorityData: ['Biasa', 'Sederhana', 'Mendesak'],
        contactNumber_name: 'Nombor / Nama',
        consultantTasks: ['Conduct Video/Voice conference', 'Prescribe Medicine', 'Suggest for medical examination if required', 'Evaluate case'],
        ambulanceTasks: ['Hospitalize Patient', 'Isolate patient and house', 'Conduct Covid19 TEST', 'Collect specimen', 'Evaluate case'],
        deliveryTasks: ['Supply medicine', 'Supply groceries ', 'Supply emergency Relief goods', 'Supply emergency Relief fund'],
        beforeAftermealData: ['Sebelum makan', 'Selepas makan'],
        durationData: ['1 day', '2 days', '3 days', '5 days', '1 week', '2 Week', '3 week', '1 Month', '2 Month', '3 month', '1 Year', 'Continue'],
        quantityData: ['½', '1', '1 ½', '2', '2 ½', '3'],
        spoon: 'Sudu',
        duration: 'Tempoh',
        prescriptionTasks: ['Purchase and start using the medicines ASAP', 'Please update patient\'s condition through app', 'Please take  the medicines in proscribed time interval', 'Please complete the course in prescribed time'],
        tasklist: ['Kes dikemukakan kepada perunding', 'Kes diteruskan ke ambulans', 'Kes dikemukakan ke Unit Uji bergerak', 'Ubat telah ditentukan'],
        distributorTypeData: ['Govt', 'Local', 'Company', 'Individual']
    }
};

var i18n = new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
    locale: 'en',
    fallbackLocale: 'es',
    messages: messages });

/* harmony default export */ __webpack_exports__["a"] = (i18n);

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setTitleAndDescription */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return calRiskFactor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return calSymptom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return showTrend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return showAgeGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return listError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

var setTitleAndDescription = function setTitleAndDescription(title, description) {
    window.document.title = title;
    window.document.head.querySelector('meta[name=description]').content = description;
};

var calRiskFactor = function calRiskFactor(value) {
    value = parseInt(value);
    if (value > 0 && value < 4) {
        return 0;
    } else if (value >= 4 && value < 8) {
        return 1;
    } else if (value >= 8 && value < 10) {
        return 2;
    } else if (value >= 10) {
        return 3;
    } else {
        return 0;
    }
};
var calSymptom = function calSymptom(value) {
    value = parseInt(value);
    if (value > 0 && value < 4) {
        return 0;
    } else if (value >= 4 && value < 8) {
        return 1;
    } else if (value >= 8 && value < 10) {
        return 2;
    } else if (value >= 10) {
        return 3;
    } else {
        return 0;
    }
};
var showTrend = function showTrend(value) {
    if (value < 0) {
        return '<i class=\'fa fa-arrow-circle-down text-success\'>' + value + '</i>';
    } else if (value > 0) {
        return '<i class=\'fa fa-arrow-circle-up text-danger\'>' + value + '</i>';
    } else if (value === 0) {
        return '<i class=\'fa fa-arrows-v text-info\'>' + value + '</i>';
    }
};
var showAgeGroup = function showAgeGroup(value) {
    var age = new Date().getFullYear() - value;
    if (age > 0 && age < 25) {
        return 0;
    } else if (age >= 25 && age < 45) {
        return 1;
    } else if (age >= 45 && age < 55) {
        return 2;
    } else if (age >= 55) {
        return 3;
    } else {
        return 0;
    }
};
var listError = function listError(value) {
    var data = [];
    var type = typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value);
    if (type === 'object') {
        for (var k in value) {
            if (value.hasOwnProperty(k)) {
                data.push(value[k]);
            }
        }
    } else if (type === "string") {
        data.push(value);
    }
    return data;
};
var getIcon = function getIcon(status) {
    if (status === 8) {
        return "http://maps.google.com/mapfiles/ms/icons/red-dot.png";
    } else if (status === 7) {
        return "http://maps.google.com/mapfiles/ms/icons/green-dot.png";
    } else {
        return "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png";
    }
};

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);


var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue___default.a();

/* harmony default export */ __webpack_exports__["a"] = (EventBus);

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_PRODUCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_TASK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOGOUT; });
/* unused harmony export RESET_PASS */
/* unused harmony export CHANGE_PASS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOGIN_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GET_LAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_LAN; });
var FETCH_PRODUCT = 'FETCH_PRODUCT';
var FETCH_TASK = 'FETCH_TASK';
var LOGIN = 'LOGIN';
var ERROR = 'ERROR';
var LOGOUT = 'LOGOUT';
var RESET_PASS = 'RESET_PASS';
var CHANGE_PASS = 'CHANGE_PASS';
var LOGIN_STATUS = 'LOGIN_STATUS';
var GET_LAN = 'GET_LAN';
var SET_LAN = 'SET_LAN';

/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */
/***/ (function(module, exports) {

module.exports = {"_from":"twilio-video","_id":"twilio-video@2.3.0","_inBundle":false,"_integrity":"sha512-03tOkLWamHMLV8Z6imcPG9A1RFOYuSNEn5pbUEa/RhJWgPhmeffwPqOL8tw96md8Byum3vLUFUo5kvEt4NhK1w==","_location":"/twilio-video","_phantomChildren":{"async-limiter":"1.0.1"},"_requested":{"type":"tag","registry":true,"raw":"twilio-video","name":"twilio-video","escapedName":"twilio-video","rawSpec":"","saveSpec":null,"fetchSpec":"latest"},"_requiredBy":["#USER","/"],"_resolved":"https://registry.npmjs.org/twilio-video/-/twilio-video-2.3.0.tgz","_shasum":"a96574bece5b1d2897a0b76924dbb29fc8c05938","_spec":"twilio-video","_where":"/Volumes/Dev/web/vue2-admin-lte-master","author":{"name":"Mark Andrus Roberts","email":"mroberts@twilio.com"},"browser":{"ws":"./src/ws.js","xmlhttprequest":"./src/xmlhttprequest.js"},"bugs":{"url":"https://github.com/twilio/twilio-video.js/issues"},"bundleDependencies":false,"contributors":[{"name":"Ryan Rowland","email":"rrowland@twilio.com"},{"name":"Manjesh Malavalli","email":"mmalavalli@twilio.com"},{"name":"Makarand Patwardhan","email":"mpatwardhan@twilio.com"}],"dependencies":{"@twilio/webrtc":"4.2.0","backoff":"^2.5.0","ws":"^3.3.1","xmlhttprequest":"^1.8.0"},"deprecated":false,"description":"Twilio Video JavaScript library","devDependencies":{"@types/express":"^4.11.0","@types/node":"^8.5.1","@types/selenium-webdriver":"^3.0.8","@types/ws":"^3.2.1","babel-cli":"^6.26.0","babel-preset-es2015":"^6.24.1","browserify":"^14.3.0","cheerio":"^0.22.0","chromedriver":"2.28.0","cors":"^2.8.5","electron":"^5.0.1","envify":"^4.0.0","eslint":"^6.2.1","eslint-config-standard":"^14.0.0","eslint-plugin-import":"^2.18.2","eslint-plugin-node":"^9.1.0","eslint-plugin-promise":"^4.2.1","eslint-plugin-standard":"^4.0.1","express":"^4.16.2","geckodriver":"1.4.0","ink-docstrap":"^1.3.2","inquirer":"^7.0.0","is-docker":"^2.0.0","istanbul":"^0.4.5","jsdoc":"^3.5.5","json-loader":"^0.5.7","karma":"^1.6.0","karma-browserify":"^5.1.1","karma-chrome-launcher":"^2.0.0","karma-edgium-launcher":"^4.0.0-0","karma-electron":"^6.1.0","karma-firefox-launcher":"^1.0.1","karma-htmlfile-reporter":"^0.3.8","karma-junit-reporter":"^1.2.0","karma-mocha":"^1.3.0","karma-safari-launcher":"^1.0.0","karma-spec-reporter":"0.0.32","mocha":"^3.2.0","npm-run-all":"^4.0.2","puppeteer":"^1.11.0","release-tool":"^0.2.2","requirejs":"^2.3.3","rimraf":"^2.6.1","selenium-webdriver":"3.3.0","simple-git":"^1.126.0","sinon":"^4.0.1","travis-multirunner":"^4.0.0","ts-node":"4.0.1","tslint":"5.8.0","twilio":"^2.11.1","typescript":"2.6.2","uglify-js":"^2.8.22","vinyl-fs":"^2.4.4","vinyl-source-stream":"^1.1.0","watchify":"^3.11.1","webrtc-adapter":"^4.1.1"},"engines":{"node":">=0.12"},"homepage":"https://twilio.com","keywords":["twilio","webrtc","library","javascript","video","rooms"],"license":"BSD-3-Clause","main":"./es5/index.js","name":"twilio-video","repository":{"type":"git","url":"git+https://github.com/twilio/twilio-video.js.git"},"scripts":{"build":"npm-run-all clean lint docs cover test:integration build:es5 build:js build:min.js test:umd","build:docker":"npm-run-all clean lint docs cover test:integration:travis build:es5 build:js build:min.js","build:es5":"rimraf ./es5 && babel lib -d es5","build:js":"node ./scripts/build.js ./src/twilio-video.js ./LICENSE.md ./dist/twilio-video.js","build:min.js":"uglifyjs ./dist/twilio-video.js -o ./dist/twilio-video.min.js --comments \"/^! twilio-video.js/\" -b beautify=false,ascii_only=true","build:quick":"npm-run-all clean lint docs build:es5 build:js build:min.js","build:travis":"npm-run-all clean lint docs cover build:es5 build:js build:min.js test:umd test:framework","clean":"rimraf ./coverage ./es5 ./dist","cover":"istanbul cover node_modules/mocha/bin/_mocha -- ./test/unit/index.js","docs":"node ./scripts/docs.js ./dist/docs","lint":"eslint ./lib ./test/*.js ./docker/**/*.js ./test/framework/*.js ./test/lib/*.js ./test/integration/** ./test/unit/**","test":"npm-run-all test:unit test:integration","test:crossbrowser":"npm-run-all test:crossbrowser:*","test:crossbrowser:build":"npm-run-all test:crossbrowser:build:*","test:crossbrowser:build:browser":"cd ./test/crossbrowser && browserify lib/crossbrowser/src/browser/index.js > src/browser/index.js","test:crossbrowser:build:clean":"rimraf ./test/crossbrowser/lib ./test/crossbrowser/src/browser/index.js","test:crossbrowser:build:lint":"cd ./test/crossbrowser && tslint --project tsconfig.json","test:crossbrowser:build:tsc":"cd ./test/crossbrowser && tsc","test:crossbrowser:test":"cd ./test/crossbrowser && mocha --compilers ts:ts-node/register test/integration/spec/**/*.ts","test:framework":"npm-run-all test:framework:angular test:framework:no-framework test:framework:react","test:framework:angular":"npm-run-all test:framework:angular:*","test:framework:angular:install":"cd ./test/framework/twilio-video-angular && rimraf ./node_modules package-lock.json && npm install","test:framework:angular:run":"mocha ./test/framework/twilio-video-angular.js","test:framework:no-framework":"npm-run-all test:framework:no-framework:*","test:framework:no-framework:run":"mocha ./test/framework/twilio-video-no-framework.js","test:framework:react":"npm-run-all test:framework:react:*","test:framework:react:build":"cd ./test/framework/twilio-video-react && npm run build","test:framework:react:install":"cd ./test/framework/twilio-video-react && rimraf ./node_modules package-lock.json && npm install","test:framework:react:run":"mocha ./test/framework/twilio-video-react.js","test:framework:react:test":"node ./scripts/framework.js twilio-video-react","test:integration":"node ./scripts/karma.js karma/integration.conf.js","test:integration:adapter":"node ./scripts/karma.js karma/integration.adapter.conf.js","test:integration:travis":"node ./scripts/integration.js","test:sdkdriver":"npm-run-all test:sdkdriver:*","test:sdkdriver:build":"npm-run-all test:sdkdriver:build:*","test:sdkdriver:build:clean":"rimraf ./test/lib/sdkdriver/lib ./test/lib/sdkdriver/test/integration/browser/index.js","test:sdkdriver:build:lint":"cd ./test/lib/sdkdriver && tslint --project tsconfig.json","test:sdkdriver:build:tsc":"cd ./test/lib/sdkdriver && tsc --rootDir src","test:sdkdriver:test":"npm-run-all test:sdkdriver:test:*","test:sdkdriver:test:integration":"npm-run-all test:sdkdriver:test:integration:*","test:sdkdriver:test:integration:browser":"cd ./test/lib/sdkdriver/test/integration && browserify browser/browser.js > browser/index.js","test:sdkdriver:test:integration:run":"cd ./test/lib/sdkdriver && mocha --compilers ts:ts-node/register test/integration/spec/**/*.ts","test:sdkdriver:test:unit":"cd ./test/lib/sdkdriver && mocha --compilers ts:ts-node/register test/unit/spec/**/*.ts","test:umd":"mocha ./test/umd/index.js","test:unit":"mocha ./test/unit/index.js"},"title":"Twilio Video","version":"2.3.0"}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(518)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(371),
  /* template */
  __webpack_require__(728),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return router; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pages_PatientList__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pages_PatientList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pages_PatientList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_PatientDetails__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_PatientDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pages_PatientDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_Task__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_Task___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pages_Task__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_Users__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_Users___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pages_Users__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_Procedure__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_Procedure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pages_Procedure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_Medicines__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_Medicines___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pages_Medicines__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_Location__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_Location___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_pages_Location__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_AddLocation__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_AddLocation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_pages_AddLocation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pages_Report_Patient__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pages_Report_Patient___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_pages_Report_Patient__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pages_Report_Location__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pages_Report_Location___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_pages_Report_Location__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_pages_Report_Hotline__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_pages_Report_Hotline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_pages_Report_Hotline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_pages_RationLog__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_pages_RationLog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_pages_RationLog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_pages_RequestForRation__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_pages_RequestForRation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_pages_RequestForRation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_pages_TransportRequest__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_pages_TransportRequest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_pages_TransportRequest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_pages_TransportVehicle__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_pages_TransportVehicle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_pages_TransportVehicle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_pages_RationDistributor__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_pages_RationDistributor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_pages_RationDistributor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_pages_Login__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_pages_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_pages_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_pages_Logout__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_pages_Logout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_pages_Logout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_pages_Profile__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_pages_Profile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_pages_Profile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_pages_Dashboard__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_pages_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_pages_Dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_pages_forms_GeneralElements_vue__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_pages_forms_GeneralElements_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_pages_forms_GeneralElements_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_pages_forms_AdvancedElements_vue__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_pages_forms_AdvancedElements_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_pages_forms_AdvancedElements_vue__);

































__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
var routes = [];

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  deep: true,
  immediate: true,
  routes: [{
    path: '/patients',
    name: 'patient_list',
    component: __WEBPACK_IMPORTED_MODULE_2_pages_PatientList___default.a
  }, {
    path: '/patient-details',
    name: 'PatientsDetails',
    component: __WEBPACK_IMPORTED_MODULE_3_pages_PatientDetails___default.a
  }, {
    path: '/tasks',
    name: 'task_list',
    component: __WEBPACK_IMPORTED_MODULE_4_pages_Task___default.a
  }, {
    path: '/users',
    name: 'user_list',
    component: __WEBPACK_IMPORTED_MODULE_5_pages_Users___default.a
  }, {
    path: '/procedures',
    name: 'procedures',
    component: __WEBPACK_IMPORTED_MODULE_6_pages_Procedure___default.a
  }, {
    path: '/medicines',
    name: 'medicines',
    component: __WEBPACK_IMPORTED_MODULE_7_pages_Medicines___default.a
  }, {
    path: '/location',
    name: 'location',
    component: __WEBPACK_IMPORTED_MODULE_8_pages_Location___default.a
  }, {
    path: '/patient-report',
    name: 'PatientReport',
    component: __WEBPACK_IMPORTED_MODULE_10_pages_Report_Patient___default.a
  }, {
    path: '/location-report',
    name: 'LocationReport',
    component: __WEBPACK_IMPORTED_MODULE_11_pages_Report_Location___default.a
  }, {
    path: '/hotline-report',
    name: 'HotlineReport',
    component: __WEBPACK_IMPORTED_MODULE_12_pages_Report_Hotline___default.a
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_18_pages_Login___default.a
  }, {
    path: '/logout',
    name: 'Logout',
    component: __WEBPACK_IMPORTED_MODULE_19_pages_Logout___default.a
  }, {
    path: '/request',
    name: 'RequestForRation',
    component: __WEBPACK_IMPORTED_MODULE_14_pages_RequestForRation___default.a
  }, {
    path: '/ration',
    name: 'RationLog',
    component: __WEBPACK_IMPORTED_MODULE_13_pages_RationLog___default.a
  }, {
    path: '/transport',
    name: 'TransportRequest',
    component: __WEBPACK_IMPORTED_MODULE_15_pages_TransportRequest___default.a
  }, {
    path: '/distributor',
    name: 'Distributor',
    component: __WEBPACK_IMPORTED_MODULE_17_pages_RationDistributor___default.a
  }, {
    path: '/vehicle',
    name: 'TransportVehicle',
    component: __WEBPACK_IMPORTED_MODULE_16_pages_TransportVehicle___default.a
  }, {
    path: '/addlocation',
    name: 'AddLocation',
    component: __WEBPACK_IMPORTED_MODULE_9_pages_AddLocation___default.a
  }, {
    path: '/profile',
    name: 'Profile',
    component: __WEBPACK_IMPORTED_MODULE_20_pages_Profile___default.a
  }, {
    path: '/dashboard',
    name: 'dashboard',
    component: __WEBPACK_IMPORTED_MODULE_21_pages_Dashboard___default.a
  }],
  linkActiveClass: 'active',
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.name = to.params.name;
    next();
  }
});
router.beforeEach(function (to, from, next) {
  var publicPages = ['/login', '/forget'];
  var authRequired = !publicPages.includes(to.path);
  var loggedIn = localStorage.getItem('users') != null ? localStorage.getItem('users') : '{"authorized": false}';
  var json = JSON.parse(loggedIn);
  var lggged = json.authorized ? json.authorized : false;
  if (authRequired && !lggged) {
    return next('/login');
  }
  next();
});

/***/ }),
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var files = __webpack_require__(769);
var modules = {};

files.keys().forEach(function (key) {
  if (key === './index.js') return;
  modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default;
});

/* harmony default export */ __webpack_exports__["default"] = (modules);

/***/ }),
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(374),
  /* template */
  __webpack_require__(735),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(515)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(382),
  /* template */
  __webpack_require__(725),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(510)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(413),
  /* template */
  __webpack_require__(718),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(414),
  /* template */
  __webpack_require__(705),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(417),
  /* template */
  __webpack_require__(731),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(529)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(418),
  /* template */
  __webpack_require__(742),
  /* scopeId */
  "data-v-bf5d34d4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(419),
  /* template */
  __webpack_require__(752),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_admin_lte_dist_css_AdminLTE_min_css__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_admin_lte_dist_css_AdminLTE_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_admin_lte_dist_css_AdminLTE_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_admin_lte_dist_css_skins_all_skins_min_css__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_admin_lte_dist_css_skins_all_skins_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_admin_lte_dist_css_skins_all_skins_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_font_awesome_css_font_awesome_min_css__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_font_awesome_css_font_awesome_min_css__);





/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__grid_Row__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__grid_Row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__grid_Row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__grid_Column__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__grid_Column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__grid_Column__);



__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('row', __WEBPACK_IMPORTED_MODULE_1__grid_Row___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('column', __WEBPACK_IMPORTED_MODULE_2__grid_Column___default.a);

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_expose_loader_expose_loader_jQuery_jquery__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_expose_loader_expose_loader_jQuery_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_expose_loader_expose_loader_jQuery_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery_slimscroll__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery_slimscroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery_slimscroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery_ui_ui_widgets_sortable_js__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery_ui_ui_widgets_sortable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery_ui_ui_widgets_sortable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery_ui_ui_widgets_datepicker_js__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery_ui_ui_widgets_datepicker_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery_ui_ui_widgets_datepicker_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery_ui_themes_base_datepicker_css__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery_ui_themes_base_datepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery_ui_themes_base_datepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_admin_lte__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_admin_lte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_admin_lte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_chart_js__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_chart_js__);











/***/ }),
/* 300 */,
/* 301 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(496)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(365),
  /* template */
  __webpack_require__(694),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */
/***/ (function(module, exports) {

module.exports = {"_from":"@twilio/webrtc@4.2.0","_id":"@twilio/webrtc@4.2.0","_inBundle":false,"_integrity":"sha512-MmxRVuQtKSKqSsspe9cGuhIH+p7EuEhainHXvdys8QdFbBpnRkGuQKNwwiNzwf+9DcTvlw1B32q3TDgyfqopKw==","_location":"/@twilio/webrtc","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"@twilio/webrtc@4.2.0","name":"@twilio/webrtc","escapedName":"@twilio%2fwebrtc","scope":"@twilio","rawSpec":"4.2.0","saveSpec":null,"fetchSpec":"4.2.0"},"_requiredBy":["/twilio-video"],"_resolved":"https://registry.npmjs.org/@twilio/webrtc/-/webrtc-4.2.0.tgz","_shasum":"f4978ca807116536b5ffcb5e56b5ff076cb5eebb","_spec":"@twilio/webrtc@4.2.0","_where":"/Volumes/Dev/web/vue2-admin-lte-master/node_modules/twilio-video","author":{"name":"Manjesh Malavalli","email":"mmalavalli@twilio.com"},"bugs":{"url":"https://github.com/twilio/twilio-webrtc.js/issues"},"bundleDependencies":false,"contributors":[{"name":"Mark Roberts","email":"mroberts@twilio.com"},{"name":"Ryan Rowland","email":"rrowland@twilio.com"}],"deprecated":false,"description":"WebRTC-related APIs and shims used by twilio-video.js","devDependencies":{"browserify":"^14.4.0","electron":"^5.0.0","envify":"^4.1.0","eslint":"^4.4.1","istanbul":"^0.4.5","karma":"^1.7.0","karma-browserify":"^5.1.1","karma-chrome-launcher":"^2.2.0","karma-electron":"^6.1.0","karma-firefox-launcher":"^1.0.1","karma-mocha":"^1.3.0","karma-safari-launcher":"~0.1","karma-spec-reporter":"0.0.31","mocha":"^3.5.0","npm-run-all":"^4.0.2","release-tool":"^0.2.2","rimraf":"^2.6.1","travis-multirunner":"^4.2.3","watchify":"^3.9.0","webrtc-adapter":"^6.4.8"},"homepage":"https://github.com/twilio/twilio-webrtc.js#readme","keywords":["shim","twilio","video","webrtc"],"license":"BSD-3-Clause","main":"./lib/index.js","name":"@twilio/webrtc","repository":{"type":"git","url":"git+https://github.com/twilio/twilio-webrtc.js.git"},"scripts":{"build":"npm-run-all clean lint test","clean":"rimraf coverage","lint":"eslint ./lib","test":"npm-run-all test:*","test:integration":"npm-run-all test:integration:*","test:integration:adapter":"karma start karma/integration.adapter.conf.js","test:integration:native":"karma start karma/integration.conf.js","test:unit":"istanbul cover node_modules/mocha/bin/_mocha -- ./test/unit/index.js"},"version":"4.2.0"}

/***/ }),
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */
/***/ (function(module, exports) {

module.exports = [{
  type: 'item',
  isHeader: true,
  name: 'MAIN NAVIGATION'
}, {
  type: 'tree',
  icon: 'fa fa-dashboard',
  name: 'dashboard',
  permission: [0, 1, 2, 3],
  items: [{
    type: 'item',
    icon: 'fa fa-user-circle',
    name: 'patient_list',
    permission: [0, 1, 2, 3],
    router: {
      name: 'patient_list'
    }
  }, {
    type: 'item',
    icon: 'fa fa-tasks',
    name: 'task_list',
    permission: [0, 1, 2, 3],
    router: {
      name: 'task_list'
    }
  }, {
    type: 'item',
    icon: 'fa fa-users',
    name: 'user_list',
    permission: [0, 1, 2],
    router: {
      name: 'user_list'
    }
  }]
}, {
  type: 'tree',
  icon: 'fa fa-gift',
  name: 'ration',
  permission: [0, 1, 2],
  items: [{
    type: 'item',
    icon: 'fa fa-user-circle-o',
    name: 'distributor',
    permission: [0, 1, 2],
    router: {
      name: 'Distributor'
    }
  }, {
    type: 'item',
    icon: 'fa fa-life-ring',
    name: 'request',
    permission: [0, 1, 2],
    router: {
      name: 'RequestForRation'
    }
  }, {
    type: 'item',
    icon: 'fa fa-address-card',
    name: 'ration',
    permission: [0, 1, 2],
    router: {
      name: 'RationLog'
    }
  }]
}, {
  type: 'tree',
  icon: 'fa fa-truck',
  name: 'transport_request',
  permission: [0, 1, 2],
  items: [{
    type: 'item',
    icon: 'fa fa-truck',
    name: 'vehicle',
    permission: [0, 1, 2],
    router: {
      name: 'TransportVehicle'
    }
  }, {
    type: 'item',
    icon: 'fa fa-list',
    name: 'transport',
    permission: [0, 1, 2],
    router: {
      name: 'TransportRequest'
    }
  }]
}, {
  type: 'tree',
  icon: 'fa fa-bar-chart',
  name: 'reports',
  permission: [0, 1, 2],
  items: [{
    type: 'item',
    icon: 'fa fa-area-chart',
    name: 'patient_report',
    permission: [0, 1, 2],
    router: {
      name: 'PatientReport'
    }
  }, {
    type: 'item',
    icon: 'fa fa-bar-chart',
    name: 'location_report',
    permission: [0, 1, 2],
    router: {
      name: 'LocationReport'
    }
  }, {
    type: 'item',
    icon: 'fa fa-line-chart',
    name: 'hotline_report',
    permission: [0, 1, 2],
    router: {
      name: 'HotlineReport'
    }
  }]
}, {
  type: 'tree',
  icon: 'fa fa-laptop',
  name: 'settings',
  permission: [0, 1, 2],
  items: [{
    type: 'item',
    icon: 'fa fa-stethoscope',
    name: 'medicines',
    permission: [0, 1, 2],
    router: {
      name: 'medicines'
    }
  }, {
    type: 'item',
    icon: 'fa fa-map-marker',
    name: 'location',
    permission: [0, 1, 2],
    router: {
      name: 'location'
    }
  }, {
    type: 'item',
    icon: 'fa fa-plus-circle',
    name: 'addlocation',
    permission: [0, 1, 2],
    router: {
      name: 'AddLocation'
    }
  }]
}];

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_css__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_script__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_global__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_eventBus_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__plugins_i18n__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_flag_icon__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__fortawesome_fontawesome_svg_core__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__fortawesome_free_solid_svg_icons__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__fortawesome_vue_fontawesome__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue2_google_maps__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue2_google_maps__);

















__WEBPACK_IMPORTED_MODULE_3_vue___default.a.prototype.moment = __WEBPACK_IMPORTED_MODULE_8_moment___default.a;
__WEBPACK_IMPORTED_MODULE_3_vue___default.a.prototype.$bus = __WEBPACK_IMPORTED_MODULE_6__lib_eventBus_js__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_3_vue___default.a.prototype.$http = __WEBPACK_IMPORTED_MODULE_7_axios___default.a;
__WEBPACK_IMPORTED_MODULE_11__fortawesome_fontawesome_svg_core__["a" /* library */].add([__WEBPACK_IMPORTED_MODULE_12__fortawesome_free_solid_svg_icons__["a" /* faHeartbeat */], __WEBPACK_IMPORTED_MODULE_12__fortawesome_free_solid_svg_icons__["b" /* faLungs */], __WEBPACK_IMPORTED_MODULE_12__fortawesome_free_solid_svg_icons__["c" /* faTint */], __WEBPACK_IMPORTED_MODULE_12__fortawesome_free_solid_svg_icons__["d" /* faSmoking */], __WEBPACK_IMPORTED_MODULE_12__fortawesome_free_solid_svg_icons__["e" /* faProcedures */], __WEBPACK_IMPORTED_MODULE_12__fortawesome_free_solid_svg_icons__["f" /* faUserMd */], __WEBPACK_IMPORTED_MODULE_12__fortawesome_free_solid_svg_icons__["g" /* faHeadset */], __WEBPACK_IMPORTED_MODULE_12__fortawesome_free_solid_svg_icons__["h" /* faClipboardList */], __WEBPACK_IMPORTED_MODULE_12__fortawesome_free_solid_svg_icons__["i" /* faAmbulance */], __WEBPACK_IMPORTED_MODULE_12__fortawesome_free_solid_svg_icons__["j" /* faTachometerAlt */], __WEBPACK_IMPORTED_MODULE_12__fortawesome_free_solid_svg_icons__["k" /* faWeight */], __WEBPACK_IMPORTED_MODULE_12__fortawesome_free_solid_svg_icons__["l" /* faFileMedical */], __WEBPACK_IMPORTED_MODULE_12__fortawesome_free_solid_svg_icons__["m" /* faHandshake */], __WEBPACK_IMPORTED_MODULE_12__fortawesome_free_solid_svg_icons__["n" /* faMap */], __WEBPACK_IMPORTED_MODULE_12__fortawesome_free_solid_svg_icons__["o" /* faHeadSideCough */], __WEBPACK_IMPORTED_MODULE_12__fortawesome_free_solid_svg_icons__["p" /* faChild */]]);

__WEBPACK_IMPORTED_MODULE_3_vue___default.a.component('font-awesome-icon', __WEBPACK_IMPORTED_MODULE_13__fortawesome_vue_fontawesome__["a" /* FontAwesomeIcon */]);
__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_vue_flag_icon__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14_vue2_google_maps__, {
  load: {
    key: 'AIzaSyD10FFzuYM4qyfnMims3xKu-gUSoZja_eI',
    libraries: 'places' }
});

new __WEBPACK_IMPORTED_MODULE_3_vue___default.a({
  el: '#app',
  i18n: __WEBPACK_IMPORTED_MODULE_9__plugins_i18n__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* router */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_4__App___default.a
  }
});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchProduct", function() { return fetchProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchTask", function() { return fetchTask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "processLogin", function() { return processLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "processLogout", function() { return processLogout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLoginStatus", function() { return getLoginStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLanguage", function() { return getLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLanguage", function() { return setLanguage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(90);



var fetchProduct = function fetchProduct(_ref) {
  var commit = _ref.commit;

  return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* services */].products.getAll().then(function (response) {
    console.log(response);
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["f" /* FETCH_PRODUCT */], response.data);
  }).catch(function (error) {
    console.error(error);
  });
};

var fetchTask = function fetchTask(_ref2) {
  var commit = _ref2.commit;

  return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* services */].tasks.getAll().then(function (response) {
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["e" /* FETCH_TASK */], response.data);
  }).catch(function (error) {
    console.error(error);
  });
};

var processLogin = function processLogin(_ref3, _ref4) {
  var commit = _ref3.commit;
  var username = _ref4.username,
      password = _ref4.password;

  return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* services */].user.login({ contactNumber: username, password: password }).then(function (response) {
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* LOGIN */], response.data);
    __WEBPACK_IMPORTED_MODULE_2__router__["a" /* router */].push('/');
  }).catch(function (error) {
    console.log(error);
    console.log('CHECK->AFNAN');

    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* ERROR */], error.response.data.errors);
  });
};

var processLogout = function processLogout(_ref5) {
  var commit = _ref5.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* LOGOUT */]);
  __WEBPACK_IMPORTED_MODULE_2__router__["a" /* router */].push('/login');
};

var getLoginStatus = function getLoginStatus(_ref6) {
  var commit = _ref6.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* LOGIN_STATUS */]);
};

var getLanguage = function getLanguage(_ref7) {
  var commit = _ref7.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["g" /* GET_LAN */]);
};
var setLanguage = function setLanguage(_ref8, language) {
  var commit = _ref8.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["h" /* SET_LAN */], language);
};

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  getInstruction: function getInstruction() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;

    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/instruction', {
      dataType: 'json',
      params: request,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  getInstructionDetails: function getInstructionDetails() {
    var Id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;

    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/instruction/' + Id, {
      dataType: 'json',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  addInstruction: function addInstruction() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    var headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    };
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/instruction', request, { "headers": headers }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  updateInstruction: function updateInstruction() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    var id = request._id;
    delete request._id;
    var headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    };
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/instruction/' + id, request, { "headers": headers }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }
});

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  getLocation: function getLocation() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;

    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/location', {
      dataType: 'json',
      params: request,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  getLocationDetails: function getLocationDetails() {
    var Id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;

    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/location/' + Id, {
      dataType: 'json',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  addLocation: function addLocation() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    var headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    };
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/location', request, { "headers": headers }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  updateLocation: function updateLocation() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    var id = request._id;
    delete request._id;
    var headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    };
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/location/' + id, request, { "headers": headers }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  getProcedure: function getProcedure() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;

    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/procedure', {
      dataType: 'json',
      params: request,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  getProcedureDetails: function getProcedureDetails() {
    var Id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;

    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/procedure/' + Id, {
      dataType: 'json',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  addProcedure: function addProcedure() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    var headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    };
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/procedure', request, { "headers": headers }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  updateProcedure: function updateProcedure() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    var id = request._id;
    delete request._id;
    var headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    };
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/procedure/' + id, request, { "headers": headers }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }
});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  getRationDistributor: function getRationDistributor() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;

    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/rationdistributor', {
      dataType: 'json',
      params: request,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  getRationDistributorDetails: function getRationDistributorDetails() {
    var Id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;

    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/rationdistributor/' + Id, {
      dataType: 'json',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  addRationDistributor: function addRationDistributor() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    var headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    };
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/rationdistributor', request, { "headers": headers }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  updateRationDistributor: function updateRationDistributor() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    var id = request._id;
    delete request._id;
    var headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    };
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/rationdistributor/' + id, request, { "headers": headers }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }
});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  getRationLog: function getRationLog() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;

    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/rationlog', {
      dataType: 'json',
      params: request,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  getRationLogDetails: function getRationLogDetails() {
    var Id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;

    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/rationlog/' + Id, {
      dataType: 'json',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  addRationLog: function addRationLog() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    var headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    };
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/rationlog', request, { "headers": headers }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  updateRationLog: function updateRationLog() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    var id = request._id;
    delete request._id;
    var headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    };
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/rationlog/' + id, request, { "headers": headers }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }
});

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  getRequestForRation: function getRequestForRation() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;

    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/requestforration', {
      dataType: 'json',
      params: request,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  getRequestForRationDetails: function getRequestForRationDetails() {
    var Id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;

    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/requestforration/' + Id, {
      dataType: 'json',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  addRequestForRation: function addRequestForRation() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    var headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    };
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/requestforration', request, { "headers": headers }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  updateRequestForRation: function updateRequestForRation() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    var id = request._id;
    delete request._id;
    var headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    };
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/requestforration/' + id, request, { "headers": headers }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  getReport: function getReport() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/requestreport', {
      dataType: 'json',
      params: request,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  getLocationReport: function getLocationReport() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/requestloc', {
      dataType: 'json',
      params: request,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  getCaseReport: function getCaseReport() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/requestcase', {
      dataType: 'json',
      params: request,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  getStatusReport: function getStatusReport() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/requeststatus', {
      dataType: 'json',
      params: request,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  getAreaReport: function getAreaReport() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/requestarea', {
      dataType: 'json',
      params: request,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  getTask: function getTask() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;

    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/task', {
      dataType: 'json',
      params: request,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  getTaskDetails: function getTaskDetails() {
    var Id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;

    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/task/' + Id, {
      dataType: 'json',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  addTask: function addTask() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    var headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    };
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/task', request, { "headers": headers }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  updateTask: function updateTask() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    var id = request._id;
    delete request._id;
    var headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    };
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/task/' + id, request, { "headers": headers }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }
});

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  getTaskLog: function getTaskLog() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;

    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/tasklog', {
      dataType: 'json',
      params: request,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  getTaskLogDetails: function getTaskLogDetails() {
    var Id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;

    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/tasklog/' + Id, {
      dataType: 'json',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  addTaskLog: function addTaskLog() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    var headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    };
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/tasklog', request, { "headers": headers }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  updateTaskLog: function updateTaskLog() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    var id = request._id;
    delete request._id;
    var headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    };
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/tasklog/' + id, request, { "headers": headers }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }
});

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  getTransportRequest: function getTransportRequest() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;

    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/transportrequest', {
      dataType: 'json',
      params: request,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  getTransportRequestDetails: function getTransportRequestDetails() {
    var Id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;

    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/transportrequest/' + Id, {
      dataType: 'json',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  addTransportRequest: function addTransportRequest() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    var headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    };
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/transportrequest', request, { "headers": headers }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  updateTransportRequest: function updateTransportRequest() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    var id = request._id;
    delete request._id;
    var headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    };
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/transportrequest/' + id, request, { "headers": headers }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }
});

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  getTransportVehicle: function getTransportVehicle() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;

    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/transportvehicle', {
      dataType: 'json',
      params: request,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  getTransportVehicleDetails: function getTransportVehicleDetails() {
    var Id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;

    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/transportvehicle/' + Id, {
      dataType: 'json',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  addTransportVehicle: function addTransportVehicle() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    var headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    };
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/transportvehicle', request, { "headers": headers }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  updateTransportVehicle: function updateTransportVehicle() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    var id = request._id;
    delete request._id;
    var headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    };
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/transportvehicle/' + id, request, { "headers": headers }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }
});

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__products__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tasks__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__patients__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__medicines__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Location__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Task__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TaskLog__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Procedure__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Instruction__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__RequestForRation__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__RationLog__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TransportRequest__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__RationDistributor__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__TransportVehicle__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__twillo__ = __webpack_require__(350);
















/* harmony default export */ __webpack_exports__["a"] = ({
  patients: __WEBPACK_IMPORTED_MODULE_3__patients__["a" /* default */],
  products: __WEBPACK_IMPORTED_MODULE_0__products__["a" /* default */],
  tasks: __WEBPACK_IMPORTED_MODULE_1__tasks__["a" /* default */],
  user: __WEBPACK_IMPORTED_MODULE_2__user__["a" /* default */],
  twilloToken: __WEBPACK_IMPORTED_MODULE_15__twillo__["a" /* default */],
  medicines: __WEBPACK_IMPORTED_MODULE_4__medicines__["a" /* default */],
  Instruction: __WEBPACK_IMPORTED_MODULE_9__Instruction__["a" /* default */],
  Procedure: __WEBPACK_IMPORTED_MODULE_8__Procedure__["a" /* default */],
  Task: __WEBPACK_IMPORTED_MODULE_6__Task__["a" /* default */],
  TaskLog: __WEBPACK_IMPORTED_MODULE_7__TaskLog__["a" /* default */],
  Location: __WEBPACK_IMPORTED_MODULE_5__Location__["a" /* default */],
  RequestForRation: __WEBPACK_IMPORTED_MODULE_10__RequestForRation__["a" /* default */],
  RationLog: __WEBPACK_IMPORTED_MODULE_11__RationLog__["a" /* default */],
  TransportRequest: __WEBPACK_IMPORTED_MODULE_12__TransportRequest__["a" /* default */],
  RationDistributor: __WEBPACK_IMPORTED_MODULE_13__RationDistributor__["a" /* default */],
  TransportVehicle: __WEBPACK_IMPORTED_MODULE_14__TransportVehicle__["a" /* default */]
});

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  getMedicine: function getMedicine() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;

    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/medicine', {
      dataType: 'json',
      params: request,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  getMedicineDetails: function getMedicineDetails() {
    var Id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;

    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/medicine/' + Id, {
      dataType: 'json',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  addMedicine: function addMedicine() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    var headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    };
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/medicine', request, { "headers": headers }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  updateMedicine: function updateMedicine() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    var id = request._id;
    delete request._id;
    var headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    };
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/medicine/' + id, request, { "headers": headers }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }
});

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  getPatientRanking: function getPatientRanking() {},
  getPatientInfo: function getPatientInfo() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    console.log('VVVVTOEKVVVV--->' + token);
    console.log(token);
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/patientinfo', {
      dataType: 'json',
      params: request,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  getPatientDetails: function getPatientDetails() {
    var pateintId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    console.log('VVVVTOEKVVVV--->' + token);
    console.log(token);
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/patientinfo/' + pateintId, {
      dataType: 'json',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  getInstructions: function getInstructions() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    console.log('VVVVTOEKVVVV--->' + token);
    console.log(token);
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/instruction', {
      dataType: 'json',
      params: request,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  getPrecondition: function getPrecondition() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    console.log('VVVVTOEKVVVV--->' + token);
    console.log(token);
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/precondition', {
      dataType: 'json',
      params: request,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  getSymptom: function getSymptom() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;

    console.log(token);
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/symptom', {
      dataType: 'json',
      params: request,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  getTask: function getTask() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    console.log('VVVVTOEKVVVV--->' + token);
    console.log(token);
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/task', {
      dataType: 'json',
      params: request,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  getTaskLog: function getTaskLog() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    console.log('VVVVTOEKVVVV--->' + token);
    console.log(token);
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/tasklog', {
      dataType: 'json',
      params: request,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  getFiles: function getFiles() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    console.log('VVVVTOEKVVVV--->' + token);
    console.log(token);
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/files', {
      dataType: 'json',
      params: request,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  getReport: function getReport() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/patientreport', {
      dataType: 'json',
      params: request,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  getLocationReport: function getLocationReport() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/patientloc', {
      dataType: 'json',
      params: request,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  getCaseReport: function getCaseReport() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/patientcases', {
      dataType: 'json',
      params: request,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  getStatusReport: function getStatusReport() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/patientstatus', {
      dataType: 'json',
      params: request,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }
});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/products', request).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }
});

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/task', request).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  getToken: function getToken() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/users/vctoken', {
      dataType: 'json',
      params: request,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }
});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  login: function login() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/authweb', request).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  getUserList: function getUserList() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    console.log('VVVVTOEKVVVV--->' + token);
    console.log(token);
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/users', {
      dataType: 'json',
      params: request,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  getForwardUserList: function getForwardUserList() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    console.log('VVVVTOEKVVVV--->' + token);
    console.log(token);
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/users/nearme', {
      dataType: 'json',
      params: request,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  getUserDetails: function getUserDetails() {
    var userId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    console.log('VVVVTOEKVVVV--->' + token);
    console.log(token);
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/users/' + userId, {
      dataType: 'json',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  addUser: function addUser() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    console.log('VVVVTOEKVVVV--->' + token);
    console.log(token);

    var headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    };
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/users/webAdd', request, { "headers": headers }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  updateUser: function updateUser() {
    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    var id = request._id;
    delete request._id;
    var headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    };
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/users/' + id, request, { "headers": headers }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  uploadProflePhoto: function uploadProflePhoto(formdata, file) {
    var ldata = localStorage.getItem('users');
    if (ldata == null) return [];
    var data = JSON.parse(ldata);
    var token = data.token;
    console.log('VVVVTOEKVVVV--->' + token);
    console.log(token);

    var headers = {
      'Content-Type': 'multipart/form-data',
      'Authorization': 'Bearer ' + token
    };
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/files', formdata, { "headers": headers }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unreadMessagesCount", function() { return unreadMessagesCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unreadNotificationsCount", function() { return unreadNotificationsCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "remainTasksCount", function() { return remainTasksCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentUser", function() { return currentUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loginError", function() { return loginError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "totalProduct", function() { return totalProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tasks", function() { return tasks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lang", function() { return lang; });
var unreadMessagesCount = function unreadMessagesCount(state) {
  return state.messages.main.length;
};
var unreadNotificationsCount = function unreadNotificationsCount(state) {
  return state.notifications.main.length;
};
var remainTasksCount = function remainTasksCount(state) {
  return state.tasks.main.length;
};
var currentUser = function currentUser(state) {
  return state.user.main;
};
var loginError = function loginError(state) {
  return state.user.error;
};
var totalProduct = function totalProduct(state) {
  return state.products.main;
};
var tasks = function tasks(state) {
  return state.tasks.main;
};
var lang = function lang(state) {
  return state.language.main;
};

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(42);



var _mutations;



var state = {
  main: { language: 'en', flag: 'us', title: 'English' }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* GET_LAN */], function (state) {
  var main2 = { language: 'en', flag: 'us', title: 'English' };
  var lanData = localStorage.getItem('lan');
  var jsonData = lanData !== null ? JSON.parse(lanData) : main2;
  state.main = jsonData;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["h" /* SET_LAN */], function (state, data) {
  var main2 = { language: data.language, flag: data.flag, title: data.title };
  localStorage.setItem('lan', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(main2));
  state.main = main2;
}), _mutations);

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var state = {
  main: [{
    id: 1,
    body: 'Message 1'
  }, {
    id: 2,
    body: 'Message 2'
  }, {
    id: 3,
    body: 'Message 3'
  }, {
    id: 4,
    body: 'Message 4'
  }, {
    id: 5,
    body: 'Message 5'
  }, {
    id: 5,
    body: 'Message 5'
  }]
};

var mutations = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var state = {
  main: [{
    id: 1,
    body: 'Noti 1'
  }, {
    id: 2,
    body: 'Noti 2'
  }]
};

var mutations = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(42);



var state = {
  main: []
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* FETCH_PRODUCT */], function (state, products) {
  state.main = products;
});

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(42);



var state = {
  main: []
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* FETCH_TASK */], function (state, tasks) {
  state.main = tasks;
});

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_jwt_decode__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_jwt_decode__);



var _mutations;



var state = {
  main: {
    name: 'Alexander Pierce',
    position: 'Web Developer',
    authorized: false,
    token: '',
    location: { country: '', state: '', district: '', city_union: '' },
    state: {
      color: '#3c763d',
      name: 'Online'
    },
    createdAt: new Date()
  },
  error: {}
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* LOGIN */], function (state, data) {
  var decode = __WEBPACK_IMPORTED_MODULE_3_vue_jwt_decode___default.a.decode(data.accessToken);

  var main2 = {
    name: decode.name,
    contactNumber: decode.contactNumber,
    position: decode.permissionLevel,
    authorized: true,
    token: data.accessToken,
    location: { country: decode.country, state: decode.state, district: decode.district, city_union: decode.city_union, coordinates: decode.location.coordinates },
    state: {
      color: '#3c763d',
      name: 'Online'
    },
    createdAt: new Date()
  };
  localStorage.setItem('users', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(main2));
  state.main = main2;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* ERROR */], function (state, data) {
  state.error = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* LOGOUT */], function (state) {
  var main2 = {
    name: 'guest',
    position: '',
    contactNumber: '',
    authorized: false,
    token: '',
    location: { country: '', state: '', district: '', city_union: '' },
    state: {
      color: '#ff1100',
      name: 'Offline'
    },
    createdAt: new Date()
  };
  localStorage.removeItem('users');
  state.main = main2;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* LOGIN_STATUS */], function (state) {
  var main2 = {
    name: 'guest',
    position: '',
    authorized: false,
    contactNumber: '',
    token: '',
    location: { country: '', state: '', district: '', city_union: '' },
    state: {
      color: '#ff1100',
      name: 'Offline'
    },
    createdAt: new Date()
  };
  var localData = localStorage.getItem('users');
  var jsonData = localData ? JSON.parse(localData) : main2;
  state.main = jsonData;
}), _mutations);

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules__ = __webpack_require__(100);







__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
  modules: __WEBPACK_IMPORTED_MODULE_4__modules__["default"],
  strict: "production" !== 'production'
}));

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'flag',
    props: {
        iso: { type: String, default: null },
        title: { type: String, default: null },
        squared: { type: Boolean, default: true }
    },
    computed: {
        flagIconClass: function flagIconClass() {
            return (!!this.squared ? 'flag-icon-squared ' : '') + 'flag-icon-' + this.iso.toLowerCase();
        }
    }
});

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(757)));

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(759)));

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(760)));

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(765)));

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_NaviBar_vue__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_NaviBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_NaviBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Slider_vue__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Slider_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_Slider_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ContentWrap_vue__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ContentWrap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ContentWrap_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Modal_vue__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vuex_store_js__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_slideMenuItems_js__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_slideMenuItems_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__lib_slideMenuItems_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(5);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      slideMenuItems: __WEBPACK_IMPORTED_MODULE_6__lib_slideMenuItems_js___default.a
    };
  },
  created: function created() {
    this.getLoginStatus();
  },

  components: {
    'va-navibar': __WEBPACK_IMPORTED_MODULE_1_NaviBar_vue___default.a,
    'va-slider': __WEBPACK_IMPORTED_MODULE_2_Slider_vue___default.a,
    'va-content-wrap': __WEBPACK_IMPORTED_MODULE_3_ContentWrap_vue___default.a,
    Modal: __WEBPACK_IMPORTED_MODULE_4__components_Modal_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])(['currentUser'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])(['getLoginStatus'])),
  store: __WEBPACK_IMPORTED_MODULE_5__vuex_store_js__["a" /* default */]
});

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'va-content-wrap',
  created: function created() {}
});

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_vuex_api_services_config__ = __webpack_require__(7);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'va-navibar',
  data: function data() {
    return {
      languages: [{ flag: 'us', language: 'en', title: 'English' }, { flag: 'es', language: 'es', title: 'Español' }, { flag: 'my', language: 'my', title: 'Malaysia' }],
      selectedLan: '',
      classFlag: '',
      title: '',
      avatar: ''
    };
  },
  mounted: function mounted() {
    this.avatar = __WEBPACK_IMPORTED_MODULE_3__src_vuex_api_services_config__["a" /* default */].serverURI + '/avatar/' + this.currentUser.contactNumber;
  },
  created: function created() {
    this.getLanguage();
    this.selectedLan = this.lang.language;
    this.classFlag = 'flag-icon flag-icon-' + this.lang.flag;
    this.title = this.lang.title;
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    imageLoadError: function imageLoadError(event) {
      console.log(event);
      event.target.src = __WEBPACK_IMPORTED_MODULE_3__src_vuex_api_services_config__["a" /* default */].serverURI + '/static/avatar.png';
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['getLanguage', 'setLanguage']), {
    changeLocale: function changeLocale(locale) {
      this.setLanguage(locale);
      __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].locale = locale.language;
      this.selectedLan = locale.language;
      this.classFlag = 'flag-icon flag-icon-' + locale.flag;
      this.title = locale.title;
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['unreadMessagesCount', 'unreadNotificationsCount', 'remainTasksCount', 'currentUser', 'lang']))
});

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_VASlideItem__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_VASlideItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_VASlideItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_vuex_api_services_config__ = __webpack_require__(7);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'va-slider',
  props: {
    slideMenuItems: {
      type: Array,
      default: []
    },
    userRole: {
      type: Number,
      default: -1
    }
  },
  data: function data() {
    return {
      avatar: ''
    };
  },
  created: function created() {
    this.avatar = __WEBPACK_IMPORTED_MODULE_3__src_vuex_api_services_config__["a" /* default */].serverURI + '/avatar/' + this.currentUser.contactNumber;
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['currentUser'])),
  components: {
    'va-slide-item': __WEBPACK_IMPORTED_MODULE_2__components_VASlideItem___default.a
  }
});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    var _this = this;

    this.$bus.$on('modal-open', function (args) {
      _this.type = args.type;
      _this.title = args.title;
      _this.description = args.description;
      _this.confirmText = args.confirmText || '저장 후 닫기';
      _this.cancelText = args.cancelText || '닫기';
      _this.confirmBeforeHook = args.confirmBefore;
      _this.confirmAfterHook = args.confirmAfter;
      _this.cancelBeforeHook = args.cancelBefore;
      _this.cancelAfterHook = args.cancelAfter;

      $('#bsModal').modal('show');
    });
    $('#bsModal').on('show.bs.modal', function (e) {});

    $('#bsModal').on('hidden.bs.modal', function (e) {
      _this.confirmAfterHook();
      _this.cancelAfterHook();
      _this.resetProperties();
    });
  },
  data: function data() {
    return {
      type: '',
      title: '',
      description: '',
      confirmText: '',
      cancelText: '',
      confirmBeforeHook: function confirmBeforeHook() {},
      confirmAfterHook: function confirmAfterHook() {},
      cancelBeforeHook: function cancelBeforeHook() {},
      cancelAfterHook: function cancelAfterHook() {}
    };
  },

  methods: {
    confirm: function confirm() {
      this.confirmBeforeHook();
      $('#bsModal').modal('hide');
      this.cancelAfterHook = function () {};
    },
    cancel: function cancel() {
      this.cancelBeforeHook();
      $('#bsModal').modal('hide');
      this.confirmAfterHook = function () {};
    },
    resetProperties: function resetProperties() {
      this.type = '';
      this.title = '';
      this.description = '';
      this.confirmText = '';
      this.cancelText = '';
      this.confirmBeforeHook = function () {};
      this.confirmAfterHook = function () {};
      this.cancelBeforeHook = function () {};
      this.cancelAfterHook = function () {};
    }
  }
});

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'va-button',
  props: {
    name: {
      type: String,
      default: 'Button'
    },
    theme: {
      type: String,
      default: 'default'
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isFlat: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: ''
    },
    isBlock: {
      type: Boolean,
      default: true
    },
    align: {
      type: String,
      default: ''
    }
  },
  created: function created() {},

  computed: {
    btnTheme: function btnTheme() {
      return 'btn-' + this.theme;
    },
    disabled: function disabled() {
      return this.isDisabled ? 'disabled' : '';
    },
    flat: function flat() {
      return this.isFlat ? 'btn-flat' : '';
    },
    getAlign: function getAlign() {
      switch (this.align) {
        case 'left':
        case 'right':
          break;
        default:
          return '';
      }

      return 'pull-' + this.align;
    }
  }
});

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Chart',
  props: {
    'chart-config': {
      type: Object,
      validator: function validator(value) {
        var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(value);
        if (!keys.includes('type')) {
          console.error('[Chart.js] Object must has type (key)');
          return false;
        }
        if (!keys.includes('data')) {
          console.error('[Chart.js] Object must has data (key)');
          return false;
        }
        return true;
      }
    }
  },
  mounted: function mounted() {
    var chartCanvas = this.$el.getContext('2d');
    var chartConfig = this.chartConfig;
    new __WEBPACK_IMPORTED_MODULE_1_chart_js___default.a(chartCanvas, chartConfig);
  }
});

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'va-checkbox',
  props: {
    text: {
      type: String,
      default: 'Check me out'
    },
    isHorizontal: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {}
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'va-form-group',
  created: function created() {}
});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'va-input',
  props: {
    type: {
      type: String,
      default: 'text'
    },
    vaId: {
      type: String
    },
    placeholder: {
      type: String,
      default: 'Enter Text...'
    },
    size: {
      type: String
    },
    value: {
      type: String
    },
    isFormControl: {
      type: Boolean,
      default: true
    },
    isHorizontal: {
      type: Boolean,
      default: false
    },
    title: {
      type: String
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getSize: function getSize() {
      if (!this.size) {
        return '';
      }

      return 'input-' + this.size;
    },
    formControl: function formControl() {
      return this.isFormControl ? 'form-control' : '';
    }
  },
  created: function created() {}
});

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAInput__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__VAInput__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'va-input-group',
  props: {
    groupType: {
      type: String,
      default: 'form'
    },
    theme: {
      type: String
    },
    title: {
      type: String
    },
    type: {
      type: String,
      default: 'text'
    },
    vaId: {
      type: String
    },
    placeholder: {
      type: String,
      default: 'Enter Text...'
    },
    size: {
      type: String
    },
    value: {
      type: String
    },
    helpBlock: {
      type: String
    },
    prefixAddonText: {
      type: String
    },
    suffixAddonText: {
      type: String
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getTheme: function getTheme() {
      if (!this.theme) {
        return '';
      }

      return 'has-' + this.theme;
    }
  },
  created: function created() {},

  components: {
    'va-input': __WEBPACK_IMPORTED_MODULE_0__VAInput___default.a
  }
});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'va-radio',
  props: {
    vaId: {
      type: String
    },
    name: {
      type: String
    },
    value: {
      type: String
    },
    isChecked: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {}
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'va-select',
  props: {
    list: {
      type: Array,
      default: []
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isMultiple: {
      type: Boolean,
      default: false
    },
    isHorizontal: {
      type: Boolean,
      default: false
    },
    title: {
      type: String
    },
    vaId: {
      type: String
    }
  },
  created: function created() {}
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'va-slide-item',
  props: {
    type: {
      type: String,
      default: 'item'
    },
    isHeader: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    name: {
      type: String
    },
    badge: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    router: {
      type: Object,
      default: function _default() {
        return {
          name: ''
        };
      }
    },
    link: {
      type: String,
      default: ''
    },
    userRole: {
      type: Number,
      default: -1
    },
    permission: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  created: function created() {},

  computed: {
    getType: function getType() {
      if (this.isHeader) {
        return 'header';
      }
      return this.type === 'item' ? '' : 'treeview';
    }
  }
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'va-textarea',
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    rowCount: {
      type: Number,
      default: 3
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {}
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VATextarea__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VATextarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__VATextarea__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'va-textarea-group',
  props: {
    title: {
      type: String,
      default: 'Textarea'
    },
    rowCount: {
      type: Number,
      default: 3
    },
    placeholder: {
      type: String,
      defualt: ''
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {},

  components: {
    'va-textarea': __WEBPACK_IMPORTED_MODULE_0__VATextarea___default.a
  }
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pages: {
      type: Number,
      required: true
    },
    currentpage: {
      type: Number,
      required: true
    },
    vspbutton: {
      type: String,
      default: 'vspButton'
    },
    vspbuttonselected: {
      type: String,
      default: 'vspButton-selected'
    },
    vspbuttonfast: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      maxPages: 10,
      leftPages: [],
      currPage: 0
    };
  },

  methods: {
    handlePageChange: function handlePageChange(item) {
      if (this.currPage !== item) {
        this.currPage = item;
        this.generateLeftPages();
        this.$emit('changePage', item);
      }
    },
    generateLeftPages: function generateLeftPages() {
      var start = this.currPage - parseInt(this.maxPages / Math.pow(2, 2)) > 1 ? this.currPage - parseInt(this.maxPages / Math.pow(2, 2)) : 1;
      var stop = parseInt(this.maxPages / 2) + this.currPage - parseInt(this.maxPages / Math.pow(2, 2)) - 1;
      if (stop < parseInt(this.maxPages / 2)) stop = parseInt(this.maxPages / 2);
      if (stop >= this.pages - parseInt(this.maxPages / 2) + 1) {
        stop = this.pages - parseInt(this.maxPages / 2);
        start = this.pages - parseInt(this.maxPages / 2) - parseInt(this.maxPages / Math.pow(2, 2)) - 2;
      }
      this.leftPages = [];
      for (var i = start; i <= stop; i++) {
        this.leftPages.push(i);
      }
    }
  },
  watch: {
    currentpage: function currentpage(val) {
      this.handlePageChange(val);
    }
  },
  mounted: function mounted() {
    this.currPage = this.currentpage;
    this.generateLeftPages();
  }
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_eventBus__ = __webpack_require__(41);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "AddRoom", data: function data() {
    return {
      room_name: ""
    };
  },

  methods: {
    createNewRoom: function createNewRoom(name) {
      if (!name) {
        alert("please provide a room name");
        return;
      }

      this.room_name = '';
      __WEBPACK_IMPORTED_MODULE_0__lib_eventBus__["a" /* default */].$emit('new_room', name);
    }
  }
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_eventBus__ = __webpack_require__(41);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Logs",
  data: function data() {
    return {
      logs: [],
      logCount: 0
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__lib_eventBus__["a" /* default */].$on('new_log', function (message) {
      _this.logs.push({ id: _this.logCount, message: message });

      _this.logCount += 1;
    });
  }
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_eventBus__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AddRoom__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AddRoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__AddRoom__);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: "Rooms", data: function data() {
        return {
            rooms: [{ id: 1, name: 'PHP Room' }, { id: 2, name: 'Python Room' }, { id: 3, name: 'Daily standup' }],
            roomCount: 3,
            loading: false };
    },

    components: {
        AddRoom: __WEBPACK_IMPORTED_MODULE_1__AddRoom___default.a },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0__lib_eventBus__["a" /* default */].$on('new_room', function (data) {
            _this.roomCount++;
            _this.rooms.push({ id: _this.roomCount, name: data });
        });
    },

    methods: {
        showRoom: function showRoom(room) {
            __WEBPACK_IMPORTED_MODULE_0__lib_eventBus__["a" /* default */].$emit('show_room', room);
        }
    }

});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_eventBus__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_twilio_video__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_twilio_video___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_twilio_video__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vuex_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(5);











/* harmony default export */ __webpack_exports__["default"] = ({
    name: "Video",
    data: function data() {
        return {
            loading: false,
            data: {},
            localTrack: false,
            remoteTrack: '',
            activeRoom: '',
            previewTracks: '',
            identity: '',
            roomName: null
        };
    },

    props: ['username'], created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_4__lib_eventBus__["a" /* default */].$on('show_room', function (room_name) {
            _this.createChat(room_name);
        });

        window.addEventListener('beforeunload', this.leaveRoomIfJoined);
    },

    computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])(['currentUser'])),
    methods: {
        getAccessToken: function getAccessToken() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_6__vuex_api__["a" /* services */].twilloToken.getToken();

                            case 2:
                                return _context.abrupt('return', _context.sent);

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        dispatchLog: function dispatchLog(message) {
            __WEBPACK_IMPORTED_MODULE_4__lib_eventBus__["a" /* default */].$emit('new_log', message);
        },
        attachTracks: function attachTracks(tracks, container) {
            tracks.forEach(function (track) {
                container.appendChild(track.attach());
            });
        },
        attachParticipantTracks: function attachParticipantTracks(participant, container) {
            var tracks = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(participant.tracks.values());
            this.attachTracks(tracks, container);
        },
        detachTracks: function detachTracks(tracks) {
            tracks.forEach(function (track) {
                track.detach().forEach(function (detachedElement) {
                    detachedElement.remove();
                });
            });
        },
        detachParticipantTracks: function detachParticipantTracks(participant) {
            var tracks = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(participant.tracks.values());
            this.detachTracks(tracks);
        },
        leaveRoomIfJoined: function leaveRoomIfJoined() {
            if (this.activeRoom) {
                this.activeRoom.disconnect();
            }
        },
        createChat: function createChat(room_name) {
            var _this3 = this;

            this.loading = true;
            var VueThis = this;
            __WEBPACK_IMPORTED_MODULE_6__vuex_api__["a" /* services */].twilloToken.getToken().then(function (response) {
                VueThis.roomName = null;
                var token = response.data.token;
                var connectOptions = {
                    name: room_name,

                    audio: true,
                    video: { width: 400 }
                };

                _this3.leaveRoomIfJoined();

                document.getElementById('remoteTrack').innerHTML = "";

                __WEBPACK_IMPORTED_MODULE_5_twilio_video___default.a.connect(token, connectOptions).then(function (room) {
                    VueThis.dispatchLog('Successfully joined a Room: ' + room_name);

                    VueThis.activeRoom = room;
                    VueThis.roomName = room_name;
                    VueThis.loading = false;
                    room.participants.forEach(function (participant) {
                        var previewContainer = document.getElementById('remoteTrack');
                        VueThis.attachParticipantTracks(participant, previewContainer);
                    });

                    room.on('participantConnected', function (participant) {
                        VueThis.dispatchLog("Joining: '" + participant.identity + "'");
                    });

                    room.on('trackAdded', function (track, participant) {
                        VueThis.dispatchLog(participant.identity + " added track: " + track.kind);
                        var previewContainer = document.getElementById('remoteTrack');
                        VueThis.attachTracks([track], previewContainer);
                    });

                    room.on('trackRemoved', function (track, participant) {
                        VueThis.dispatchLog(participant.identity + " removed track: " + track.kind);
                        VueThis.detachTracks([track]);
                    });

                    room.on('participantDisconnected', function (participant) {
                        VueThis.dispatchLog("Participant '" + participant.identity + "' left the room");
                        VueThis.detachParticipantTracks(participant);
                    });

                    if (!VueThis.localTrack) {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_twilio_video__["createLocalVideoTrack"])().then(function (track) {
                            var localMediaContainer = document.getElementById('localTrack');
                            localMediaContainer.appendChild(track.attach());
                            VueThis.localTrack = true;
                        });
                    }
                });
            });
        }
    }
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'column',
  props: {
    'class': {
      type: String,
      default: ''
    }
  },
  created: function created() {}
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'row',
  created: function created() {}
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_vuex_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_components_simple_pagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_components_simple_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__src_components_simple_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_widgets_VALoading__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_widgets_VALoading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__src_widgets_VALoading__);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'AddLocation',
    mounted: function mounted() {
        var self = this;

        self.getLanguage();
        if (localStorage.getItem('lan') != null) self.$i18n.locale = JSON.parse(localStorage.getItem('lan')).language;
    },
    data: function data() {
        return {
            center: { lat: 23.8103, lng: 90.4125 },
            markers: [{ position: { lat: 10.0, lng: 10.0 } }],
            getMap: this.$root.mapping,
            description: '',
            latLng: {},
            place: null,
            loading: false,
            error: '',
            success: '',
            form: {
                locationName: '',
                district: '',
                state: '',
                latitude: 0,
                longitude: 0

            }
        };
    },
    components: {
        'loading': __WEBPACK_IMPORTED_MODULE_4__src_widgets_VALoading___default.a
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['getLanguage']), {
        setDescription: function setDescription(description) {
            this.description = description;
        },
        getPos: function getPos(e) {
            var latLng_ = e.latLng;
            console.log(e);
            var lat = latLng_.lat();
            var lng = latLng_.lng();
            this.latLng = {
                lat: lat,
                lng: lng
            };

            this.center.lat = lat;
            this.center.lng = lng;
            this.form.latitude = lat;
            this.form.longitude = lng;
        },
        setPlace: function setPlace(place) {
            this.latLng = {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng()
            };

            this.center.lat = place.geometry.location.lat();
            this.center.lng = place.geometry.location.lng();
            this.form.latitude = place.geometry.location.lat();
            this.form.longitude = place.geometry.location.lng();
            this.form.locationName = place.name;
        },
        geocodeLatLng: function geocodeLatLng(geocoder, map, infowindow) {
            geocoder.geocode({ 'location': this.center }, function (results, status) {
                console.log(results, status);
            });
        },

        addLocation: function addLocation() {
            var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var self = this;
            self.success = "";
            $('#loadMe').modal('show');
            __WEBPACK_IMPORTED_MODULE_1__src_vuex_api__["a" /* services */].Location.addLocation(request).then(function (response) {
                $('#loadMe').modal('hide');
                self.success = "saved";
            }).catch(function (err) {
                $('#loadMe').modal('hide');
                self.error = '' + err;
            });
        },
        updateLocation: function updateLocation() {
            var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var self = this;

            $('#loadMe').modal('show');
            __WEBPACK_IMPORTED_MODULE_1__src_vuex_api__["a" /* services */].Location.updateLocation(request).then(function (response) {
                $('#bsModal').modal('hide');
                self.getLocation({});
            }).catch(function (err) {
                $('#loadMe').modal('hide');
                self.error = '' + err;
            });
        },
        submit: function submit() {
            if (this.form._id) {
                this.updateLocation(this.form);
            } else {
                this.addLocation(this.form);
            }
        }

    }),

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['lang']))
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__widgets_VASmallBox_vue__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__widgets_VASmallBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__widgets_VASmallBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__widgets_VAChatBox_vue__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__widgets_VAChatBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__widgets_VAChatBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_VATodoList_vue__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_VATodoList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__widgets_VATodoList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__widgets_VAQuickMail_vue__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__widgets_VAQuickMail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__widgets_VAQuickMail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_VACalendar_vue__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_VACalendar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__widgets_VACalendar_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'dashboard',
  data: function data() {
    return {
      patientInfo: [],
      instructions: [],
      preconditions: [],
      symtops: [],
      task: [],
      taskInfo: [],
      files: []
    };
  },

  methods: {
    clickToSmallBox: function clickToSmallBox() {
      alert('click!!!: clickToSmallBox');
    }
  },
  components: {
    'va-small-box': __WEBPACK_IMPORTED_MODULE_0__widgets_VASmallBox_vue___default.a,
    'va-chat-box': __WEBPACK_IMPORTED_MODULE_1__widgets_VAChatBox_vue___default.a,
    'va-todo-list': __WEBPACK_IMPORTED_MODULE_2__widgets_VATodoList_vue___default.a,
    'va-quick-mail': __WEBPACK_IMPORTED_MODULE_3__widgets_VAQuickMail_vue___default.a,
    'va-calendar': __WEBPACK_IMPORTED_MODULE_4__widgets_VACalendar_vue___default.a
  }
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Location',
  mounted: function mounted() {
    var self = this;
    var uri = window.location.href.split('?');
    if (uri.length === 2) {
      var vars = uri[1].split('&');
      var getVars = {};
      var tmp = '';
      vars.forEach(function (v) {
        tmp = v.split('=');
        if (tmp.length === 2) {
          getVars[tmp[0]] = tmp[1];
          if (tmp[0] in self.form) {
            self.form[tmp[0]] = tmp[1];
          }
        }
      });
    }
    this.getLocation(self.form);
    this.getLanguage();
    if (localStorage.getItem('lan') != null) this.$i18n.locale = JSON.parse(localStorage.getItem('lan')).language;
    console.log('mounted: got here');
  },
  data: function data() {
    return {
      place: null,
      loading: false,
      message: 'Location list',
      error: '',
      locations: [],
      form: {
        locationName: '',
        district: '',
        state: ''
      },
      search: {
        locationName: '',
        district: '',
        state: '',
        enterBy: '',
        totalpages: 0,
        page: 0

      },
      customLabels: {
        first: '<<',
        last: '>>',
        previous: '<',
        next: '>'
      }
    };
  },
  components: {
    'simple-pagination': __WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination___default.a,
    'loading': __WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['getLanguage']), {

    getLocation: function getLocation() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var self = this;

      $('#loadMe').modal('show');
      __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__["a" /* services */].Location.getLocation(request).then(function (response) {
        self.locations = response.data.docs;
        self.search.totalpages = Math.ceil(response.data.count / response.data.perpage);
        self.search.page = response.data.page;

        $('#loadMe').modal('hide');
      }).catch(function (error) {
        console.log(error);
      });
    },
    addLocation: function addLocation() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var self = this;

      $('#loadMe').modal('show');
      __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__["a" /* services */].Location.addLocation(request).then(function (response) {
        $('#bsModal').modal('hide');
        self.getLocation({});
      }).catch(function (err) {
        $('#loadMe').modal('hide');
        self.error = '' + err;
      });
    },
    updateLocation: function updateLocation() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var self = this;

      $('#loadMe').modal('show');
      __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__["a" /* services */].Location.updateLocation(request).then(function (response) {
        $('#bsModal').modal('hide');
        self.getLocation({});
      }).catch(function (err) {
        $('#loadMe').modal('hide');
        self.error = '' + err;
      });
    },
    submit: function submit() {
      if (this.form._id) {
        this.updateLocation(this.form);
      } else {
        this.addLocation(this.form);
      }
    },
    searchClick: function searchClick() {
      this.getLocation(this.search);
    },
    clearClick: function clearClick() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.form).forEach(function (key, index) {
        if (key !== 'totalpages' && key !== 'pages' && key !== 'page') {
          self.search[key] = '';
        }
      });
    },
    pageChange: function pageChange(pageNo) {
      var self = this;
      self.search.page = pageNo;
      this.getLocation(this.search);
    },
    openFrom: function openFrom(data) {
      this.error = '';
      if (data) {
        this.form = data;
      }
      $('#bsModal').modal('show');
    }

  }),

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['lang']))
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Login',
  data: function data(router) {
    return {
      section: 'Login',
      loading: '',
      username: '',
      password: '',
      response: ''
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['currentUser', 'loginError'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['processLogin']), {
    checkCreds: function checkCreds() {
      var username = this.username,
          password = this.password;

      this.processLogin({ username: username, password: password });
    }
  })
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Logout',
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['processLogout'])),
  created: function created() {
    this.processLogout();
  }
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Medicines',
  mounted: function mounted() {
    var self = this;
    var uri = window.location.href.split('?');
    if (uri.length === 2) {
      var vars = uri[1].split('&');
      var getVars = {};
      var tmp = '';
      vars.forEach(function (v) {
        tmp = v.split('=');
        if (tmp.length === 2) {
          getVars[tmp[0]] = tmp[1];
          if (tmp[0] in self.form) {
            self.form[tmp[0]] = tmp[1];
          }
        }
      });
    }
    this.getMedicine(self.form);
    this.getLanguage();
    if (localStorage.getItem('lan') != null) this.$i18n.locale = JSON.parse(localStorage.getItem('lan')).language;
    console.log('mounted: got here');
  },
  data: function data() {
    return {
      loading: false,
      message: 'Medicines list',
      error: '',
      users: [],
      user: {
        name: '',
        groupName: -1,
        productType: -1,
        warnings: []
      },
      form: {
        name: '',
        groupName: -1,
        productType: -1,
        warnings: [],
        totalpages: 0,
        page: 0

      },
      customLabels: {
        first: '<<',
        last: '>>',
        previous: '<',
        next: '>'
      }
    };
  },
  components: {
    'simple-pagination': __WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination___default.a,
    'loading': __WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['getLanguage']), {

    getMedicine: function getMedicine() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var self = this;

      $('#loadMe').modal('show');
      __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__["a" /* services */].medicines.getMedicine(request).then(function (response) {
        self.users = response.data.docs;
        self.form.totalpages = Math.ceil(response.data.count / response.data.perpage);
        self.form.page = response.data.page;

        $('#loadMe').modal('hide');
      }).catch(function (error) {
        console.log(error);
      });
    },
    addMedicine: function addMedicine() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var self = this;

      $('#loadMe').modal('show');
      __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__["a" /* services */].medicines.addMedicine(request).then(function (response) {
        $('#bsModal').modal('hide');
        self.getMedicine({});
      }).catch(function (err) {
        $('#loadMe').modal('hide');
        self.error = '' + err;
      });
    },
    updateMedicine: function updateMedicine() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var self = this;

      $('#loadMe').modal('show');
      __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__["a" /* services */].medicines.updateMedicine(request).then(function (response) {
        $('#bsModal').modal('hide');
        self.getMedicine({});
      }).catch(function (err) {
        $('#loadMe').modal('hide');
        self.error = '' + err;
      });
    },
    submit: function submit(e) {
      e.preventDefault();
      if (this.user._id) {
        this.updateMedicine(this.user);
      } else {
        this.addMedicine(this.user);
      }
    },
    searchClick: function searchClick() {
      this.getMedicine(this.form);
    },
    clearClick: function clearClick() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.form).forEach(function (key, index) {
        if (key !== 'totalpages' && key !== 'pages' && key !== 'page') {
          self.form[key] = '';
        }
      });
    },
    pageChange: function pageChange(pageNo) {
      var self = this;
      self.form.page = pageNo;
      this.getMedicine(this.form);
    },
    openUserFrom: function openUserFrom(data) {
      if (data) {
        this.user = data;
      }
      $('#bsModal').modal('show');
    }

  }),

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['lang']))
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__widgets_VASmallBox_vue__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__widgets_VASmallBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__widgets_VASmallBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__widgets_VAChatBox_vue__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__widgets_VAChatBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__widgets_VAChatBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_VATodoList_vue__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_VATodoList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__widgets_VATodoList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__widgets_VAQuickMail_vue__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__widgets_VAQuickMail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__widgets_VAQuickMail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_VACalendar_vue__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_VACalendar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__widgets_VACalendar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_vuex_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__widgets_VAInfoBox_vue__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__widgets_VAInfoBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__widgets_VAInfoBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_VAChart__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_VAChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_VAChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugins_i18n__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_twillo_Rooms__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_twillo_Rooms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_twillo_Rooms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_twillo_Video__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_twillo_Video___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_twillo_Video__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__widgets_PrescriptionForm_vue__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__widgets_PrescriptionForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__widgets_PrescriptionForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__widgets_TaskForm_vue__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__widgets_TaskForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__widgets_TaskForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_twillo_Logs__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_twillo_Logs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_twillo_Logs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_twillo_AddRoom__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_twillo_AddRoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_twillo_AddRoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_lib_functions__ = __webpack_require__(31);




















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PatientDetails',
  mounted: function mounted() {
    var self = this;
    var uri = window.location.href.split('?');
    if (uri.length === 2) {
      var vars = uri[1].split('&');
      var tmp = '';
      vars.forEach(function (v) {
        tmp = v.split('=');
        if (tmp.length === 2) {
          if (tmp[0] === 'id') {
            self.id = tmp[1];
          }
        }
      });
    }
    this.getPatientDetails(self.id);
    this.getPatientPreCondition(self.id);
    this.getPatientSymtoms(self.id);

    if (localStorage.getItem('lan') != null) this.$i18n.locale = JSON.parse(localStorage.getItem('lan')).language;
    console.log('mounted: got here');
  },
  data: function data() {
    return {
      patientInfo: {},
      instructions: [],
      preconditions: [],
      symtops: [],
      userType: -1,
      error: '',
      chartData: {
        type: 'line',
        data: {
          datasets: []
        }
      },
      id: null,
      calRiskFactor: __WEBPACK_IMPORTED_MODULE_15__src_lib_functions__["c" /* calRiskFactor */],
      calSymptom: __WEBPACK_IMPORTED_MODULE_15__src_lib_functions__["d" /* calSymptom */],
      showTrend: __WEBPACK_IMPORTED_MODULE_15__src_lib_functions__["e" /* showTrend */]

    };
  },

  methods: {
    openTaskFrom: function openTaskFrom(data, e) {
      var self = this;
      self.userType = data;
      e.preventDefault();

      if (data === 6) {
        $('#bsMedicine').modal('show');
      } else {
        $('#bsForward').modal('show');
      }
    },
    clickToSmallBox: function clickToSmallBox() {
      alert('click!!!: clickToSmallBox');
    },
    getDescriptions: function getDescriptions(val, group) {
      if (group === 'close_contact') {
        return __WEBPACK_IMPORTED_MODULE_8__plugins_i18n__["a" /* default */].t('closeContactData')[[val]];
      } else if (group === 'location') {
        return __WEBPACK_IMPORTED_MODULE_8__plugins_i18n__["a" /* default */].t('locationData')[[val]];
      } else if (group === 'age') {
        return __WEBPACK_IMPORTED_MODULE_8__plugins_i18n__["a" /* default */].t('ageGroupDate')[[val]];
      } else {
        return __WEBPACK_IMPORTED_MODULE_8__plugins_i18n__["a" /* default */].t('preconditionStatus')[[val]];
      }
    },
    customClass: function customClass(val) {
      var sec = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'weight';

      if (sec === 'weight') {
        if (val > -1 && val < 2) {
          return 'tags alert-success';
        } else if (val >= 2 && val < 3) {
          return 'tags alert-warning';
        } else {
          return 'tags alert-danger';
        }
      } else if (sec === 'pre') {
        if (val === 0) {
          return 'green';
        } else if (val === 1) {
          return 'aqua';
        } else if (val === 2) {
          return 'yellow';
        } else if (val === 3) {
          return 'red';
        } else {
          return 'aqua';
        }
      } else if (sec === 'age') {
        var age = new Date().getFullYear() - val;
        if (age > 6 && age < 25) {
          return 'tags alert-success';
        } else if (age >= 25 && age < 40) {
          return 'tags alert-primary';
        } else if (age >= 40 && age < 55) {
          return 'tags alert-warning';
        } else {
          return 'tags alert-danger';
        }
      } else if (sec === 'icon') {
        if (val === 'diabetics') {
          return 'tint';
        } else if (val === 'heart') {
          return 'heartbeat';
        } else if (val === 'weight') {
          return 'weight';
        } else if (val === 'hypertension') {
          return 'tachometer-alt';
        } else if (val === 'close_contact') {
          return 'head-side-cough';
        } else if (val === 'location') {
          return 'map';
        } else if (val === 'age') {
          return 'child';
        } else if (val === 'lungs') {
          return 'lungs';
        } else {
          return 'tint';
        }
      } else if (sec === 'duration') {
        if (val === 0) {
          return 'duration_na';
        } else if (val === 1) {
          return 'duration_less_5';
        } else if (val === 2) {
          return 'duration_more_5';
        }
      }
    },

    getPatientDetails: function getPatientDetails() {
      var patientId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var self = this;
      __WEBPACK_IMPORTED_MODULE_5__src_vuex_api__["a" /* services */].patients.getPatientDetails(patientId).then(function (response) {
        self.patientInfo = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    getPatientPreCondition: function getPatientPreCondition() {
      var patientId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var self = this;
      __WEBPACK_IMPORTED_MODULE_5__src_vuex_api__["a" /* services */].patients.getPrecondition({ patientId: patientId }).then(function (response) {
        var ageRank = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__src_lib_functions__["f" /* showAgeGroup */])(self.patientInfo.yob);

        var ageData = {
          "preCondition": "age",
          "status": ageRank,
          "duration": 2,
          "active": 1
        };
        self.preconditions = response.data;
        self.preconditions.push(ageData);
      }).catch(function (error) {
        console.log(error);
      });
    },
    getPatientSymtoms: function getPatientSymtoms() {
      var patientId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var self = this;
      console.log('YYYYYYYYYYYYYYYY  I AM IN SYMPTOMS');
      __WEBPACK_IMPORTED_MODULE_5__src_vuex_api__["a" /* services */].patients.getSymptom({ patientId: patientId }).then(function (response) {
        console.log('SHOWING  I AM INSIDE  SYMPTOMS');
        console.log(response.data);

        self.symtops = response.data;
        var timedifference = new Date().getTimezoneOffset() * 60 * 1000;

        var fever_ = [];
        var cough_ = [];
        var breath_ = [];
        var chest_ = [];
        var conditionData = __WEBPACK_IMPORTED_MODULE_8__plugins_i18n__["a" /* default */].t('symptomData');

        var consciousness_ = [];
        var now = new Date();
        var utcTimestamp = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds(), now.getUTCMilliseconds()) - timedifference;

        self.symtops.forEach(function (element) {

          var hours = Math.floor((utcTimestamp - element.insertTime) / 3600000);
          if (element.symptom.trim() === 'fever') {
            fever_.push({ y: conditionData[element.status], x: hours });

            cough_.push({ y: conditionData[element.status], x: hours });
          } else if (element.symptom === 'breath') {
            breath_.push({ y: conditionData[element.status], x: hours });
          } else if (element.symptom === 'chest_pain') {
            chest_.push({ y: conditionData[element.status], x: hours });
          } else if (element.symptom === 'confusion') {
            consciousness_.push({ y: conditionData[element.status], x: hours });
          }
        });

        var fever = { label: __WEBPACK_IMPORTED_MODULE_8__plugins_i18n__["a" /* default */].t('fever'), borderColor: '#0e14c7', data: fever_, borderDash: [2, 2], backgroundColor: '#0e14c7', fill: false };
        var cough = { label: __WEBPACK_IMPORTED_MODULE_8__plugins_i18n__["a" /* default */].t('cough'), borderColor: '#f80079', data: cough_, borderDash: [4, 4], backgroundColor: '#f80079', fill: false };
        var breath = { label: __WEBPACK_IMPORTED_MODULE_8__plugins_i18n__["a" /* default */].t('breathing_problem'), borderColor: 'rgba(199, 19, 6,0.9)', data: breath_, borderDash: [5, 5], backgroundColor: 'rgba(199, 19, 6,0.9)', fill: false };
        var chest = { label: __WEBPACK_IMPORTED_MODULE_8__plugins_i18n__["a" /* default */].t('chest_pain'), borderColor: '#f5bd05', data: chest_, borderDash: [6, 6], backgroundColor: '#f5bd05', fill: false };
        var consciousness = { label: __WEBPACK_IMPORTED_MODULE_8__plugins_i18n__["a" /* default */].t('consciousness'), borderColor: '#f8ff79', data: consciousness_, borderDash: [7, 7], backgroundColor: '#f8ff79', fill: false };
        var cLabels = conditionData.reverse();
        var chart = {
          type: 'line',
          data: {
            datasets: [fever, cough, chest, breath, consciousness]
          },
          options: {
            scales: {
              xAxes: [{
                type: 'linear',
                position: 'bottom',
                scaleLabel: {
                  display: true,
                  labelString: __WEBPACK_IMPORTED_MODULE_8__plugins_i18n__["a" /* default */].t('hour')
                }
              }],
              yAxes: [{
                display: true,
                type: 'category',
                ticks: {
                  min: cLabels[0],
                  max: cLabels[4]
                },
                labels: cLabels,
                scaleLabel: {
                  display: true,
                  labelString: __WEBPACK_IMPORTED_MODULE_8__plugins_i18n__["a" /* default */].t('condition')
                }
              }]
            }
          }
        };
        self.chartData = chart;
        console.log(self.chartData);
        console.log('FINAL  I AM INSIDE  SYMPTOMS');
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  components: {
    'va-small-box': __WEBPACK_IMPORTED_MODULE_0__widgets_VASmallBox_vue___default.a,
    'va-chat-box': __WEBPACK_IMPORTED_MODULE_1__widgets_VAChatBox_vue___default.a,
    'va-todo-list': __WEBPACK_IMPORTED_MODULE_2__widgets_VATodoList_vue___default.a,
    'va-quick-mail': __WEBPACK_IMPORTED_MODULE_3__widgets_VAQuickMail_vue___default.a,
    'va-calendar': __WEBPACK_IMPORTED_MODULE_4__widgets_VACalendar_vue___default.a,
    'va-info-box': __WEBPACK_IMPORTED_MODULE_6__widgets_VAInfoBox_vue___default.a,
    'Rooms': __WEBPACK_IMPORTED_MODULE_9__components_twillo_Rooms___default.a,
    'Logs': __WEBPACK_IMPORTED_MODULE_13__components_twillo_Logs___default.a,
    'Video': __WEBPACK_IMPORTED_MODULE_10__components_twillo_Video___default.a,
    'AddRoom': __WEBPACK_IMPORTED_MODULE_14__components_twillo_AddRoom___default.a,
    'va-chart': __WEBPACK_IMPORTED_MODULE_7__components_VAChart___default.a,
    'prescription': __WEBPACK_IMPORTED_MODULE_11__widgets_PrescriptionForm_vue___default.a,
    'task': __WEBPACK_IMPORTED_MODULE_12__widgets_TaskForm_vue___default.a

  }
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_lib_functions__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_components_simple_pagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_components_simple_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__src_components_simple_pagination__);








/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'patient-list-row',
  mounted: function mounted() {
    var self = this;
    var uri = window.location.href.split('?');
    if (uri.length === 2) {
      var vars = uri[1].split('&');
      var getVars = {};
      var tmp = '';
      vars.forEach(function (v) {
        tmp = v.split('=');
        if (tmp.length === 2) {
          getVars[tmp[0]] = tmp[1];
          if (tmp[0] in self.form) {
            self.form[tmp[0]] = tmp[1];
          }
        }
      });
    }
    this.getPatient(self.form);
    this.getLanguage();
    if (localStorage.getItem('lan') != null) this.$i18n.locale = JSON.parse(localStorage.getItem('lan')).language;
    console.log('mounted: got here');
  },
  data: function data() {
    return {
      message: 'Patient List Row',
      patients: [],
      form: {
        name: '',
        address: '',
        contactNumber: '',
        gender: '',
        weight: '',
        status: '',
        condition: '',
        age1: '',
        age2: '',
        riskFactor: null,
        trend: null,
        currentRating: null,
        totalpages: 0,
        page: 0

      },
      customLabels: {
        first: '<<',
        last: '>>',
        previous: '<',
        next: '>'
      }
    };
  },
  components: {
    'simple-pagination': __WEBPACK_IMPORTED_MODULE_5__src_components_simple_pagination___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    calRiskFactor_: function calRiskFactor_(val) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__src_lib_functions__["c" /* calRiskFactor */])(val);
    },
    calSymptom_: function calSymptom_(val) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__src_lib_functions__["d" /* calSymptom */])(val);
    },
    showTrend_: function showTrend_(val) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__src_lib_functions__["e" /* showTrend */])(val);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['getLanguage']), {

    getPatient: function getPatient() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var self = this;
      __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__["a" /* services */].patients.getPatientInfo(request).then(function (response) {
        self.patients = response.data.docs;
        self.form.totalpages = Math.ceil(response.data.count / response.data.perpage);
        self.form.page = response.data.page;
        console.log(response.data.count);
      }).catch(function (error) {
        console.log(error);
      });
    },
    searchClick: function searchClick() {
      this.getPatient(this.form);
    },
    clearClick: function clearClick() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.form).forEach(function (key, index) {
        if (key !== 'totalpages' && key !== 'pages' && key !== 'page') {
          self.form[key] = '';
        }
      });
    },
    pageChange: function pageChange(pageNo) {
      var self = this;
      self.form.page = pageNo;
      this.getPatient(this.form);
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(['lang']))
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Procedure',
  mounted: function mounted() {
    var self = this;
    var uri = window.location.href.split('?');
    if (uri.length === 2) {
      var vars = uri[1].split('&');
      var getVars = {};
      var tmp = '';
      vars.forEach(function (v) {
        tmp = v.split('=');
        if (tmp.length === 2) {
          getVars[tmp[0]] = tmp[1];
          if (tmp[0] in self.form) {
            self.form[tmp[0]] = tmp[1];
          }
        }
      });
    }
    this.getProcedure(self.form);
    this.getLanguage();
    if (localStorage.getItem('lan') != null) this.$i18n.locale = JSON.parse(localStorage.getItem('lan')).language;
    console.log('mounted: got here');
  },
  data: function data() {
    return {
      loading: false,
      message: 'Procedure list',
      error: '',
      procedures: [],
      form: {
        patientId: '',
        yob: -1,
        patientName: '',
        consultantName: '',
        consultantId: '',
        medicines: []
      },
      search: {
        yob: -1,
        patientName: '',
        consultantName: '',
        consultantId: '',
        medicines: [],
        insertTime: -1,
        status: -1,
        totalpages: 0,
        page: 0

      },
      customLabels: {
        first: '<<',
        last: '>>',
        previous: '<',
        next: '>'
      }
    };
  },
  components: {
    'simple-pagination': __WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination___default.a,
    'loading': __WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['getLanguage']), {

    getProcedure: function getProcedure() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var self = this;

      $('#loadMe').modal('show');
      __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__["a" /* services */].Procedure.getProcedure(request).then(function (response) {
        self.procedures = response.data.docs;
        self.search.totalpages = Math.ceil(response.data.count / response.data.perpage);
        self.search.page = response.data.page;

        $('#loadMe').modal('hide');
      }).catch(function (error) {
        console.log(error);
      });
    },
    addProcedure: function addProcedure() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var self = this;

      $('#loadMe').modal('show');
      __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__["a" /* services */].Procedure.addProcedure(request).then(function (response) {
        $('#bsModal').modal('hide');
        self.getProcedure({});
      }).catch(function (err) {
        $('#loadMe').modal('hide');
        self.error = '' + err;
      });
    },
    updateProcedure: function updateProcedure() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var self = this;

      $('#loadMe').modal('show');
      __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__["a" /* services */].Procedure.updateProcedure(request).then(function (response) {
        $('#bsModal').modal('hide');
        self.getProcedure({});
      }).catch(function (err) {
        $('#loadMe').modal('hide');
        self.error = '' + err;
      });
    },
    submit: function submit() {
      if (this.form._id) {
        this.updateProcedure(this.form);
      } else {
        this.addProcedure(this.form);
      }
    },
    searchClick: function searchClick() {
      this.getProcedure(this.search);
    },
    clearClick: function clearClick() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.form).forEach(function (key, index) {
        if (key !== 'totalpages' && key !== 'pages' && key !== 'page') {
          self.search[key] = '';
        }
      });
    },
    pageChange: function pageChange(pageNo) {
      var self = this;
      self.search.page = pageNo;
      this.getProcedure(this.search);
    },
    openFrom: function openFrom(data) {
      if (data) {
        this.form = data;
      }
      $('#bsModal').modal('show');
    }

  }),

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['lang']))
});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cropperjs__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cropperjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_cropperjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_cropperjs_dist_cropper_css__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_cropperjs_dist_cropper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_cropperjs_dist_cropper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_vuex_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_vuex_api_services_config__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(5);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    VueCropper: __WEBPACK_IMPORTED_MODULE_2_vue_cropperjs___default.a,
    'loading': __WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading___default.a
  },
  data: function data() {
    return {
      imgSrc: '',
      cropImg: '',
      postData: null,
      data: null
    };
  },

  mounted: function mounted() {
    this.imgSrc = __WEBPACK_IMPORTED_MODULE_6__src_vuex_api_services_config__["a" /* default */].serverURI + '/avatar/' + this.currentUser.contactNumber;
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])(['currentUser'])),
  methods: {
    upload: function upload() {
      if (this.cropImg.length > 0) {
        var self = this;
        var formData = new FormData();
        this.$refs.cropper.getCroppedCanvas({ maxWidth: 200, maxHeight: 200 }).toBlob(function (blob) {
          formData.append('uploadFile', blob, 'kalam.png');
          formData.append('section', 'profileImage');
          formData.append('filename', 'kalam');
          formData.append('sectionId', 0);

          $('#loadMe').modal('show');
          __WEBPACK_IMPORTED_MODULE_4__src_vuex_api__["a" /* services */].user.uploadProflePhoto(formData).then(function (response) {
            $('#loadMe').modal('hide');
            self.getUsers({});
          }).catch(function (err) {
            $('#loadMe').modal('hide');
            self.error = '' + err;
          });
        });
      }
    },
    cropImage: function cropImage() {
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
      this.data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$refs.cropper.getData(), null, 4);
    },
    flipX: function flipX() {
      var dom = this.$refs.flipX;
      var scale = dom.getAttribute('data-scale');
      scale = scale ? -scale : -1;
      this.$refs.cropper.scaleX(scale);
      dom.setAttribute('data-scale', scale);
    },
    flipY: function flipY() {
      var dom = this.$refs.flipY;
      var scale = dom.getAttribute('data-scale');
      scale = scale ? -scale : -1;
      this.$refs.cropper.scaleY(scale);
      dom.setAttribute('data-scale', scale);
    },
    getCropBoxData: function getCropBoxData() {
      this.data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$refs.cropper.getCropBoxData(), null, 4);
    },
    getData: function getData() {
      this.data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$refs.cropper.getData(), null, 4);
    },
    move: function move(offsetX, offsetY) {
      this.$refs.cropper.move(offsetX, offsetY);
    },
    reset: function reset() {
      this.$refs.cropper.reset();
    },
    rotate: function rotate(deg) {
      this.$refs.cropper.rotate(deg);
    },
    setCropBoxData: function setCropBoxData() {
      if (!this.data) return;
      this.$refs.cropper.setCropBoxData(JSON.parse(this.data));
    },
    setData: function setData() {
      if (!this.data) return;
      this.$refs.cropper.setData(JSON.parse(this.data));
    },
    setImage: function setImage(e) {
      var _this = this;

      var file = e.target.files[0];
      if (file.type.indexOf('image/') === -1) {
        alert('Please select an image file');
        return;
      }
      if (typeof FileReader === 'function') {
        var reader = new FileReader();
        reader.onload = function (event) {
          _this.imgSrc = event.target.result;

          _this.$refs.cropper.replace(event.target.result);
        };
        reader.readAsDataURL(file);
      } else {
        alert('Sorry, FileReader API not supported');
      }
    },
    showFileChooser: function showFileChooser() {
      this.$refs.input.click();
    },
    zoom: function zoom(percent) {
      this.$refs.cropper.relativeZoom(percent);
    }
  }
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_lib_functions__ = __webpack_require__(31);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RationDistributor',
  mounted: function mounted() {
    var self = this;
    var uri = window.location.href.split('?');
    if (uri.length === 2) {
      var vars = uri[1].split('&');
      var getVars = {};
      var tmp = '';
      vars.forEach(function (v) {
        tmp = v.split('=');
        if (tmp.length === 2) {
          getVars[tmp[0]] = tmp[1];
          if (tmp[0] in self.form) {
            self.form[tmp[0]] = tmp[1];
          }
        }
      });
    }
    this.getRationDistributor(self.form);
    this.getLanguage();

    if (localStorage.getItem('lan') != null) this.$i18n.locale = JSON.parse(localStorage.getItem('lan')).language;
    console.log('mounted: got here');
  },
  created: function created() {
    this.getLocations();
  },
  data: function data() {
    return {
      loading: false,
      message: 'RationDistributor list',
      error: [],
      rationdistributors: [],
      locationNames: [],
      form: {
        contactNumber: '',
        name: '',
        idNumber: '',
        ward_village: '',
        city_union: '',
        active: 1,
        location: {}
      },
      search: {
        contactNumber: '',
        name: '',
        idNumber: '',
        ward_village: '',
        city_union: '',
        district: '',
        state: '',
        locationName: '',
        enterBy: '',
        active: -1,
        totalpages: 0,
        page: 0

      },
      customLabels: {
        first: '<<',
        last: '>>',
        previous: '<',
        next: '>'
      },
      listError: __WEBPACK_IMPORTED_MODULE_6__src_lib_functions__["a" /* listError */]
    };
  },
  components: {
    'simple-pagination': __WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination___default.a,
    'loading': __WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['getLanguage']), {
    updateDistrict: function updateDistrict() {
      var self = this.form;
      if (self.location.state.length > 0) {
        self.state = self.location.state;
        self.district = self.location.district;
      }
    },
    getLocations: function getLocations() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__["a" /* services */].Location.getLocation({}).then(function (response) {
        self.locationNames = response.data.docs;
      }).catch(function (error) {
        console.log(error);
      });
    },
    getRationDistributor: function getRationDistributor() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var self = this;

      $('#loadMe').modal('show');
      __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__["a" /* services */].RationDistributor.getRationDistributor(request).then(function (response) {
        self.rationdistributors = response.data.docs;
        self.search.totalpages = Math.ceil(response.data.count / response.data.perpage);
        self.search.page = response.data.page;

        $('#loadMe').modal('hide');
      }).catch(function (error) {
        console.log(error);
      });
    },
    addRationDistributor: function addRationDistributor() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__["a" /* services */].RationDistributor.addRationDistributor(request).then(function (response) {
        self.loading = false;
        $('#bsModal').modal('hide');
        $('#loadMe').modal('show');
        self.getRationDistributor({});
      }).catch(function (err) {
        self.loading = false;
        self.error = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__src_lib_functions__["a" /* listError */])(err.response.data);
      });
    },
    updateRationDistributor: function updateRationDistributor() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__["a" /* services */].RationDistributor.updateRationDistributor(request).then(function (response) {
        self.loading = false;
        $('#bsModal').modal('hide');
        $('#loadMe').modal('show');
        self.getRationDistributor({});
      }).catch(function (err) {
        self.loading = false;
        self.error = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__src_lib_functions__["a" /* listError */])(err.response.data);
      });
    },
    submit: function submit() {
      if (this.form._id) {
        this.updateRationDistributor(this.form);
      } else {
        this.addRationDistributor(this.form);
      }
    },
    searchClick: function searchClick() {
      this.getRationDistributor(this.search);
    },
    clearClick: function clearClick() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.form).forEach(function (key, index) {
        if (key !== 'totalpages' && key !== 'pages' && key !== 'page') {
          self.search[key] = '';
        }
      });
    },
    pageChange: function pageChange(pageNo) {
      var self = this;
      self.search.page = pageNo;
      this.getRationDistributor(this.search);
    },
    openFrom: function openFrom(data) {
      this.error = '';
      if (data) {
        this.form = data;
      }
      $('#bsModal').modal('show');
    }

  }),

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['lang']))
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_lib_functions__ = __webpack_require__(31);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RationLog',
  mounted: function mounted() {
    var self = this;
    var uri = window.location.href.split('?');
    if (uri.length === 2) {
      var vars = uri[1].split('&');
      var getVars = {};
      var tmp = '';
      vars.forEach(function (v) {
        tmp = v.split('=');
        if (tmp.length === 2) {
          getVars[tmp[0]] = tmp[1];
          if (tmp[0] in self.form) {
            self.form[tmp[0]] = tmp[1];
          }
        }
      });
    }
    this.getRationLog(self.form);
    this.getLanguage();
    if (localStorage.getItem('lan') != null) this.$i18n.locale = JSON.parse(localStorage.getItem('lan')).language;
    console.log('mounted: got here');
  },
  data: function data() {
    return {
      loading: false,
      message: 'RationLog list',
      error: [],
      rationlogs: [],
      form: {
        idNumber: '',
        itemDetails: '',
        validity: null
      },
      search: {
        idNumber: '',
        itemDetails: '',
        validity: null,
        enterBy: '',
        insertTime: -1,
        status: -1,
        totalpages: 0,
        page: 0

      },
      customLabels: {
        first: '<<',
        last: '>>',
        previous: '<',
        next: '>'
      },
      listError: __WEBPACK_IMPORTED_MODULE_6__src_lib_functions__["a" /* listError */]
    };
  },
  components: {
    'simple-pagination': __WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination___default.a,
    'loading': __WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['getLanguage']), {

    getRationLog: function getRationLog() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var self = this;

      $('#loadMe').modal('show');
      __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__["a" /* services */].RationLog.getRationLog(request).then(function (response) {
        self.rationlogs = response.data.docs;
        self.search.totalpages = Math.ceil(response.data.count / response.data.perpage);
        self.search.page = response.data.page;

        $('#loadMe').modal('hide');
      }).catch(function (error) {
        console.log(error);
      });
    },
    addRationLog: function addRationLog() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__["a" /* services */].RationLog.addRationLog(request).then(function (response) {
        self.loading = false;
        $('#bsModal').modal('hide');
        $('#loadMe').modal('show');
        self.getRationLog({});
      }).catch(function (err) {
        self.loading = false;
        self.error = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__src_lib_functions__["a" /* listError */])(err.response.data);
      });
    },
    updateRationLog: function updateRationLog() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__["a" /* services */].RationLog.updateRationLog(request).then(function (response) {
        self.loading = false;
        $('#bsModal').modal('hide');
        $('#loadMe').modal('show');
        self.getRationLog({});
      }).catch(function (err) {
        self.loading = false;
        self.error = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__src_lib_functions__["a" /* listError */])(err.response.data);
      });
    },
    submit: function submit() {
      if (this.form._id) {
        this.updateRationLog(this.form);
      } else {
        this.addRationLog(this.form);
      }
    },
    searchClick: function searchClick() {
      this.getRationLog(this.search);
    },
    clearClick: function clearClick() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.form).forEach(function (key, index) {
        if (key !== 'totalpages' && key !== 'pages' && key !== 'page') {
          self.search[key] = '';
        }
      });
    },
    pageChange: function pageChange(pageNo) {
      var self = this;
      self.search.page = pageNo;
      this.getRationLog(this.search);
    },
    openFrom: function openFrom(data) {
      this.error = '';
      if (data) {
        this.form = data;
      }
      $('#bsModal').modal('show');
    }

  }),

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['lang']))
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VAChart__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VAChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_VAChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_vuex_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__ = __webpack_require__(27);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'va-chart': __WEBPACK_IMPORTED_MODULE_0__components_VAChart___default.a
  },
  name: 'Users',
  mounted: function mounted() {
    this.locationLevel = this.$route.query.level === undefined ? 0 : this.$route.query.level;
    this.district = this.$route.query.district === undefined ? '' : this.$route.query.district;
    this.state = this.$route.query.state === undefined ? '' : this.$route.query.state;
    this.citty = this.$route.query.citty === undefined ? '' : this.$route.query.citty;

    var filter = { level: this.locationLevel, state: this.state, district: this.district, city: this.city };
    this.getRequestReport(filter);
    this.getRequestCaseReport(filter);
    this.getLocationReport(filter);
    this.getRequestAgeReport(filter);
  },
  data: function data() {
    return {
      loading: false,
      loading_case: false,
      loading_age: false,
      loading_location: false,
      locationLevel: 0,
      state: '',
      district: '',
      city: '',
      chartData: { type: 'line', data: { datasets: [] } },
      chartCaseDataMale: { type: 'pie', data: { datasets: [] } },
      chartCaseDataFemale: { type: 'pie', data: { datasets: [] } },
      chartAgeDataMale: { type: 'bar', data: { datasets: [] } },
      chartAgeDataFemale: { type: 'bar', data: { datasets: [] } },
      chartDeathDataMale: { type: 'bar', data: { datasets: [] } },
      chartDeathDataFemale: { type: 'bar', data: { datasets: [] } },
      chartLocationData: { type: 'bar', data: { datasets: [] } },
      caseSummary: { total: 0, male: 0, female: 0 },
      ageSummary: { total: 0, male: 0, female: 0 },
      deathSummary: { total: 0, male: 0, female: 0 }
    };
  },

  methods: {
    click: function click(event, array) {
      var area = array[0]._model.label;
      var url = '/hotline-report';
      if (parseInt(this.locationLevel) === 0) {
        url = '/hotline-report?level=1&state=' + area;
      } else if (parseInt(this.locationLevel) === 1) {
        url = '/hotline-report?level=2&state=' + this.state + '&district=' + area;
      } else if (parseInt(this.locationLevel) === 2) {
        url = '/hotline-report?level=3&state=' + this.state + '&district=' + this.district + '&city=' + area;
      }

      window.location.href = url;
    },
    clickBtn: function clickBtn() {
      var _this = this;

      this.loading = !this.loading;
      setTimeout(function () {
        _this.loading = !_this.loading;
      }, 1000);
    },
    getRequestReport: function getRequestReport(filter) {
      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_1__src_vuex_api__["a" /* services */].RequestForRation.getReport(filter).then(function (response) {
        var chartData = response.data;
        var datas = [];
        var dataLine = [];
        var lebels = [];
        chartData.forEach(function (element) {
          var date = element._id.day + '/' + element._id.month + '/' + element._id.year;
          lebels.push(date);
          datas.push(element.count);
          dataLine.push({ y: element.count, x: date });
        });

        var chart = {
          type: 'line',
          data: {
            labels: lebels,
            datasets: [{
              label: __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('number_of_request'),
              data: datas
            }]
          },
          stroke: {
            curve: 'straight'
          },
          title: {
            text: __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('case_trend'),
            align: 'left'
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'],
              opacity: 0.5
            }
          }
        };
        self.chartData = chart;
        self.loading = false;
      }).catch(function (error) {
        console.log(error);
        self.loading = false;
      });
    },
    getRequestCaseReport: function getRequestCaseReport(filter) {
      var self = this;
      self.loading_case = true;
      __WEBPACK_IMPORTED_MODULE_1__src_vuex_api__["a" /* services */].RequestForRation.getCaseReport(filter).then(function (response) {
        var chartData = response.data;
        var datas_male = [0, 0, 0, 0];
        var datas_female = [0, 0, 0, 0];
        var lebels = __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('rationRequestStatus');
        var defaultCase = 0;
        chartData.forEach(function (element) {
          self.caseSummary.total = self.caseSummary.total + element.count;
          defaultCase = element._id.status === undefined ? 0 : element._id.status;
          if (element._id.gender === 0) {
            datas_male[defaultCase] = datas_male[defaultCase] + element.count;
            self.caseSummary.male = self.caseSummary.male + element.count;
          } else if (element._id.gender === 1) {
            datas_female[defaultCase] = datas_female[defaultCase] + element.count;
            self.caseSummary.female = self.caseSummary.female + element.count;
          }
        });

        var BGColor = ['#11baed', '#f2b407', '#1db345', '#f50539'];
        var HoverColor = ['#11baed', '#f2b407', '#1db345', '#f50539'];
        var chart_male = {
          type: 'pie',
          data: {
            labels: lebels,
            datasets: [{
              data: datas_male,
              backgroundColor: BGColor,
              hoverBackgroundColor: HoverColor
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: true,
            legend: {
              position: 'bottom',
              display: true
            }
          }
        };

        var chart_female = {
          type: 'pie',
          data: {
            labels: lebels,
            datasets: [{
              data: datas_female,
              backgroundColor: BGColor,
              hoverBackgroundColor: HoverColor
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: true,
            legend: {
              position: 'bottom',
              display: true
            }
          }
        };
        self.chartCaseDataMale = chart_male;
        self.chartCaseDataFemale = chart_female;
        self.loading_case = false;
      }).catch(function (error) {
        console.log(error);
        self.loading_case = false;
      });
    },
    getRequestAgeReport: function getRequestAgeReport(filter) {
      var self = this;
      self.loading_age = true;
      __WEBPACK_IMPORTED_MODULE_1__src_vuex_api__["a" /* services */].RequestForRation.getStatusReport(filter).then(function (response) {
        var chartData = response.data;
        var datas_male = [0, 0, 0, 0, 0];
        var datas_female = [0, 0, 0, 0, 0];
        var datas_male_d = [0, 0, 0, 0, 0];
        var datas_female_d = [0, 0, 0, 0, 0];
        var datas_male_c = [0, 0, 0, 0, 0];
        var datas_female_c = [0, 0, 0, 0, 0];
        var lebels = __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('ageGroupRation');
        var ageGroup = 0;
        chartData.forEach(function (element) {
          ageGroup = element._id.ageGroup === undefined ? 0 : element._id.ageGroup;
          self.ageSummary.total = self.ageSummary.total + element.count;
          if (element._id.gender === 0) {
            self.ageSummary.male = self.ageSummary.male + element.count;
            datas_male[ageGroup] = datas_male[ageGroup] + element.count;
            if (element._id.status === 2) {
              datas_male_d[ageGroup] = datas_male_d[ageGroup] + element.count;
            } else if (element._id.status === 3) {
              datas_male_c[ageGroup] = datas_male_c[ageGroup] + element.count;
            }
          } else if (element._id.gender === 1) {
            self.ageSummary.female = self.ageSummary.female + element.count;
            datas_female[ageGroup] = datas_female[ageGroup] + element.count;
            if (element._id.status === 2) {
              datas_female_d[ageGroup] = datas_female_d[ageGroup] + element.count;
            } else if (element._id.status === 3) {
              datas_female_c[ageGroup] = datas_female_c[ageGroup] + element.count;
            }
          }
        });

        var BGColor = ['#237ff7', '#23f738', '#00c0ef', '#f0df24', '#f07c24', '#ed2d1f'];
        var BGColorHover = ['#237ff7', '#23f738', '#00c0ef', '#f0df24', '#f07c24', '#ed2d1f'];
        var chart_male = {
          type: 'bar',
          data: {
            labels: lebels,
            datasets: [{
              label: __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('total_request_male'),
              data: datas_male,
              backgroundColor: BGColor[0],
              hoverBackgroundColor: BGColorHover[0],
              borderColor: '#344ceb',
              borderWidth: 2
            }, {
              label: __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('total_delivered_male'),
              data: datas_male_d,
              backgroundColor: BGColor[1],
              hoverBackgroundColor: BGColorHover[1],
              borderColor: '#344ceb',
              borderWidth: 2
            }, {
              label: __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('total_canceled_male'),
              data: datas_male_c,
              backgroundColor: BGColor[2],
              hoverBackgroundColor: BGColorHover[2],
              borderColor: '#344ceb',
              borderWidth: 2
            }, {
              label: __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('total_request_female'),
              data: datas_female,
              backgroundColor: BGColor[3],
              hoverBackgroundColor: BGColorHover[3],
              borderColor: '#ff3bf2',
              borderWidth: 2
            }, {
              label: __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('total_delivered_female'),
              data: datas_female_d,
              backgroundColor: BGColor[4],
              hoverBackgroundColor: BGColorHover[4],
              borderColor: '#ff3bf2',
              borderWidth: 2
            }, {
              label: __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('total_cancel_female'),
              data: datas_female_c,
              backgroundColor: BGColor[5],
              hoverBackgroundColor: BGColorHover[5],
              borderColor: '#ff3bf2',
              borderWidth: 2
            }]
          },
          options: {
            scales: {
              xAxes: [{
                stacked: false
              }],
              yAxes: [{
                stacked: false
              }]
            }
          }
        };

        var chart_female = {
          type: 'bar',
          data: {
            labels: lebels,
            datasets: [{
              label: self.caseSummary.female,
              data: datas_female,
              backgroundColor: BGColor,
              hoverBackgroundColor: BGColorHover
            }]
          },
          options: {
            scales: {
              xAxes: [{
                stacked: true
              }],
              yAxes: [{
                stacked: true
              }]
            }
          }
        };

        self.chartAgeDataMale = chart_male;
        self.loading_age = false;
      }).catch(function (error) {
        console.log(error);
        self.loading_age = false;
      });
    },
    getLocationReport: function getLocationReport(filter) {
      var self = this;
      self.loading_location = true;
      __WEBPACK_IMPORTED_MODULE_1__src_vuex_api__["a" /* services */].RequestForRation.getAreaReport(filter).then(function (response) {
        var chartData = response.data;
        var datas_total = [];
        var datas_delivered = [];
        var datas_cancelled = [];
        var lebels = [];
        var area = '';
        var areaIndex = -1;
        var currentIndex = 0;
        chartData.forEach(function (element) {
          area = element._id.area;
          areaIndex = lebels.indexOf(area);
          currentIndex = lebels.length;
          if (areaIndex === -1) {
            lebels[currentIndex] = area;
          } else {
            currentIndex = areaIndex;
          }
          datas_total[currentIndex] = (datas_total[currentIndex] === undefined ? 0 : datas_total[currentIndex]) + element.count;

          if (element._id.status === 3) {
            datas_cancelled[currentIndex] = (datas_cancelled[currentIndex] === undefined ? 0 : datas_cancelled[currentIndex]) + element.count;
          } else if (element._id.status === 2) {
            datas_delivered[currentIndex] = (datas_delivered[currentIndex] === undefined ? 0 : datas_delivered[currentIndex]) + element.count;
          }
        });
        var BGColor = ['#ebc634', '#11c255', '#bf0b1d'];
        var BGColorHover = ['#eb7434', '#023806', '#63040a'];
        var chart_location = {
          type: 'bar',
          data: {
            labels: lebels,
            datasets: [{
              label: __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('request'),
              data: datas_total,
              backgroundColor: BGColor[0],
              hoverBackgroundColor: BGColorHover[0],
              borderColor: BGColorHover[0],
              borderWidth: 2
            }, {
              label: __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('delivered'),
              data: datas_delivered,
              backgroundColor: BGColor[1],
              hoverBackgroundColor: BGColorHover[1],
              borderColor: BGColorHover[1],
              borderWidth: 2
            }, {
              label: __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('canceled'),
              data: datas_cancelled,
              backgroundColor: BGColor[2],
              hoverBackgroundColor: BGColorHover[2],
              borderColor: BGColorHover[2],
              borderWidth: 2
            }]
          },
          options: {
            onClick: function onClick(evt, array) {
              self.click(evt, array);
            },
            scales: {
              xAxes: [{
                stacked: false
              }],
              yAxes: [{
                stacked: false,
                ticks: {
                  beginAtZero: true
                }
              }]
            }
          }
        };

        self.chartLocationData = chart_location;
        self.loading_location = false;
      }).catch(function (error) {
        console.log(error);
        self.loading_location = false;
      });
    }
  }
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_vuex_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_lib_functions__ = __webpack_require__(31);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Users',
  mounted: function mounted() {
    this.center = { lat: this.currentUser.location.coordinates[1], lng: this.currentUser.location.coordinates[0] };
    this.getLocations();
  },
  data: function data() {
    return {
      center: {},
      markers: [],
      getMap: this.$root.mapping,
      description: '',
      latval: 23,
      lngval: 90,
      latLng: {},
      place: null,
      loading: false,
      error: '',
      success: '',
      getIcon: __WEBPACK_IMPORTED_MODULE_3__src_lib_functions__["b" /* getIcon */]
    };
  },

  methods: {
    getLocations: function getLocations() {
      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_1__src_vuex_api__["a" /* services */].patients.getLocationReport({}).then(function (response) {
        var chartData = response.data;
        var datas = [];
        chartData.forEach(function (element) {
          if (element.location !== undefined) {
            var marker = { position: { lat: element.location.coordinates[1], lng: element.location.coordinates[0] }, status: element.status };
          } else {}
          datas.push(marker);
        });
        console.log(datas);
        self.markers = datas;
        self.loading = false;
      }).catch(function (error) {
        console.log(error);
        self.loading = false;
      });
    },
    clickBtn: function clickBtn() {
      var _this = this;

      this.loading = !this.loading;
      setTimeout(function () {
        _this.loading = !_this.loading;
      }, 1000);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['currentUser'])),
  created: function created() {
    this.center = { lat: this.currentUser.location.coordinates[1], lng: this.currentUser.location.coordinates[0] };
  }
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VAChart__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VAChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_VAChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_vuex_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__ = __webpack_require__(27);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'va-chart': __WEBPACK_IMPORTED_MODULE_0__components_VAChart___default.a
  },
  name: 'Users',
  mounted: function mounted() {
    this.getPatientReport();
    this.getPatientCaseReport();
    this.getPatientAgeReport();
    this.getDeathReport();
  },
  data: function data() {
    return {
      loading: false,
      loading_case: false,
      loading_age: false,
      loading_death: false,
      chartData: { type: 'line', data: { datasets: [] } },
      chartCaseDataMale: { type: 'pie', data: { datasets: [] } },
      chartCaseDataFemale: { type: 'pie', data: { datasets: [] } },
      chartAgeDataMale: { type: 'bar', data: { datasets: [] } },
      chartAgeDataFemale: { type: 'bar', data: { datasets: [] } },
      chartDeathDataMale: { type: 'bar', data: { datasets: [] } },
      chartDeathDataFemale: { type: 'bar', data: { datasets: [] } },
      caseSummary: { total: 0, male: 0, female: 0 },
      ageSummary: { total: 0, male: 0, female: 0 },
      deathSummary: { total: 0, male: 0, female: 0 }
    };
  },

  methods: {
    clickBtn: function clickBtn() {
      var _this = this;

      this.loading = !this.loading;
      setTimeout(function () {
        _this.loading = !_this.loading;
      }, 1000);
    },
    getPatientReport: function getPatientReport() {
      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_1__src_vuex_api__["a" /* services */].patients.getReport({}).then(function (response) {
        var chartData = response.data;
        var datas = [];
        var dataLine = [];
        var lebels = [];
        chartData.forEach(function (element) {
          var date = element._id.day + '/' + element._id.month + '/' + element._id.year;
          lebels.push(date);
          datas.push(element.count);
          dataLine.push({ y: element.count, x: date });
        });

        var chart = {
          type: 'line',
          data: {
            labels: lebels,
            datasets: [{
              label: __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('number_of_cases'),
              data: datas
            }]
          },
          stroke: {
            curve: 'straight'
          },
          title: {
            text: __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('case_trend'),
            align: 'left'
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'],
              opacity: 0.5
            }
          }
        };
        self.chartData = chart;
        self.loading = false;
      }).catch(function (error) {
        console.log(error);
        self.loading = false;
      });
    },
    getPatientCaseReport: function getPatientCaseReport() {
      var self = this;
      self.loading_case = true;
      __WEBPACK_IMPORTED_MODULE_1__src_vuex_api__["a" /* services */].patients.getCaseReport({}).then(function (response) {
        var chartData = response.data;
        var datas_male = [0, 0, 0];
        var datas_female = [0, 0, 0];
        var lebels = __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('casesData');
        var defaultCase = 0;
        chartData.forEach(function (element) {
          self.caseSummary.total = self.caseSummary.total + element.count;
          defaultCase = element._id.caseType === undefined ? 0 : element._id.caseType;
          if (element._id.gender === 0) {
            datas_male[defaultCase] = datas_male[defaultCase] + element.count;
            self.caseSummary.male = self.caseSummary.male + element.count;
          } else if (element._id.gender === 1) {
            datas_female[defaultCase] = datas_female[defaultCase] + element.count;
            self.caseSummary.female = self.caseSummary.female + element.count;
          }
        });

        var chart_male = {
          type: 'pie',
          data: {
            labels: lebels,
            datasets: [{
              data: datas_male,
              backgroundColor: ['#f50539', '#f39c12', '#00c0ef'],
              hoverBackgroundColor: ['#f50ac2', '#f39c12', '#00c0ef']
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: true,
            legend: {
              position: 'bottom',
              display: true
            }
          }
        };

        var chart_female = {
          type: 'pie',
          data: {
            labels: lebels,
            datasets: [{
              data: datas_female,
              backgroundColor: ['#f50539', '#f39c12', '#00c0ef'],
              hoverBackgroundColor: ['#f50ac2', '#f39c12', '#00c0ef']
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: true,
            legend: {
              position: 'bottom',
              display: true
            }
          }
        };
        self.chartCaseDataMale = chart_male;
        self.chartCaseDataFemale = chart_female;
        self.loading_case = false;
      }).catch(function (error) {
        console.log(error);
        self.loading_case = false;
      });
    },
    getPatientAgeReport: function getPatientAgeReport() {
      var self = this;
      self.loading_age = true;
      __WEBPACK_IMPORTED_MODULE_1__src_vuex_api__["a" /* services */].patients.getStatusReport({}).then(function (response) {
        var chartData = response.data;
        var datas_male = [0, 0, 0, 0, 0, 0];
        var datas_female = [0, 0, 0, 0, 0, 0];
        var lebels = __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('ageGroup');
        var defaultCase = 0;
        chartData.forEach(function (element) {
          defaultCase = element._id.caseType === undefined ? 0 : element._id.caseType;
          self.ageSummary.total = self.ageSummary.total + element.count;
          if (element._id.gender === 0) {
            datas_male[element._id.ageGroup] = element.count;
            self.ageSummary.male = self.ageSummary.male + element.count;
          } else if (element._id.gender === 1) {
            datas_female[element._id.ageGroup] = element.count;
            self.ageSummary.female = self.ageSummary.female + element.count;
          }
        });

        var BGColor = ['#237ff7', '#23f738', '#00c0ef', '#f0df24', '#f07c24', '#ed2d1f'];
        var BGColorHover = ['#237ff7', '#23f738', '#00c0ef', '#f0df24', '#f07c24', '#ed2d1f'];
        var chart_male = {
          type: 'bar',
          data: {
            labels: lebels,
            datasets: [{
              label: self.caseSummary.male,
              data: datas_male,
              backgroundColor: BGColor,
              hoverBackgroundColor: BGColorHover
            }]
          },
          options: {
            scales: {
              xAxes: [{
                stacked: true
              }],
              yAxes: [{
                stacked: true
              }]
            }
          }
        };

        var chart_female = {
          type: 'bar',
          data: {
            labels: lebels,
            datasets: [{
              label: self.caseSummary.female,
              data: datas_female,
              backgroundColor: BGColor,
              hoverBackgroundColor: BGColorHover
            }]
          },
          options: {
            scales: {
              xAxes: [{
                stacked: true
              }],
              yAxes: [{
                stacked: true
              }]
            }
          }
        };
        self.chartAgeDataMale = chart_male;
        self.chartAgeDataFemale = chart_female;
        self.loading_age = false;
      }).catch(function (error) {
        console.log(error);
        self.loading_age = false;
      });
    },
    getDeathReport: function getDeathReport() {
      var self = this;
      self.loading_death = true;
      __WEBPACK_IMPORTED_MODULE_1__src_vuex_api__["a" /* services */].patients.getStatusReport({ condition: 1, status: 8 }).then(function (response) {
        var chartData = response.data;
        var datas_male = [0, 0, 0, 0, 0, 0];
        var datas_female = [0, 0, 0, 0, 0, 0];
        var lebels = __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('ageGroup');
        var defaultCase = 0;
        chartData.forEach(function (element) {
          defaultCase = element._id.caseType === undefined ? 0 : element._id.caseType;
          self.deathSummary.total = self.deathSummary.total + element.count;
          if (element._id.gender === 0) {
            datas_male[element._id.ageGroup] = element.count;
            self.deathSummary.male = self.deathSummary.male + element.count;
          } else if (element._id.gender === 1) {
            datas_female[element._id.ageGroup] = element.count;
            self.deathSummary.female = self.deathSummary.female + element.count;
          }
        });

        var BGColor = ['#237ff7', '#23f738', '#00c0ef', '#f0df24', '#f07c24', '#ed2d1f'];
        var BGColorHover = ['#237ff7', '#23f738', '#00c0ef', '#f0df24', '#f07c24', '#ed2d1f'];
        var chart_male = {
          type: 'doughnut',
          data: {
            labels: lebels,
            datasets: [{
              data: datas_male,
              backgroundColor: BGColor,
              hoverBackgroundColor: BGColorHover
            }]
          },
          options: {
            animation: {
              animateScale: true
            }
          }
        };

        var chart_female = {
          type: 'doughnut',
          data: {
            labels: lebels,
            datasets: [{
              data: datas_female,
              backgroundColor: BGColor,
              hoverBackgroundColor: BGColorHover
            }]
          },
          options: {
            animation: {
              animateScale: true
            }
          }
        };
        self.chartDeathDataMale = chart_male;
        self.chartDeathDataFemale = chart_female;
        self.loading_death = false;
      }).catch(function (error) {
        console.log(error);
        self.loading_death = false;
      });
    }
  }
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_lib_functions__ = __webpack_require__(31);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RequestForRation',
  mounted: function mounted() {
    var _this = this;

    var self = this;
    var uri = window.location.href.split('?');
    if (uri.length === 2) {
      var vars = uri[1].split('&');
      var getVars = {};
      var tmp = '';
      vars.forEach(function (v) {
        tmp = v.split('=');
        if (tmp.length === 2) {
          getVars[tmp[0]] = tmp[1];
          if (tmp[0] in self.form) {
            self.form[tmp[0]] = tmp[1];
          }
        }
      });
    }
    this.getRequestForRation(self.form);
    this.getLanguage();
    if (localStorage.getItem('lan') != null) this.$i18n.locale = JSON.parse(localStorage.getItem('lan')).language;
    this.$on('input', function (event) {
      if (event.target.name === 'age') {
        self.form.yob = _this.currentYear - parseInt(event.target.value);
        _this.updateYoB();
      }
    });
  },
  data: function data() {
    return {
      currentYear: new Date().getFullYear(),
      loading: false,
      message: 'RequestForRation list',
      error: [],
      requestforrations: [],
      form: {
        contactNumber: '',
        name: '',
        idNumber: '',
        yob: -1,
        gender: 0,
        address: '',
        city: '',
        state: '',
        locationName: '',
        zipcode: '',
        age: null
      },
      search: {
        contactNumber: '',
        name: '',
        idNumber: '',
        yob1: null,
        yob2: null,
        gender: null,
        address: '',
        city: '',
        locationName: '',
        zipcode: '',
        insertTime: null,
        status: null,
        totalpages: 0,
        page: 0

      },
      customLabels: {
        first: '<<',
        last: '>>',
        previous: '<',
        next: '>'
      },
      listError: __WEBPACK_IMPORTED_MODULE_6__src_lib_functions__["a" /* listError */]
    };
  },
  components: {
    'simple-pagination': __WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination___default.a,
    'loading': __WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['getLanguage']), {

    getRequestForRation: function getRequestForRation() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var self = this;

      $('#loadMe').modal('show');
      __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__["a" /* services */].RequestForRation.getRequestForRation(request).then(function (response) {
        self.requestforrations = response.data.docs;
        self.search.totalpages = Math.ceil(response.data.count / response.data.perpage);
        self.search.page = response.data.page;

        $('#loadMe').modal('hide');
      }).catch(function (error) {
        console.log(error);
      });
    },
    addRequestForRation: function addRequestForRation() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__["a" /* services */].RequestForRation.addRequestForRation(request).then(function (response) {
        self.loading = false;
        $('#bsModal').modal('hide');
        $('#loadMe').modal('show');
        self.getRequestForRation({});
      }).catch(function (err) {
        self.loading = false;
        self.error = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__src_lib_functions__["a" /* listError */])(err.response.data);
      });
    },
    updateRequestForRation: function updateRequestForRation() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__["a" /* services */].RequestForRation.updateRequestForRation(request).then(function (response) {
        self.loading = false;
        $('#bsModal').modal('hide');
        $('#loadMe').modal('show');
        self.getRequestForRation({});
      }).catch(function (err) {
        self.loading = false;
        self.error = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__src_lib_functions__["a" /* listError */])(err.response.data);
      });
    },
    updateYoB: function updateYoB() {
      this.form.yob = this.currentYear - parseInt(this.form.age);
    },
    updateAge: function updateAge() {
      this.form.age = this.currentYear - parseInt(this.form.yob);
    },
    submit: function submit() {
      if (this.form._id) {
        this.form.age = this.currentYear - this.form.yob;
        this.updateRequestForRation(this.form);
      } else {
        this.addRequestForRation(this.form);
      }
    },
    searchClick: function searchClick() {
      this.getRequestForRation(this.search);
    },
    clearClick: function clearClick() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.form).forEach(function (key, index) {
        if (key !== 'totalpages' && key !== 'pages' && key !== 'page') {
          self.search[key] = '';
        }
      });
    },
    pageChange: function pageChange(pageNo) {
      var self = this;
      self.search.page = pageNo;
      this.getRequestForRation(this.search);
    },
    openFrom: function openFrom(data) {
      this.error = '';
      if (data) {
        this.form = data;
      }
      $('#bsModal').modal('show');
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['lang']))
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Task',
  mounted: function mounted() {
    var self = this;
    var uri = window.location.href.split('?');
    if (uri.length === 2) {
      var vars = uri[1].split('&');
      var getVars = {};
      var tmp = '';
      vars.forEach(function (v) {
        tmp = v.split('=');
        if (tmp.length === 2) {
          getVars[tmp[0]] = tmp[1];
          if (tmp[0] in self.form) {
            self.form[tmp[0]] = tmp[1];
          }
        }
      });
    }
    this.getTask(self.form);
    this.getLanguage();
    if (localStorage.getItem('lan') != null) this.$i18n.locale = JSON.parse(localStorage.getItem('lan')).language;
    console.log('mounted: got here');
  },
  data: function data() {
    return {
      loading: false,
      message: 'Task list',
      error: '',
      tasks: [],
      form: {
        contactNumber: '',
        patientId: '',
        patientName: '',
        patientContact: '',
        taskGroup: -1,
        taskType: [],
        priority: -1,
        comments: ''
      },
      search: {
        contactNumber: '',
        patientName: '',
        patientContact: '',
        taskGroup: -1,
        taskType: [],
        priority: -1,
        status: -1,
        totalpages: 0,
        page: 0

      },
      customLabels: {
        first: '<<',
        last: '>>',
        previous: '<',
        next: '>'
      }
    };
  },
  components: {
    'simple-pagination': __WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination___default.a,
    'loading': __WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['getLanguage']), {

    getTask: function getTask() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var self = this;

      $('#loadMe').modal('show');
      __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__["a" /* services */].Task.getTask(request).then(function (response) {
        self.tasks = response.data.docs;
        self.search.totalpages = Math.ceil(response.data.count / response.data.perpage);
        self.search.page = response.data.page;

        $('#loadMe').modal('hide');
      }).catch(function (error) {
        console.log(error);
      });
    },
    addTask: function addTask() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var self = this;

      $('#loadMe').modal('show');
      __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__["a" /* services */].Task.addTask(request).then(function (response) {
        $('#bsModal').modal('hide');
        self.getTask({});
      }).catch(function (err) {
        $('#loadMe').modal('hide');
        self.error = '' + err;
      });
    },
    updateTask: function updateTask() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var self = this;

      $('#loadMe').modal('show');
      __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__["a" /* services */].Task.updateTask(request).then(function (response) {
        $('#bsModal').modal('hide');
        self.getTask({});
      }).catch(function (err) {
        $('#loadMe').modal('hide');
        self.error = '' + err;
      });
    },
    submit: function submit() {
      if (this.form._id) {
        this.updateTask(this.form);
      } else {
        this.addTask(this.form);
      }
    },
    searchClick: function searchClick() {
      this.getTask(this.search);
    },
    clearClick: function clearClick() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.form).forEach(function (key, index) {
        if (key !== 'totalpages' && key !== 'pages' && key !== 'page') {
          self.search[key] = '';
        }
      });
    },
    pageChange: function pageChange(pageNo) {
      var self = this;
      self.search.page = pageNo;
      this.getTask(this.search);
    },
    openFrom: function openFrom(data) {
      if (data) {
        this.form = data;
      }
      $('#bsModal').modal('show');
    }

  }),

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['lang']))
});

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TransportRequest',
  mounted: function mounted() {
    var self = this;
    var uri = window.location.href.split('?');
    if (uri.length === 2) {
      var vars = uri[1].split('&');
      var getVars = {};
      var tmp = '';
      vars.forEach(function (v) {
        tmp = v.split('=');
        if (tmp.length === 2) {
          getVars[tmp[0]] = tmp[1];
          if (tmp[0] in self.form) {
            self.form[tmp[0]] = tmp[1];
          }
        }
      });
    }
    this.getTransportRequest(self.form);
    this.getLanguage();
    if (localStorage.getItem('lan') != null) this.$i18n.locale = JSON.parse(localStorage.getItem('lan')).language;
    console.log('mounted: got here');
  },
  data: function data() {
    return {
      loading: false,
      message: 'TransportRequest list',
      error: '',
      transportrequests: [],
      form: {
        contactNumber: '',
        name: '',
        itemType: -1,
        approxQuantity: -1,
        packagingType: -1,
        packageQuantity: -1,
        pickupPointName: '',
        pickupPoint: [],
        deliveryPoint: [],
        deliveryName: ''
      },
      search: {
        contactNumber: '',
        itemType: -1,
        approxQuantity: -1,
        packagingType: -1,
        pickupPointName: '',
        deliveryAddress: '',
        requestType: -1,
        insertTime: -1,
        plateNumber: '',
        driverContact: '',
        status: -1,
        totalpages: 0,
        page: 0

      },
      customLabels: {
        first: '<<',
        last: '>>',
        previous: '<',
        next: '>'
      }
    };
  },
  components: {
    'simple-pagination': __WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination___default.a,
    'loading': __WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['getLanguage']), {

    getTransportRequest: function getTransportRequest() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var self = this;

      $('#loadMe').modal('show');
      __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__["a" /* services */].TransportRequest.getTransportRequest(request).then(function (response) {
        self.transportrequests = response.data.docs;
        self.search.totalpages = Math.ceil(response.data.count / response.data.perpage);
        self.search.page = response.data.page;

        $('#loadMe').modal('hide');
      }).catch(function (error) {
        console.log(error);
      });
    },
    addTransportRequest: function addTransportRequest() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var self = this;

      $('#loadMe').modal('show');
      __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__["a" /* services */].TransportRequest.addTransportRequest(request).then(function (response) {
        $('#bsModal').modal('hide');
        self.getTransportRequest({});
      }).catch(function (err) {
        $('#loadMe').modal('hide');
        self.error = '' + err;
      });
    },
    updateTransportRequest: function updateTransportRequest() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var self = this;

      $('#loadMe').modal('show');
      __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__["a" /* services */].TransportRequest.updateTransportRequest(request).then(function (response) {
        $('#bsModal').modal('hide');
        self.getTransportRequest({});
      }).catch(function (err) {
        $('#loadMe').modal('hide');
        self.error = '' + err;
      });
    },
    submit: function submit() {
      if (this.form._id) {
        this.updateTransportRequest(this.form);
      } else {
        this.addTransportRequest(this.form);
      }
    },
    searchClick: function searchClick() {
      this.getTransportRequest(this.search);
    },
    clearClick: function clearClick() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.form).forEach(function (key, index) {
        if (key !== 'totalpages' && key !== 'pages' && key !== 'page') {
          self.search[key] = '';
        }
      });
    },
    pageChange: function pageChange(pageNo) {
      var self = this;
      self.search.page = pageNo;
      this.getTransportRequest(this.search);
    },
    openFrom: function openFrom(data) {
      this.error = '';
      if (data) {
        this.form = data;
      }
      $('#bsModal').modal('show');
    }

  }),

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['lang']))
});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_lib_functions__ = __webpack_require__(31);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TransportVehicle',
  mounted: function mounted() {
    var self = this;
    var uri = window.location.href.split('?');
    if (uri.length === 2) {
      var vars = uri[1].split('&');
      var getVars = {};
      var tmp = '';
      vars.forEach(function (v) {
        tmp = v.split('=');
        if (tmp.length === 2) {
          getVars[tmp[0]] = tmp[1];
          if (tmp[0] in self.form) {
            self.form[tmp[0]] = tmp[1];
          }
        }
      });
    }
    this.getTransportVehicle(self.form);
    this.getLanguage();
    if (localStorage.getItem('lan') != null) this.$i18n.locale = JSON.parse(localStorage.getItem('lan')).language;
    console.log('mounted: got here');
  },
  data: function data() {
    return {
      loading: false,
      message: 'TransportVehicle list',
      error: [],
      transportvehicles: [],
      form: {
        contactNumber: '',
        name: '',
        idNumber: '',
        registrationNumber: '',
        capacity: -1,
        loadingSetting: []
      },
      search: {
        contactNumber: '',
        name: '',
        idNumber: '',
        registrationNumber: '',
        capacity: -1,
        insertTime: -1,
        status: -1,
        loadingSetting: [],
        totalpages: 0,
        page: 0

      },
      customLabels: {
        first: '<<',
        last: '>>',
        previous: '<',
        next: '>'
      },
      listError: __WEBPACK_IMPORTED_MODULE_6__src_lib_functions__["a" /* listError */]
    };
  },
  components: {
    'simple-pagination': __WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination___default.a,
    'loading': __WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['getLanguage']), {

    getTransportVehicle: function getTransportVehicle() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var self = this;

      $('#loadMe').modal('show');
      __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__["a" /* services */].TransportVehicle.getTransportVehicle(request).then(function (response) {
        self.transportvehicles = response.data.docs;
        self.search.totalpages = Math.ceil(response.data.count / response.data.perpage);
        self.search.page = response.data.page;

        $('#loadMe').modal('hide');
      }).catch(function (error) {
        console.log(error);
      });
    },
    addTransportVehicle: function addTransportVehicle() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__["a" /* services */].TransportVehicle.addTransportVehicle(request).then(function (response) {
        $('#bsModal').modal('hide');
        $('#loadMe').modal('show');
        self.loading = false;
        self.getTransportVehicle({});
      }).catch(function (err) {
        self.loading = false;
        self.error = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__src_lib_functions__["a" /* listError */])(err.response.data);
      });
    },
    updateTransportVehicle: function updateTransportVehicle() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__["a" /* services */].TransportVehicle.updateTransportVehicle(request).then(function (response) {
        self.loading = false;
        $('#loadMe').modal('show');
        $('#bsModal').modal('hide');
        self.getTransportVehicle({});
      }).catch(function (err) {
        self.loading = false;
        self.error = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__src_lib_functions__["a" /* listError */])(err.response.data);
      });
    },
    submit: function submit() {
      if (this.form._id) {
        this.updateTransportVehicle(this.form);
      } else {
        this.addTransportVehicle(this.form);
      }
    },
    searchClick: function searchClick() {
      this.getTransportVehicle(this.search);
    },
    clearClick: function clearClick() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.form).forEach(function (key, index) {
        if (key !== 'totalpages' && key !== 'pages' && key !== 'page') {
          self.search[key] = '';
        }
      });
    },
    pageChange: function pageChange(pageNo) {
      var self = this;
      self.search.page = pageNo;
      this.getTransportVehicle(this.search);
    },
    openFrom: function openFrom(data) {
      this.error = [];
      this.loading = false;
      if (data) {
        this.form = data;
      }
      $('#bsModal').modal('show');
    }

  }),

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['lang']))
});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Users',

  mounted: function mounted() {
    var self = this;
    var uri = window.location.href.split('?');
    if (uri.length === 2) {
      var vars = uri[1].split('&');
      var getVars = {};
      var tmp = '';
      vars.forEach(function (v) {
        tmp = v.split('=');
        if (tmp.length === 2) {
          getVars[tmp[0]] = tmp[1];
          if (tmp[0] in self.form) {
            self.form[tmp[0]] = tmp[1];
          }
        }
      });
    }
    this.getUsers(self.form);
    this.getLanguage();
    if (localStorage.getItem('lan') != null) this.$i18n.locale = JSON.parse(localStorage.getItem('lan')).language;
    console.log('mounted: got here');
  },
  data: function data() {
    return {
      loading: false,
      message: 'Users list',
      error: '',
      users: [],
      user: {
        name: '',
        userType: null,
        contactNumber: '',
        userOptionsConsultant: [],
        userOptionsAmbulance: [],
        userOptionsDelivery: []
      },
      form: {
        name: '',
        contactNumber: '',
        userType: null,
        userOptionsConsultant: -1,
        userOptionsAmbulance: -1,
        userOptionsDelivery: -1,
        totalpages: 0,
        page: 0

      },
      customLabels: {
        first: '<<',
        last: '>>',
        previous: '<',
        next: '>'
      }
    };
  },
  components: {
    'simple-pagination': __WEBPACK_IMPORTED_MODULE_4__src_components_simple_pagination___default.a,
    'loading': __WEBPACK_IMPORTED_MODULE_5__src_widgets_VALoading___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['getLanguage']), {

    getUsers: function getUsers() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var self = this;

      $('#loadMe').modal('show');
      __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__["a" /* services */].user.getUserList(request).then(function (response) {
        self.users = response.data.docs;
        self.form.totalpages = Math.ceil(response.data.count / response.data.perpage);
        self.form.page = response.data.page;

        $('#loadMe').modal('hide');
      }).catch(function (error) {
        console.log(error);
        $('#loadMe').modal('hide');
      });
    },
    addUser: function addUser() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var self = this;

      $('#loadMe').modal('show');
      __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__["a" /* services */].user.addUser(request).then(function (response) {
        $('#bsModal').modal('hide');
        self.getUsers({});
      }).catch(function (err) {
        $('#loadMe').modal('hide');
        self.error = '' + err;
      });
    },
    updateUser: function updateUser() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var self = this;

      $('#loadMe').modal('show');
      __WEBPACK_IMPORTED_MODULE_2__src_vuex_api__["a" /* services */].user.updateUser(request).then(function (response) {
        $('#bsModal').modal('hide');
        self.getUsers({});
      }).catch(function (err) {
        $('#loadMe').modal('hide');
        self.error = '' + err;
      });
    },
    submit: function submit() {
      if (this.user._id) {
        this.updateUser(this.user);
      } else {
        this.addUser(this.user);
      }
    },
    searchClick: function searchClick() {
      this.getUsers(this.form);
    },
    clearClick: function clearClick() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.form).forEach(function (key, index) {
        if (key !== 'totalpages' && key !== 'pages' && key !== 'page') {
          self.form[key] = '';
        }
      });
    },
    pageChange: function pageChange(pageNo) {
      var self = this;
      self.form.page = pageNo;
      this.getUsers(this.form);
    },
    openUserFrom: function openUserFrom(data) {
      if (data) {
        this.user = data;
      }
      $('#bsModal').modal('show');
    },
    resetAllSelect: function resetAllSelect() {
      this.form.userOptionsConsultant = '';
      this.form.userOptionsAmbulance = '';
      this.form.userOptionsDelivery = '';
    }

  }),

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['lang']))
});

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'advanced-elements',
  created: function created() {}
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__widgets_VABox__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__widgets_VABox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__widgets_VABox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VAInputGroup__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VAInputGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_VAInputGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_VACheckBox__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_VACheckBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_VACheckBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VAInput__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VAInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_VAInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_VAButton__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_VAButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_VAButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_VATextareaGroup__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_VATextareaGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_VATextareaGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_VAFormGroup__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_VAFormGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_VAFormGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_VARadio__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_VARadio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_VARadio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_VASelect__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_VASelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_VASelect__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'general-elements',
  data: function data() {
    return {
      selectList: ['option1', 'option2', 'option3', 'option4', 'option5']
    };
  },
  created: function created() {},

  components: {
    'va-box': __WEBPACK_IMPORTED_MODULE_0__widgets_VABox___default.a,
    'va-input-group': __WEBPACK_IMPORTED_MODULE_1__components_VAInputGroup___default.a,
    'va-checkbox': __WEBPACK_IMPORTED_MODULE_2__components_VACheckBox___default.a,
    'va-input': __WEBPACK_IMPORTED_MODULE_3__components_VAInput___default.a,
    'va-button': __WEBPACK_IMPORTED_MODULE_4__components_VAButton___default.a,
    'va-textarea-group': __WEBPACK_IMPORTED_MODULE_5__components_VATextareaGroup___default.a,
    'va-form-group': __WEBPACK_IMPORTED_MODULE_6__components_VAFormGroup___default.a,
    'va-radio': __WEBPACK_IMPORTED_MODULE_7__components_VARadio___default.a,
    'va-select': __WEBPACK_IMPORTED_MODULE_8__components_VASelect___default.a
  }
});

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_vuex_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugins_i18n__ = __webpack_require__(27);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PrescriptionForm',
  props: {
    patientInfo: Object,
    name: String
  },
  mounted: function mounted() {
    if (localStorage.getItem('lan') != null) this.$i18n.locale = JSON.parse(localStorage.getItem('lan')).language;
  },
  data: function data() {
    return {
      error: '',
      loading: false,
      medicines: [],
      searchMedicine: {
        name: '',
        productType: -1,
        groupName: -1,
        warnings: -1
      },
      prescription: {
        contactNumber: '',
        patientId: '',
        patientName: '',
        patientContact: '',
        taskGroup: 6,
        taskType: [0, 1],
        priority: -1,
        comments: '',
        medicines: []
      }
    };
  },

  methods: {
    submitPrescription: function submitPrescription(e) {
      var self = this;

      e.preventDefault();
      self.loading = true;
      self.prescription.contactNumber = self.patientInfo.enterBy;
      self.prescription.patientId = self.patientInfo.id;
      self.prescription.patientName = self.patientInfo.name;
      self.prescription.patientContact = self.patientInfo.contactNumber;
      __WEBPACK_IMPORTED_MODULE_0__src_vuex_api__["a" /* services */].Task.addTask(self.prescription).then(function (response) {
        self.error = '';
        $('#bsMedicine').modal('hide');
        self.loading = false;
      }).catch(function (err) {
        this.loading = false;
        self.error = '' + err;
      });
    },


    medicineSelected: function medicineSelected(medicineId) {
      return this.prescription.medicines.some(function (el) {
        return el.medicineId === medicineId;
      });
    },
    selectMedicine: function selectMedicine(medicine) {
      if (medicine.quantity !== undefined && medicine.duration !== undefined && medicine.beforeAfterMeal !== undefined) {
        var mItemd = {
          medicineId: medicine._id,
          name: medicine.name,
          groupName: medicine.groupName,
          productType: medicine.productType,
          warnings: medicine.warnings,
          quantity: medicine.quantity,
          beforeAfterMeal: medicine.beforeAfterMeal,
          duration: medicine.duration
        };
        this.prescription.medicines.push(mItemd);
      } else {
        var alertInfo = __WEBPACK_IMPORTED_MODULE_1__plugins_i18n__["a" /* default */].t('quantity') + ' / ' + __WEBPACK_IMPORTED_MODULE_1__plugins_i18n__["a" /* default */].t('duration') + ' / ' + __WEBPACK_IMPORTED_MODULE_1__plugins_i18n__["a" /* default */].t('before_after_meal') + '  ' + __WEBPACK_IMPORTED_MODULE_1__plugins_i18n__["a" /* default */].t('value_required');
        alert(alertInfo);
      }
    },
    removeMedicine: function removeMedicine(medicine) {
      for (var i = 0; i < this.prescription.medicines.length; i++) {
        if (this.prescription.medicines[i] === medicine) {
          this.prescription.medicines.splice(i, 1);
        }
      }
    },
    getMedicines: function getMedicines() {
      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_0__src_vuex_api__["a" /* services */].medicines.getMedicine(self.searchMedicine).then(function (response) {
        self.medicines = response.data.docs;

        self.loading = false;
      }).catch(function (err) {
        self.error = '' + err;
        self.loading = false;
      });
    },
    searchMedicineClick: function searchMedicineClick(e) {
      e.preventDefault();
      this.getMedicines();
    },
    clearMedicineClick: function clearMedicineClick(e) {
      e.preventDefault();
    }
  }
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_vuex_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugins_i18n__ = __webpack_require__(27);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TaskForm',
  props: {
    patientInfo: Object,
    name: String,
    userType: Number
  },
  watch: {
    userType: function userType(value) {
      var self = this;
      self.taskForward.contactNumber = '';
      self.taskForward.taskType = [];
      self.taskForward.taskGroup = -1;
      self.taskForward.comments = '';
      self.search.userType = self.userType;
      this.getForwardUsers();
    }
  },
  mounted: function mounted() {
    if (localStorage.getItem('lan') != null) this.$i18n.locale = JSON.parse(localStorage.getItem('lan')).language;
  },
  data: function data() {
    return {
      error: '',
      loading: false,
      task: [],
      taskInfo: [],
      files: [],
      forwards: [],
      search: {
        contactName: '',
        contactNumber: '',
        userType: 3,
        locationX: 0,
        locationY: 0,
        userOptionsConsultant: -1,
        userOptionsAmbulance: -1,
        userOptionsDelivery: -1
      },
      taskForward: {
        contactNumber: '',
        patientId: '',
        patientName: '',
        patientContact: '',
        taskGroup: -1,
        taskType: [],
        priority: -1,
        comments: ''
      }
    };
  },

  methods: {
    selectThis: function selectThis(usr) {
      this.taskForward.contactNumber = usr.contactNumber;
      this.taskForward.patientId = this.patientInfo.id;
      this.taskForward.patientName = this.patientInfo.name;
      this.taskForward.patientContact = this.patientInfo.contactNumber;
      this.taskForward.taskGroup = usr.userType;
    },
    submit: function submit(e) {
      var self = this;
      self.loading = true;
      e.preventDefault();
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_0__src_vuex_api__["a" /* services */].Task.addTask(this.taskForward).then(function (response) {
        self.error = '';
        self.loading = false;
        $('#bsForward').modal('hide');
      }).catch(function (err) {
        self.loading = false;
        self.error = '' + err;
      });
    },

    getForwardUsers: function getForwardUsers() {
      var self = this;
      self.loading = true;
      if (self.userType !== 3) {
        self.search.locationX = self.patientInfo.location.coordinates[0];
        self.search.locationY = self.patientInfo.location.coordinates[1];
      }
      __WEBPACK_IMPORTED_MODULE_0__src_vuex_api__["a" /* services */].user.getForwardUserList(self.search).then(function (response) {
        self.forwards = response.data.docs;

        self.loading = false;
      }).catch(function (err) {
        self.loading = false;
        self.error = '' + err;
      });
    },
    searchClick: function searchClick(e) {
      e.preventDefault();
      this.getForwardUsers();
    },
    clearClick: function clearClick(e) {
      e.preventDefault();
    }
  }
});

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'va-box',
  props: {
    widgetType: {
      type: String,
      default: 'collapse'
    },
    title: {
      type: String
    },
    content: {
      type: String
    },
    theme: {
      type: String
    },
    isOpen: {
      type: Boolean,
      default: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isSolid: {
      type: Boolean,
      default: false
    },
    isBorder: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    btnIcon: function btnIcon() {
      if (this.widgetType === 'collapse') {
        return this.isOpen ? 'fa fa-minus' : 'fa fa-plus';
      } else if (this.widgetType === 'remove') {
        return 'fa fa-times';
      }
      return '';
    }
  },
  created: function created() {}
});

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'va-calendar',
  mounted: function mounted() {
    $(this.$el).find('.id-calendar').datepicker();
  }
});

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_vuex_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugins_i18n__ = __webpack_require__(27);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ChatBox',
  props: {
    patient: Object
  },
  data: function data() {
    return {
      error: '',
      tasks: [],
      originTasks: []
    };
  },
  created: function created() {
    this.getTasklist();
  },
  mounted: function mounted() {
    var chatBoxElement = this.$el.querySelector('.id-chat-box');
    if (localStorage.getItem('lan') != null) this.$i18n.locale = JSON.parse(localStorage.getItem('lan')).language;
    $(chatBoxElement).slimScroll({
      height: '250px'
    });
  },

  methods: {
    filter: function filter(num, e) {
      var self = this;
      e.preventDefault();
      if (num < 0) {
        self.tasks = self.originTasks;
      } else {
        self.tasks = self.originTasks.filter(function (task) {
          return task.taskGroup === num;
        });
      }
    },
    submitPrescription: function submitPrescription(e) {
      var self = this;
      e.preventDefault();
    },

    getTasklist: function getTasklist() {
      var self = this;
      self.loading = true;
      var search = { patientId: self.patient.id };
      __WEBPACK_IMPORTED_MODULE_0__src_vuex_api__["a" /* services */].Task.getTask(search).then(function (response) {
        self.originTasks = response.data.docs;
        self.tasks = self.originTasks;

        self.loading = false;
      }).catch(function (err) {
        self.error = '' + err;
        self.loading = false;
      });
    },
    showUser: function showUser(contactNumber) {
      alert(contactNumber);
    },
    searchMedicineClick: function searchMedicineClick(e) {
      e.preventDefault();
      this.getMedicines();
    },
    clearMedicineClick: function clearMedicineClick(e) {
      e.preventDefault();
    }
  }
});

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'va-info-box',
  props: {
    'wrapBgColor': {
      type: String
    },
    'bgColor': {
      type: String
    },
    'bgIcon': {
      type: String
    },
    'text': {
      type: String,
      required: true
    },
    'number': {
      type: String,
      default: 0
    },
    'numberType': {
      type: String
    },
    'percentage': {
      type: Number,
      default: 0
    },
    'progressDescription': {
      type: String,
      default: ''
    },
    'isProgress': {
      type: Boolean,
      default: false
    }
  },
  computed: {
    parseNumber: function parseNumber() {
      var result = this.number;

      switch (this.numberType) {
        case 'percentage':
          result += '%';
          break;
        case 'comma':
          result = Number(result).toLocaleString('en');
          break;
        default:
          break;
      }
      return result;
    }
  }
});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    id: {
      type: String,
      default: 'loadMe'
    },
    loadingText: {
      type: String,
      default: 'Loading ..... '
    },
    loadingSubText: {
      type: String,
      default: ''
    }
  }

});

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'QuickMail',
  mounted: function mounted() {}
});

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SmallBox',
  props: ['color', 'icon', 'title', 'description', 'moreText'],
  computed: {
    bgColor: function bgColor() {
      return 'bg-' + this.color;
    }
  },
  methods: {
    moreEvent: function moreEvent() {
      this.$emit('more-click');
    }
  }
});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TodoList',
  mounted: function mounted() {
    $(this.$el).find('.todo-list').sortable({
      placeholder: 'sort-highlight',
      handle: '.handle',
      forcePlaceholderSize: true,
      zIndex: 999999
    });
  }
});

/***/ }),
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 490 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 491 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 492 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 493 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 494 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 495 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 496 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 497 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 498 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 499 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 500 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 501 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 502 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 503 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 504 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 505 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 506 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 507 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 508 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 509 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 512 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 513 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 516 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 517 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 518 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 520 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 521 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 522 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 523 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 524 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 525 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 526 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 527 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 528 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 529 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 530 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 531 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 532 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 127,
	"./af.js": 127,
	"./ar": 134,
	"./ar-dz": 128,
	"./ar-dz.js": 128,
	"./ar-kw": 129,
	"./ar-kw.js": 129,
	"./ar-ly": 130,
	"./ar-ly.js": 130,
	"./ar-ma": 131,
	"./ar-ma.js": 131,
	"./ar-sa": 132,
	"./ar-sa.js": 132,
	"./ar-tn": 133,
	"./ar-tn.js": 133,
	"./ar.js": 134,
	"./az": 135,
	"./az.js": 135,
	"./be": 136,
	"./be.js": 136,
	"./bg": 137,
	"./bg.js": 137,
	"./bm": 138,
	"./bm.js": 138,
	"./bn": 139,
	"./bn.js": 139,
	"./bo": 140,
	"./bo.js": 140,
	"./br": 141,
	"./br.js": 141,
	"./bs": 142,
	"./bs.js": 142,
	"./ca": 143,
	"./ca.js": 143,
	"./cs": 144,
	"./cs.js": 144,
	"./cv": 145,
	"./cv.js": 145,
	"./cy": 146,
	"./cy.js": 146,
	"./da": 147,
	"./da.js": 147,
	"./de": 150,
	"./de-at": 148,
	"./de-at.js": 148,
	"./de-ch": 149,
	"./de-ch.js": 149,
	"./de.js": 150,
	"./dv": 151,
	"./dv.js": 151,
	"./el": 152,
	"./el.js": 152,
	"./en-SG": 153,
	"./en-SG.js": 153,
	"./en-au": 154,
	"./en-au.js": 154,
	"./en-ca": 155,
	"./en-ca.js": 155,
	"./en-gb": 156,
	"./en-gb.js": 156,
	"./en-ie": 157,
	"./en-ie.js": 157,
	"./en-il": 158,
	"./en-il.js": 158,
	"./en-nz": 159,
	"./en-nz.js": 159,
	"./eo": 160,
	"./eo.js": 160,
	"./es": 163,
	"./es-do": 161,
	"./es-do.js": 161,
	"./es-us": 162,
	"./es-us.js": 162,
	"./es.js": 163,
	"./et": 164,
	"./et.js": 164,
	"./eu": 165,
	"./eu.js": 165,
	"./fa": 166,
	"./fa.js": 166,
	"./fi": 167,
	"./fi.js": 167,
	"./fo": 168,
	"./fo.js": 168,
	"./fr": 171,
	"./fr-ca": 169,
	"./fr-ca.js": 169,
	"./fr-ch": 170,
	"./fr-ch.js": 170,
	"./fr.js": 171,
	"./fy": 172,
	"./fy.js": 172,
	"./ga": 173,
	"./ga.js": 173,
	"./gd": 174,
	"./gd.js": 174,
	"./gl": 175,
	"./gl.js": 175,
	"./gom-latn": 176,
	"./gom-latn.js": 176,
	"./gu": 177,
	"./gu.js": 177,
	"./he": 178,
	"./he.js": 178,
	"./hi": 179,
	"./hi.js": 179,
	"./hr": 180,
	"./hr.js": 180,
	"./hu": 181,
	"./hu.js": 181,
	"./hy-am": 182,
	"./hy-am.js": 182,
	"./id": 183,
	"./id.js": 183,
	"./is": 184,
	"./is.js": 184,
	"./it": 186,
	"./it-ch": 185,
	"./it-ch.js": 185,
	"./it.js": 186,
	"./ja": 187,
	"./ja.js": 187,
	"./jv": 188,
	"./jv.js": 188,
	"./ka": 189,
	"./ka.js": 189,
	"./kk": 190,
	"./kk.js": 190,
	"./km": 191,
	"./km.js": 191,
	"./kn": 192,
	"./kn.js": 192,
	"./ko": 193,
	"./ko.js": 193,
	"./ku": 194,
	"./ku.js": 194,
	"./ky": 195,
	"./ky.js": 195,
	"./lb": 196,
	"./lb.js": 196,
	"./lo": 197,
	"./lo.js": 197,
	"./lt": 198,
	"./lt.js": 198,
	"./lv": 199,
	"./lv.js": 199,
	"./me": 200,
	"./me.js": 200,
	"./mi": 201,
	"./mi.js": 201,
	"./mk": 202,
	"./mk.js": 202,
	"./ml": 203,
	"./ml.js": 203,
	"./mn": 204,
	"./mn.js": 204,
	"./mr": 205,
	"./mr.js": 205,
	"./ms": 207,
	"./ms-my": 206,
	"./ms-my.js": 206,
	"./ms.js": 207,
	"./mt": 208,
	"./mt.js": 208,
	"./my": 209,
	"./my.js": 209,
	"./nb": 210,
	"./nb.js": 210,
	"./ne": 211,
	"./ne.js": 211,
	"./nl": 213,
	"./nl-be": 212,
	"./nl-be.js": 212,
	"./nl.js": 213,
	"./nn": 214,
	"./nn.js": 214,
	"./pa-in": 215,
	"./pa-in.js": 215,
	"./pl": 216,
	"./pl.js": 216,
	"./pt": 218,
	"./pt-br": 217,
	"./pt-br.js": 217,
	"./pt.js": 218,
	"./ro": 219,
	"./ro.js": 219,
	"./ru": 220,
	"./ru.js": 220,
	"./sd": 221,
	"./sd.js": 221,
	"./se": 222,
	"./se.js": 222,
	"./si": 223,
	"./si.js": 223,
	"./sk": 224,
	"./sk.js": 224,
	"./sl": 225,
	"./sl.js": 225,
	"./sq": 226,
	"./sq.js": 226,
	"./sr": 228,
	"./sr-cyrl": 227,
	"./sr-cyrl.js": 227,
	"./sr.js": 228,
	"./ss": 229,
	"./ss.js": 229,
	"./sv": 230,
	"./sv.js": 230,
	"./sw": 231,
	"./sw.js": 231,
	"./ta": 232,
	"./ta.js": 232,
	"./te": 233,
	"./te.js": 233,
	"./tet": 234,
	"./tet.js": 234,
	"./tg": 235,
	"./tg.js": 235,
	"./th": 236,
	"./th.js": 236,
	"./tl-ph": 237,
	"./tl-ph.js": 237,
	"./tlh": 238,
	"./tlh.js": 238,
	"./tr": 239,
	"./tr.js": 239,
	"./tzl": 240,
	"./tzl.js": 240,
	"./tzm": 242,
	"./tzm-latn": 241,
	"./tzm-latn.js": 241,
	"./tzm.js": 242,
	"./ug-cn": 243,
	"./ug-cn.js": 243,
	"./uk": 244,
	"./uk.js": 244,
	"./ur": 245,
	"./ur.js": 245,
	"./uz": 247,
	"./uz-latn": 246,
	"./uz-latn.js": 246,
	"./uz.js": 247,
	"./vi": 248,
	"./vi.js": 248,
	"./x-pseudo": 249,
	"./x-pseudo.js": 249,
	"./yo": 250,
	"./yo.js": 250,
	"./zh-cn": 251,
	"./zh-cn.js": 251,
	"./zh-hk": 252,
	"./zh-hk.js": 252,
	"./zh-tw": 253,
	"./zh-tw.js": 253
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 541;

/***/ }),
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(521)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(366),
  /* template */
  __webpack_require__(733),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(367),
  /* template */
  __webpack_require__(713),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(368),
  /* template */
  __webpack_require__(723),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(522)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(369),
  /* template */
  __webpack_require__(734),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(370),
  /* template */
  __webpack_require__(698),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(372),
  /* template */
  __webpack_require__(699),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(373),
  /* template */
  __webpack_require__(707),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(375),
  /* template */
  __webpack_require__(714),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(376),
  /* template */
  __webpack_require__(711),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(743),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(378),
  /* template */
  __webpack_require__(695),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(379),
  /* template */
  __webpack_require__(732),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(693),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(502)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(704),
  /* scopeId */
  "data-v-2f42f63a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(505)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(384),
  /* template */
  __webpack_require__(709),
  /* scopeId */
  "data-v-3dad18f4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(514)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(385),
  /* template */
  __webpack_require__(724),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(753),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(387),
  /* template */
  __webpack_require__(710),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(532)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(388),
  /* template */
  __webpack_require__(750),
  /* scopeId */
  "data-v-de609e98",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(746),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(507)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(715),
  /* scopeId */
  "data-v-555263e7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(509)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(717),
  /* scopeId */
  "data-v-55f7d7a7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(523)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(736),
  /* scopeId */
  "data-v-93d7b488",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(497)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(696),
  /* scopeId */
  "data-v-149b4eb7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(525)
__webpack_require__(524)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(394),
  /* template */
  __webpack_require__(737),
  /* scopeId */
  "data-v-970477a2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(517)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(727),
  /* scopeId */
  "data-v-71a7bc01",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(531)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(396),
  /* template */
  __webpack_require__(745),
  /* scopeId */
  "data-v-cdc5b9de",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(526)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(397),
  /* template */
  __webpack_require__(738),
  /* scopeId */
  "data-v-9ae53f32",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(513)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(722),
  /* scopeId */
  "data-v-6180efe2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(499)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(700),
  /* scopeId */
  "data-v-1dc4d082",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(511)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(400),
  /* template */
  __webpack_require__(719),
  /* scopeId */
  "data-v-59f9193a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(501)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(702),
  /* scopeId */
  "data-v-227a7ae8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(530)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(402),
  /* template */
  __webpack_require__(744),
  /* scopeId */
  "data-v-ca9d2704",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(519)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(403),
  /* template */
  __webpack_require__(729),
  /* scopeId */
  "data-v-77b5e44f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(498)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(404),
  /* template */
  __webpack_require__(697),
  /* scopeId */
  "data-v-16dbaeb7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(528)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(405),
  /* template */
  __webpack_require__(741),
  /* scopeId */
  "data-v-b8fc6650",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(516)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(406),
  /* template */
  __webpack_require__(726),
  /* scopeId */
  "data-v-6b8cd2f5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(512)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(407),
  /* template */
  __webpack_require__(720),
  /* scopeId */
  "data-v-5c8be274",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(500)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(408),
  /* template */
  __webpack_require__(701),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(409),
  /* template */
  __webpack_require__(747),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(410),
  /* template */
  __webpack_require__(751),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(411),
  /* template */
  __webpack_require__(721),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(412),
  /* template */
  __webpack_require__(748),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(506)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(415),
  /* template */
  __webpack_require__(712),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(503)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(360),
  /* template */
  __webpack_require__(706),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(361),
  /* template */
  __webpack_require__(749),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(362),
  /* template */
  __webpack_require__(703),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(520)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(363),
  /* template */
  __webpack_require__(730),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(420),
  /* template */
  __webpack_require__(739),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(504)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(364),
  /* template */
  __webpack_require__(708),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 693 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('va-textarea', {
    attrs: {
      "rowCount": _vm.rowCount,
      "placeholder": _vm.placeholder,
      "isDisabled": _vm.isDisabled
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 694 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('va-navibar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentUser.authorized),
      expression: "currentUser.authorized"
    }]
  }), _vm._v(" "), _c('va-slider', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentUser.authorized),
      expression: "currentUser.authorized"
    }],
    attrs: {
      "slideMenuItems": _vm.slideMenuItems,
      "userRole": _vm.currentUser.position
    }
  }), _vm._v(" "), _c('va-content-wrap'), _vm._v(" "), _c('Modal')], 1)])
},staticRenderFns: []}

/***/ }),
/* 695 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.router && _vm.router.name) ? _c('router-link', {
    attrs: {
      "tag": "li",
      "to": _vm.router
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    class: _vm.icon
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t(_vm.item.name)))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.badge),
      expression: "badge"
    }],
    staticClass: "pull-right-container"
  }, [_c('small', {
    staticClass: "label pull-right",
    class: [_vm.badge.type === 'String' ? 'bg-green' : 'label-primary']
  }, [_vm._v(_vm._s(_vm.badge.data))])])])]) : _c('li', {
    class: _vm.getType
  }, [_vm._v("\n  " + _vm._s(_vm.isHeader ? _vm.name : '') + "\n  "), (!_vm.isHeader && _vm.permission.indexOf(_vm.userRole) > -1) ? _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    class: _vm.icon
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t(_vm.name)))]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [(_vm.badge && _vm.badge.data) ? _c('small', {
    staticClass: "label pull-right",
    class: [_vm.badge.type === 'String' ? 'bg-green' : 'label-primary']
  }, [_vm._v(_vm._s(_vm.badge.data))]) : _c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])]) : _vm._e(), _vm._v(" "), (_vm.items.length > 0) ? _c('ul', {
    staticClass: "treeview-menu"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('router-link', {
      key: index,
      attrs: {
        "tag": "li",
        "data": item,
        "to": item.router
      }
    }, [(item.router && item.router.name && item.permission.indexOf(_vm.userRole) > -1) ? _c('a', [_c('i', {
      class: item.icon
    }), _vm._v(" " + _vm._s(_vm.$t(item.name)) + "\n      ")]) : _vm._e()])
  }), 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 696 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('medicine_list')))]), _vm._v(" "), _c('loading', {
    attrs: {
      "loadingText": ("" + (_vm.$t('loading'))),
      "id": "loadMe",
      "loadinSubText": ("" + (_vm.$t('loading')))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "bsModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "bsModalLabel",
      "data-toggle": "modal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "bsModalLabel"
    }
  }, [_vm._v(_vm._s(_vm.$t('medicine_from')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.groupName),
      expression: "user.groupName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": ("" + (_vm.$t('medicineGroupName')))
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user, "groupName", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$t('medicineGroups')), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i,
        "selected": _vm.user.groupName == i
      }
    }, [_vm._v("\n                               " + _vm._s(s) + "\n                           ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.productType),
      expression: "user.productType"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": ("" + (_vm.$t('medicineTypeName')))
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user, "productType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$t('medicineType')), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i,
        "selected": _vm.user.productType == i
      }
    }, [_vm._v("\n                          " + _vm._s(s) + "\n                         ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "name",
      "id": "name",
      "placeholder": ("" + (_vm.$t('medicine_name')))
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('warning')))]), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.$t('medicineWarning')), function(s, i) {
    return _c('li', {
      key: i,
      staticClass: "list-group-item"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.user.warnings),
        expression: "user.warnings"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": i,
        "checked": Array.isArray(_vm.user.warnings) ? _vm._i(_vm.user.warnings, i) > -1 : (_vm.user.warnings)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.user.warnings,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = i,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.user, "warnings", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.user, "warnings", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.user, "warnings", $$c)
          }
        }
      }
    }), _vm._v("\n                           " + _vm._s(s) + "\n                           ")])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-success ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submit($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('submit')))])]), _vm._v(" "), (_vm.error.length > 0) ? _c('div', {
    staticClass: "alert alert-danger padding5"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": _vm.openUserFrom
    }
  }, [_vm._v(_vm._s(_vm.$t('add_new')))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "input-group-text ",
    attrs: {
      "type": "text",
      "placeholder": ("" + (_vm.$t('name')))
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.groupName),
      expression: "form.groupName"
    }],
    staticClass: "input-group-select",
    attrs: {
      "name": "groupName"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "groupName", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('medicineGroupName')))]), _vm._v(" "), _vm._l((_vm.$t('medicineGroups')), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n                          " + _vm._s(s) + "\n                         ")])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.productType),
      expression: "form.productType"
    }],
    staticClass: "input-group-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "productType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('medicineTypeName')))]), _vm._v(" "), _vm._l((_vm.$t('medicineType')), function(w, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n                         " + _vm._s(w) + "\n               ")])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.warnings),
      expression: "form.warnings"
    }],
    staticClass: "input-group-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "warnings", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('warning')))]), _vm._v(" "), _vm._l((_vm.$t('medicineWarning')), function(w, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n                          " + _vm._s(w) + "\n                   ")])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success padding5",
    on: {
      "click": _vm.searchClick
    }
  }, [_vm._v(_vm._s(_vm.$t('search')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-success padding5",
    on: {
      "click": _vm.clearClick
    }
  }, [_vm._v(_vm._s(_vm.$t('clear')))])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10px"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('medicineGroupName')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('medicineTypeName')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('warning')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('insertTime')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('enterBy')) + " ")])]), _vm._v(" "), _vm._l((_vm.users), function(usr) {
    return _c('tr', {
      key: usr.id
    }, [_c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(usr.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('medicineGroups')[[usr.groupName]]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('medicineType')[[usr.productType]]))]), _vm._v(" "), _c('td', _vm._l((_vm.$t('medicineWarning')), function(w, i) {
      return _c('i', {
        key: i
      }, [_vm._v("\n                             " + _vm._s(usr.warnings.indexOf(i) >= 0 ? w : '') + "\n                     ")])
    }), 0), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.moment(usr.insertTime).startOf('hour').fromNow()))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(usr.enterBy))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.openUserFrom(usr)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit fa-2x"
    })])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer pb-0 pt-3"
  }, [_c('simple-pagination', {
    attrs: {
      "currentpage": _vm.form.page,
      "pages": _vm.form.totalpages
    },
    on: {
      "changePage": _vm.pageChange
    }
  })], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}

/***/ }),
/* 697 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('task_list')))]), _vm._v(" "), _c('loading', {
    attrs: {
      "loadingText": ("" + (_vm.$t('loading'))),
      "id": "loadMe",
      "loadinSubText": ("" + (_vm.$t('please_wait')))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "bsModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "bsModalLabel",
      "data-toggle": "modal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "bsModalLabel"
    }
  }, [_vm._v(_vm._s(_vm.$t('task_form')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('taskType')))]), _vm._v(" "), (_vm.form.taskGroup == 3) ? _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.$t('consultantTasks')), function(s, i) {
    return _c('li', {
      key: i,
      staticClass: "list-group-item"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.taskType),
        expression: "form.taskType"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": i,
        "checked": Array.isArray(_vm.form.taskType) ? _vm._i(_vm.form.taskType, i) > -1 : (_vm.form.taskType)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.form.taskType,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = i,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.form, "taskType", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.form, "taskType", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.form, "taskType", $$c)
          }
        }
      }
    }), _vm._v("\n                            " + _vm._s(s) + "\n                            ")])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.form.taskGroup == 4) ? _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.$t('ambulanceTasks')), function(s, i) {
    return _c('li', {
      key: i,
      staticClass: "list-group-item"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.taskType),
        expression: "form.taskType"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": i,
        "checked": Array.isArray(_vm.form.taskType) ? _vm._i(_vm.form.taskType, i) > -1 : (_vm.form.taskType)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.form.taskType,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = i,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.form, "taskType", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.form, "taskType", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.form, "taskType", $$c)
          }
        }
      }
    }), _vm._v("\n                            " + _vm._s(s) + "\n                            ")])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.form.taskGroup == 5) ? _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.$t('deliveryTasks')), function(s, i) {
    return _c('li', {
      key: i,
      staticClass: "list-group-item"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.taskType),
        expression: "form.taskType"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": i,
        "checked": Array.isArray(_vm.form.taskType) ? _vm._i(_vm.form.taskType, i) > -1 : (_vm.form.taskType)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.form.taskType,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = i,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.form, "taskType", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.form, "taskType", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.form, "taskType", $$c)
          }
        }
      }
    }), _vm._v("\n                            " + _vm._s(s) + "\n                            ")])])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.priority),
      expression: "form.priority"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": ("" + (_vm.$t('priorityLbl')))
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "priority", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$t('priorityData')), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i,
        "selected": _vm.form.priority == i
      }
    }, [_vm._v("\n        " + _vm._s(s) + "\n        ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.status),
      expression: "form.status"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": ("" + (_vm.$t('statusLbl')))
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$t('taskStatus')), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i,
        "selected": _vm.form.status == i
      }
    }, [_vm._v("\n        " + _vm._s(s) + "\n        ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.comments),
      expression: "form.comments"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "comments",
      "id": "comments",
      "placeholder": ("" + (_vm.$t('comments')))
    },
    domProps: {
      "value": (_vm.form.comments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "comments", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-success ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('submit')))])]), _vm._v(" "), (_vm.error.length > 0) ? _c('div', {
    staticClass: "alert alert-danger padding5"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.patientName),
      expression: "search.patientName"
    }],
    staticClass: "input-group-text ",
    attrs: {
      "type": "text",
      "placeholder": ("" + (_vm.$t('patientName')))
    },
    domProps: {
      "value": (_vm.search.patientName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "patientName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.patientContact),
      expression: "search.patientContact"
    }],
    staticClass: "input-group-text ",
    attrs: {
      "type": "text",
      "placeholder": ("" + (_vm.$t('patientContact')))
    },
    domProps: {
      "value": (_vm.search.patientContact)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "patientContact", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.contactNumber),
      expression: "search.contactNumber"
    }],
    staticClass: "input-group-text ",
    attrs: {
      "type": "text",
      "placeholder": ("" + (_vm.$t('contactNumber')))
    },
    domProps: {
      "value": (_vm.search.contactNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "contactNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.taskGroup),
      expression: "search.taskGroup"
    }],
    staticClass: "input-group-select",
    attrs: {
      "placeholder": ("" + (_vm.$t('taskTypeLbl')))
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.search, "taskGroup", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('taskGroup')))]), _vm._v(" "), _vm._l((_vm.$t('taskGroupData')), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n                " + _vm._s(s) + "\n            ")])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.priority),
      expression: "search.priority"
    }],
    staticClass: "input-group-select",
    attrs: {
      "placeholder": ("" + (_vm.$t('priorityLbl')))
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.search, "priority", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('priorityLbl')))]), _vm._v(" "), _vm._l((_vm.$t('priorityData')), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n          " + _vm._s(s) + "\n          ")])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.status),
      expression: "search.status"
    }],
    staticClass: "input-group-select",
    attrs: {
      "placeholder": ("" + (_vm.$t('statusLbl')))
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.search, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('statusLbl')))]), _vm._v(" "), _vm._l((_vm.$t('taskStatus')), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n          " + _vm._s(s) + "\n          ")])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success padding5",
    on: {
      "click": _vm.searchClick
    }
  }, [_vm._v(_vm._s(_vm.$t('search')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-success padding5",
    on: {
      "click": _vm.clearClick
    }
  }, [_vm._v(_vm._s(_vm.$t('clear')))])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10px"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('contactNumber')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('patientName')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('patientContact')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('taskGroup')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('taskType')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('priority')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('comments')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('enterBy')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('insertTime')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('status')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('sync1')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('sync2')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('action')) + " ")])]), _vm._v(" "), _vm._l((_vm.tasks), function(task) {
    return _c('tr', {
      key: task.id
    }, [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(task.contactNumber) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(task.patientName) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(task.patientContact) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n\n" + _vm._s(_vm.$t('taskGroupData')[[task.taskGroup]]) + "\n")]), _vm._v(" "), _c('td', [_vm._l((_vm.$t('taskTypeData')), function(w, i) {
      return _c('i', {
        key: i
      }, [_vm._v("\n            " + _vm._s(task.taskType.indexOf(i) >= 0 ? w : '') + "\n         ")])
    }), _vm._v(" , \n        \n")], 2), _vm._v(" "), _c('td', [_vm._v("\n\n      " + _vm._s(_vm.$t('priorityData')[[task.priority]]) + "\n      \n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(task.comments) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(task.enterBy) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n\n        " + _vm._s(_vm.moment(task.insertTime).startOf('hour').fromNow()) + "\n        \n")]), _vm._v(" "), _c('td', [_vm._v("\n\n      " + _vm._s(_vm.$t('taskStatus')[[task.status]]) + "\n      \n")]), _vm._v(" "), _c('td', [_vm._v("\n\n      " + _vm._s(_vm.$t('yesNo')[[task.sync1]]) + "\n      \n")]), _vm._v(" "), _c('td', [_vm._v("\n\n      " + _vm._s(_vm.$t('yesNo')[[task.sync2]]) + "\n      \n")]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.openFrom(task)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit fa-2x"
    })])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer pb-0 pt-3"
  }, [_c('simple-pagination', {
    attrs: {
      "currentpage": _vm.search.page,
      "pages": _vm.search.totalpages
    },
    on: {
      "changePage": _vm.pageChange
    }
  })], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}

/***/ }),
/* 698 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn",
    class: [_vm.isBlock ? 'btn-block' : '', _vm.btnTheme, _vm.disabled, _vm.flat, _vm.size, _vm.getAlign],
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.name) + "\n  "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 699 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isHorizontal) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-10"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(_vm._s(_vm.text) + "\n      ")])])])]) : _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox",
      "disabled": _vm.isDisabled
    }
  }), _vm._v(_vm._s(_vm.text) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 700 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('rationlog_list')))]), _vm._v(" "), _c('loading', {
    attrs: {
      "loadingText": ("" + (_vm.$t('loading'))),
      "id": "loadMe",
      "loadinSubText": ("" + (_vm.$t('please_wait')))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "bsModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "bsModalLabel",
      "data-toggle": "modal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "bsModalLabel"
    }
  }, [_vm._v(_vm._s(_vm.$t('rationlog_form')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.idNumber),
      expression: "form.idNumber"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "idNumber",
      "id": "idNumber",
      "placeholder": ("" + (_vm.$t('idNumber')))
    },
    domProps: {
      "value": (_vm.form.idNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "idNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.itemDetails),
      expression: "form.itemDetails"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "itemDetails",
      "id": "itemDetails",
      "placeholder": ("" + (_vm.$t('itemDetails')))
    },
    domProps: {
      "value": (_vm.form.itemDetails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "itemDetails", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.validity),
      expression: "form.validity"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": ("" + (_vm.$t('validity')))
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "validity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('validity')))]), _vm._v(" "), _vm._l((_vm.$t('validityDays')), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": s
      }
    }, [_vm._v("\n          " + _vm._s(s) + " " + _vm._s(_vm.$t('days')) + "\n          ")])
  })], 2)]), _vm._v(" "), (_vm.loading) ? _c('div', [_c('i', {
    staticClass: "fa fa-spin fa-spinner fa-3x"
  })]) : _c('div', {
    staticClass: "text-center"
  }, [(!_vm.form._id) ? _c('button', {
    staticClass: "btn btn-success ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('submit')))]) : _vm._e()]), _vm._v(" "), (_vm.error.length > 0) ? _c('div', {
    staticClass: "alert alert-danger padding5"
  }, _vm._l((_vm.error), function(s, i) {
    return _c('p', {
      key: i
    }, [_vm._v("\n                           \n                            \n                            " + _vm._s(_vm.$t(s)) + "\n                           \n                        ")])
  }), 0) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": _vm.openFrom
    }
  }, [_vm._v(_vm._s(_vm.$t('add_new')))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.idNumber),
      expression: "search.idNumber"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "idNumber",
      "placeholder": ("" + (_vm.$t('idNumber')))
    },
    domProps: {
      "value": (_vm.search.idNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "idNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.enterBy),
      expression: "search.enterBy"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "enterBy",
      "placeholder": ("" + (_vm.$t('enterBy')))
    },
    domProps: {
      "value": (_vm.search.enterBy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "enterBy", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.itemDetails),
      expression: "search.itemDetails"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "itemDetails",
      "placeholder": ("" + (_vm.$t('itemDetails')))
    },
    domProps: {
      "value": (_vm.search.itemDetails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "itemDetails", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.status),
      expression: "search.status"
    }],
    staticClass: "input-group-select",
    attrs: {
      "placeholder": ("" + (_vm.$t('statusLbl')))
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.search, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('statusLbl')))]), _vm._v(" "), _vm._l((_vm.$t('statusRationData')), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n          " + _vm._s(s) + "\n          ")])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.validity),
      expression: "search.validity"
    }],
    staticClass: "input-group-select",
    attrs: {
      "placeholder": ("" + (_vm.$t('validity')))
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.search, "validity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('validity')))]), _vm._v(" "), _vm._l((_vm.$t('validityDays')), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": s
      }
    }, [_vm._v("\n          " + _vm._s(s) + " " + _vm._s(_vm.$t('days')) + "\n          ")])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success padding5",
    on: {
      "click": _vm.searchClick
    }
  }, [_vm._v(_vm._s(_vm.$t('search')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-success padding5",
    on: {
      "click": _vm.clearClick
    }
  }, [_vm._v(_vm._s(_vm.$t('clear')))])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10px"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('idNumber')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('itemDetails')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('nextRequest')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('enterBy')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('insertTime')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('status')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('action')) + " ")])]), _vm._v(" "), _vm._l((_vm.rationlogs), function(rationlog) {
    return _c('tr', {
      key: rationlog.id
    }, [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(rationlog.idNumber) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(rationlog.itemDetails) + "  (" + _vm._s(rationlog.validity) + " " + _vm._s(_vm.$t('days')) + ")\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(_vm.moment(rationlog.nextRequest).startOf('hour').fromNow()) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(rationlog.enterBy) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n\n        " + _vm._s(_vm.moment(rationlog.insertTime).startOf('hour').fromNow()) + "\n        \n")]), _vm._v(" "), _c('td', [_vm._v("\n\n      " + _vm._s(_vm.$t('statusRationData')[[rationlog.status]]) + "\n      \n")]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.openFrom(rationlog)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit fa-2x"
    })])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer pb-0 pt-3"
  }, [_c('simple-pagination', {
    attrs: {
      "currentpage": _vm.search.page,
      "pages": _vm.search.totalpages
    },
    on: {
      "changePage": _vm.pageChange
    }
  })], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}

/***/ }),
/* 701 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  AdvancedElements View\n")])
},staticRenderFns: []}

/***/ }),
/* 702 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "center"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner fa-5x"
  })]) : _c('div', [_vm._v("\n      done\n    ")]), _vm._v(" "), _c('div', [_c('GmapMap', {
    staticStyle: {
      "width": "100%",
      "height": "800px"
    },
    attrs: {
      "id": "map",
      "center": _vm.center,
      "zoom": 13,
      "map-type-id": "terrain"
    }
  }, [_vm._l((_vm.markers), function(m, index) {
    return _c('GmapMarker', {
      key: index,
      attrs: {
        "position": m.position,
        "clickable": true,
        "draggable": true,
        "icon": _vm.getIcon(m.status)
      },
      on: {
        "click": function($event) {
          _vm.center = m.position
        }
      }
    })
  }), _vm._v(" "), _c('gmap-info-window', {
    attrs: {
      "opened": _vm.window_open,
      "position": _vm.infowindow
    },
    on: {
      "closeclick": function($event) {
        _vm.window_open = false
      }
    }
  }, [_vm._v("\n            Hello world!\n        ")])], 2)], 1)])
},staticRenderFns: []}

/***/ }),
/* 703 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 704 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 box"
  }, _vm._l((_vm.logs), function(log) {
    return _c('div', {
      key: log.id,
      staticClass: "log"
    }, [_vm._v("\n        " + _vm._s(log.message) + "\n    ")])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-success"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('i', {
    staticClass: "fa fa-comments-o"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.$t('task_log')))]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Status"
    }
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "data-toggle": "btn-toggle"
    }
  }, [_c('button', {
    staticClass: "btn btn-default btn-sm active",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.filter(-1, $event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list fa-2x text-info"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.filter(3, $event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-headphones fa-2x text-primary"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.filter(4, $event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ambulance fa-2x text-green"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.filter(5, $event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-medkit fa-2x text-danger"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.filter(6, $event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user-md fa-2x text-warning"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body chat id-chat-box"
  }, _vm._l((_vm.tasks), function(task) {
    return _c('div', {
      key: task.id,
      staticClass: "item"
    }, [_c('img', {
      staticClass: "online",
      attrs: {
        "src": __webpack_require__(637),
        "alt": "user image"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "message"
    }, [_c('small', {
      staticClass: "text-muted pull-right"
    }, [_c('i', {
      staticClass: "fa fa-clock-o"
    }), _vm._v(" " + _vm._s(_vm.moment(task.insertTime).startOf('hour').fromNow()))]), _vm._v(" "), _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.showUser(task.enterBy)
        }
      }
    }, [_vm._v(_vm._s(task.enterBy))]), _vm._v("   - > "), _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.showUser(task.contactNumber)
        }
      }
    }, [_vm._v(_vm._s(task.contactNumber))]), _vm._v(" "), _c('br'), _vm._v("\n      \n        " + _vm._s(_vm.$t('tasklist')[[task.taskGroup - 3]]) + "\n       \n      ")]), _vm._v(" "), (task.taskGroup == 6) ? _c('div', {
      staticClass: "border border-warning"
    }, [_c('h4', [_vm._v(_vm._s(_vm.$t('medicine_list')))]), _vm._v(" "), _c('table', {
      staticClass: "table table-striped"
    }, [_c('tbody', _vm._l((task.medicines), function(med) {
      return _c('tr', {
        key: med.id,
        staticClass: "filename"
      }, [_c('td', [_vm._v("\n               " + _vm._s(med.name)), _c('br'), _vm._v("\n               " + _vm._s(_vm.$t('medicineType')[[med.productType]]) + "  " + _vm._s(_vm.$t('medicineGroups')[[med.groupName]]) + "\n              \n            ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('quantityData')[[med.quantity]]) + " "), (med.productType == 2) ? _c('span', [_vm._v(_vm._s(_vm.$t('spoon')))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('durationData')[[med.duration]]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('beforeAftermealData')[[med.beforeAfterMeal]]))])])
    }), 0)])]) : _c('div', [_c('table', {
      staticClass: "table table-striped"
    }, [_c('tbody', _vm._l((task.taskLog), function(log) {
      return _c('tr', {
        key: log.id,
        staticClass: "filename"
      }, [_c('td', [(task.taskGroup == 3) ? _c('span', [_vm._v(_vm._s(_vm.$t('consultantTasks')[[log.task]]))]) : _vm._e(), _vm._v(" "), (task.taskGroup == 4) ? _c('span', [_vm._v(_vm._s(_vm.$t('ambulanceTasks')[[log.task]]))]) : _vm._e(), _vm._v(" "), (task.taskGroup == 5) ? _c('span', [_vm._v(_vm._s(_vm.$t('deliveryTasks')[[log.task]]))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(log.comments))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(log.updateBy))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(log.updateTime))])])
    }), 0)])]), _vm._v(" "), _c('hr', {
      staticClass: "text-success"
    })])
  }), 0), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "Type message..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])])
}]}

/***/ }),
/* 706 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.iso) ? _c('span', {
    staticClass: "flag-icon",
    class: _vm.flagIconClass,
    attrs: {
      "title": _vm.title || _vm.iso
    }
  }) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 707 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 708 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 709 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 rooms"
  }, [_vm._l((_vm.rooms), function(room) {
    return _c('div', {
      key: room.id,
      staticClass: "room",
      on: {
        "click": function($event) {
          return _vm.showRoom(room.name)
        }
      }
    }, [_vm._v("\n        " + _vm._s(room.name) + "\n    ")])
  }), _vm._v(" "), _c('AddRoom')], 2)
},staticRenderFns: []}

/***/ }),
/* 710 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 711 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "radio",
      "name": _vm.name,
      "id": _vm.vaId,
      "disabled": _vm.isDisabled
    },
    domProps: {
      "value": _vm.value,
      "checked": _vm.isChecked
    }
  }), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 712 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-box",
    class: _vm.wrapBgColor
  }, [_c('span', {
    staticClass: "info-box-icon",
    class: _vm.bgColor
  }, [_c('i', {
    class: _vm.bgIcon
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v(_vm._s(_vm.parseNumber))]), _vm._v(" "), (_vm.isProgress) ? _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar",
    style: (("width: " + _vm.percentage + "%"))
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "progress-description"
  }, [_vm._v("\n      " + _vm._s(_vm.progressDescription) + "\n    ")])])])
},staticRenderFns: []}

/***/ }),
/* 713 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-header"
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    class: _vm.classFlag,
    attrs: {
      "title": _vm.selectedLan
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, _vm._l((_vm.languages), function(entry) {
    return _c('li', {
      key: entry.title
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.changeLocale(entry)
        }
      }
    }, [_c('flag', {
      attrs: {
        "iso": entry.flag,
        "squared": false
      }
    }), _vm._v(" " + _vm._s(entry.title))], 1)])
  }), 0)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('li', {
    staticClass: "dropdown notifications-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-bell-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v(_vm._s(_vm.unreadNotificationsCount))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("You have " + _vm._s(_vm.unreadNotificationsCount) + " notifications")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown tasks-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.remainTasksCount))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("You have " + _vm._s(_vm.remainTasksCount) + " tasks")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6)])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('img', {
    staticClass: "user-image",
    attrs: {
      "src": _vm.avatar,
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.currentUser.name))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "user-header"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": _vm.avatar,
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.currentUser.name) + " - " + _vm._s(_vm.$t('userType')[[_vm.currentUser.position - 1]]) + "\n                "), _c('small', [_vm._v(_vm._s(_vm.currentUser.createdAt))])])]), _vm._v(" "), _c('li', {
    staticClass: "user-footer"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('a', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "href": "/profile"
    }
  }, [_vm._v(_vm._s(_vm.$t('profile')))])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "href": "/logout"
    }
  }, [_vm._v(_vm._s(_vm.$t('sign_out')))])])])])]), _vm._v(" "), _vm._m(7)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "logo",
    attrs: {
      "href": "\\"
    }
  }, [_c('span', {
    staticClass: "logo-mini"
  }, [_c('b', [_vm._v("H")]), _vm._v("Care")]), _vm._v(" "), _c('span', {
    staticClass: "logo-lg"
  }, [_c('b', [_vm._v("Hotline")]), _vm._v(".CARE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "push-menu",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown messages-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("0")])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("You have 0 messages")]), _vm._v(" "), _c('li', [_c('ul', {
    staticClass: "menu"
  })]), _vm._v(" "), _c('li', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("See All Messages")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-users text-aqua"
  }), _vm._v(" 5 new members joined today\n                  ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-warning text-yellow"
  }), _vm._v(" Very long description here that may not fit into the\n                    page and may cause design problems\n                  ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-users text-red"
  }), _vm._v(" 5 new patient joined\n                  ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart text-green"
  }), _vm._v(" 25 ration requested today\n                  ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("View all")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('h3', [_vm._v("\n                      Patient with Minor symptoms\n                      "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v("20%")])]), _vm._v(" "), _c('div', {
    staticClass: "progress xs"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-aqua",
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "20",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("20% ")])])])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('h3', [_vm._v("\n                      Patient with Major symptoms\n                      "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v("40%")])]), _vm._v(" "), _c('div', {
    staticClass: "progress xs"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-green",
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "20",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("40% ")])])])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('h3', [_vm._v("\n                      Unrecognized \n                      "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v("40%")])]), _vm._v(" "), _c('div', {
    staticClass: "progress xs"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-red",
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "20",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("40% ")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("View all tasks")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "data-toggle": "control-sidebar"
    }
  }, [_c('i', {
    staticClass: "fa fa-gears"
  })])])
}]}

/***/ }),
/* 714 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.groupType + '-group', _vm.getTheme]
  }, [(_vm.$slots.title) ? _c('label', {
    staticClass: "control-label"
  }, [_vm._t("title")], 2) : (_vm.title) ? _c('label', {
    attrs: {
      "for": _vm.vaId
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), (_vm.$slots.slotPrefixButton) ? _c('div', {
    staticClass: "input-group-btn"
  }, [_vm._t("slotPrefixButton"), _vm._v(" "), _vm._t("slotPrefixDropdown")], 2) : _vm._e(), _vm._v(" "), (_vm.prefixAddonText || _vm.$slots.slotPrefixAddonText) ? _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n    " + _vm._s(_vm.prefixAddonText) + "\n    "), _vm._t("slotPrefixAddonText")], 2) : _vm._e(), _vm._v(" "), _c('va-input', {
    attrs: {
      "type": _vm.type,
      "vaId": _vm.vaId,
      "placeholder": _vm.placeholder,
      "size": _vm.size,
      "value": _vm.value,
      "isFormControl": _vm.type != 'file',
      "isDisabled": _vm.isDisabled
    }
  }), _vm._v(" "), (_vm.suffixAddonText || _vm.$slots.slotSuffixAddonText) ? _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n    " + _vm._s(_vm.suffixAddonText) + "\n    "), _vm._t("slotSuffixAddonText")], 2) : _vm._e(), _vm._v(" "), (_vm.$slots.slotSuffixButton) ? _c('div', {
    staticClass: "input-group-btn"
  }, [_vm._t("slotSuffixButton"), _vm._v(" "), _vm._t("slotSuffixDropdown")], 2) : _vm._e(), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.helpBlock),
      expression: "helpBlock"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.helpBlock))])], 1)
},staticRenderFns: []}

/***/ }),
/* 715 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('location_list')))]), _vm._v(" "), _c('loading', {
    attrs: {
      "loadingText": ("" + (_vm.$t('loading'))),
      "id": "loadMe",
      "loadinSubText": ("" + (_vm.$t('please_wait')))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "bsModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "bsModalLabel",
      "data-toggle": "modal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "bsModalLabel"
    }
  }, [_vm._v(_vm._s(_vm.$t('location_form')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.locationName),
      expression: "form.locationName"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "locationName",
      "id": "locationName",
      "placeholder": ("" + (_vm.$t('locationName')))
    },
    domProps: {
      "value": (_vm.form.locationName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "locationName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.district),
      expression: "form.district"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "district",
      "id": "district",
      "placeholder": ("" + (_vm.$t('district')))
    },
    domProps: {
      "value": (_vm.form.district)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "district", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.state),
      expression: "form.state"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "state",
      "id": "state",
      "placeholder": ("" + (_vm.$t('state')))
    },
    domProps: {
      "value": (_vm.form.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "state", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.latitude),
      expression: "form.latitude"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "latitude",
      "id": "latitude",
      "placeholder": ("" + (_vm.$t('latitude')))
    },
    domProps: {
      "value": (_vm.form.latitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "latitude", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.longitude),
      expression: "form.longitude"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "longitude",
      "id": "longitude",
      "placeholder": ("" + (_vm.$t('longitude')))
    },
    domProps: {
      "value": (_vm.form.longitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "longitude", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-success ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('submit')))])]), _vm._v(" "), (_vm.error.length > 0) ? _c('div', {
    staticClass: "alert alert-danger padding5"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": _vm.openFrom
    }
  }, [_vm._v(_vm._s(_vm.$t('add_new')))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.locationName),
      expression: "search.locationName"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "locationName",
      "placeholder": ("" + (_vm.$t('locationName')))
    },
    domProps: {
      "value": (_vm.search.locationName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "locationName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.district),
      expression: "search.district"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "district",
      "placeholder": ("" + (_vm.$t('district')))
    },
    domProps: {
      "value": (_vm.search.district)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "district", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.state),
      expression: "search.state"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "state",
      "placeholder": ("" + (_vm.$t('state')))
    },
    domProps: {
      "value": (_vm.search.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "state", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.latitude),
      expression: "search.latitude"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "latitude",
      "placeholder": ("" + (_vm.$t('latitude')))
    },
    domProps: {
      "value": (_vm.search.latitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "latitude", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.longitude),
      expression: "search.longitude"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "longitude",
      "placeholder": ("" + (_vm.$t('longitude')))
    },
    domProps: {
      "value": (_vm.search.longitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "longitude", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success padding5",
    on: {
      "click": _vm.searchClick
    }
  }, [_vm._v(_vm._s(_vm.$t('search')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-success padding5",
    on: {
      "click": _vm.clearClick
    }
  }, [_vm._v(_vm._s(_vm.$t('clear')))])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10px"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('locationName')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('district')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('state')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('latitude')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('longitude')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('country')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('enterBy')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('insertTime')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('action')) + " ")])]), _vm._v(" "), _vm._l((_vm.locations), function(location) {
    return _c('tr', {
      key: location.id
    }, [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(location.locationName) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(location.district) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(location.state) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(location.latitude) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(location.longitude) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(location.country) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(location.enterBy) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n\n        " + _vm._s(_vm.moment(location.insertTime).startOf('hour').fromNow()) + "\n        \n")]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.openFrom(location)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit fa-2x"
    })])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer pb-0 pt-3"
  }, [_c('simple-pagination', {
    attrs: {
      "currentpage": _vm.search.page,
      "pages": _vm.search.totalpages
    },
    on: {
      "changePage": _vm.pageChange
    }
  })], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}

/***/ }),
/* 716 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.pages < _vm.maxPages) ? _c('div', [_c('button', {
    class: _vm.vspbutton + (_vm.vspbuttonfast !== '' ? ' ' + _vm.vspbuttonfast : ''),
    on: {
      "click": function($event) {
        return _vm.handlePageChange(0)
      }
    }
  }, [_vm._v(" <<")]), _vm._v(" "), _vm._l((_vm.pages), function(item) {
    return _c('button', {
      key: item,
      class: _vm.vspbutton + (item - 1 == _vm.currPage ? ' ' + _vm.vspbuttonselected : ''),
      on: {
        "click": function($event) {
          return _vm.handlePageChange(item - 1)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), _vm._v(" "), _c('button', {
    class: _vm.vspbutton + (_vm.vspbuttonfast !== '' ? ' ' + _vm.vspbuttonfast : ''),
    on: {
      "click": function($event) {
        return _vm.handlePageChange(_vm.pages - 1)
      }
    }
  }, [_vm._v(">>")])], 2) : _c('div', [_c('button', {
    class: _vm.vspbutton + (_vm.vspbuttonfast !== '' ? ' ' + _vm.vspbuttonfast : ''),
    on: {
      "click": function($event) {
        return _vm.handlePageChange(0)
      }
    }
  }, [_vm._v(" <<")]), _vm._v(" "), _vm._l((_vm.leftPages), function(item) {
    return _c('button', {
      key: item,
      class: _vm.vspbutton + (item - 1 == _vm.currPage ? ' ' + _vm.vspbuttonselected : ''),
      on: {
        "click": function($event) {
          return _vm.handlePageChange(item - 1)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), _vm._v(" "), ((_vm.pages - 4) - _vm.currPage > 3) ? _c('span', [_vm._v("...")]) : _vm._e(), _vm._v(" "), _vm._l(([_vm.pages - 4, _vm.pages - 3, _vm.pages - 2, _vm.pages - 1, _vm.pages]), function(item) {
    return _c('button', {
      key: item,
      class: _vm.vspbutton + (item - 1 == _vm.currPage ? ' ' + _vm.vspbuttonselected : ''),
      on: {
        "click": function($event) {
          return _vm.handlePageChange(item - 1)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), _vm._v(" "), _c('button', {
    class: _vm.vspbutton + (_vm.vspbuttonfast !== '' ? ' ' + _vm.vspbuttonfast : ''),
    on: {
      "click": function($event) {
        return _vm.handlePageChange(_vm.pages - 1)
      }
    }
  }, [_vm._v(">>")])], 2)])
},staticRenderFns: []}

/***/ }),
/* 717 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "static/favicon/ms-icon-150x150.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.loginError))]), _vm._v(" "), _c('div', {
    staticClass: "text-center col-sm-12"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.checkCreds($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "username",
      "placeholder": "Username",
      "type": "text"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password",
      "placeholder": "Password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    class: 'btn btn-primary btn-lg ' + _vm.loading,
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), (_vm.response) ? _c('div', {
    staticClass: "text-red"
  }, [_c('p', {
    staticClass: "vertical-5p lead"
  }, [_vm._v(_vm._s(_vm.response))])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
}]}

/***/ }),
/* 718 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-solid bg-green-gradient"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-black"
  }, [_c('row', [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_vm._v("Task #1")]), _vm._v(" "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v("90%")])]), _vm._v(" "), _c('div', {
    staticClass: "progress xs"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-green",
    staticStyle: {
      "width": "90%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_vm._v("Task #2")]), _vm._v(" "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v("70%")])]), _vm._v(" "), _c('div', {
    staticClass: "progress xs"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-green",
    staticStyle: {
      "width": "70%"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_vm._v("Task #3")]), _vm._v(" "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v("60%")])]), _vm._v(" "), _c('div', {
    staticClass: "progress xs"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-green",
    staticStyle: {
      "width": "60%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_vm._v("Task #4")]), _vm._v(" "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v("40%")])]), _vm._v(" "), _c('div', {
    staticClass: "progress xs"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-green",
    staticStyle: {
      "width": "40%"
    }
  })])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Calendar")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right box-tools"
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-success btn-sm dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu pull-right",
    attrs: {
      "role": "menu"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Add new event")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Clear events")])]), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("View calendar")])])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "button",
      "data-widget": "remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body no-padding"
  }, [_c('div', {
    staticClass: "id-calendar",
    staticStyle: {
      "width": "100%"
    }
  })])
}]}

/***/ }),
/* 719 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "center"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner fa-5x"
  })]) : _c('div', [_c('va-chart', {
    attrs: {
      "chart-config": _vm.chartData
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7"
  }, [(_vm.loading_case) ? _c('div', {
    staticClass: "center"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner fa-5x"
  })]) : _c('div', [_c('p', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('case_summary')) + " : " + _vm._s(_vm.caseSummary.total))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('P', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-male fa-2x text-primary"
  }), _c('br'), _vm._v(_vm._s(_vm.caseSummary.male))]), _vm._v(" "), _c('va-chart', {
    attrs: {
      "chart-config": _vm.chartCaseDataMale
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('P', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-female fa-2x text-warning"
  }), _c('br'), _vm._v(_vm._s(_vm.caseSummary.female))]), _vm._v(" "), _c('va-chart', {
    attrs: {
      "chart-config": _vm.chartCaseDataFemale
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.loading_age) ? _c('div', {
    staticClass: "center"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner fa-5x"
  })]) : _c('div', [_c('div', {
    staticClass: "border-top my-3",
    staticStyle: {
      "border-top": "1"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('age_group_request')) + " :" + _vm._s(_vm.ageSummary.total))]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('P', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-male fa-3x text-primary"
  })]), _vm._v(" "), _c('va-chart', {
    attrs: {
      "chart-config": _vm.chartAgeDataMale
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('location_based_request')))]), _vm._v(" "), (_vm.loading_location) ? _c('div', {
    staticClass: "center"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner fa-5x"
  })]) : _c('div', [_c('va-chart', {
    attrs: {
      "chart-config": _vm.chartLocationData
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},staticRenderFns: []}

/***/ }),
/* 720 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('user_list')))]), _vm._v(" "), _c('loading', {
    attrs: {
      "loadingText": ("" + (_vm.$t('loading'))),
      "id": "loadMe",
      "loadinSubText": ("" + (_vm.$t('loading')))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "bsModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "bsModalLabel",
      "data-toggle": "modal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "bsModalLabel"
    }
  }, [_vm._v(_vm._s(_vm.$t('user_form')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "name",
      "id": "name",
      "placeholder": ("" + (_vm.$t('name')))
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.contactNumber),
      expression: "user.contactNumber"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "email",
      "name": "contactNumber",
      "id": "contactNumber",
      "placeholder": ("" + (_vm.$t('contactNumber')))
    },
    domProps: {
      "value": (_vm.user.contactNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "contactNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.location),
      expression: "user.location"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "location",
      "id": "location",
      "placeholder": ("" + (_vm.$t('location')))
    },
    domProps: {
      "value": (_vm.user.location)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "location", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.userType),
      expression: "user.userType"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user, "userType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$t('userType')), function(s, i) {
    return _c('option', {
      key: i + 1,
      domProps: {
        "value": i + 1,
        "selected": _vm.user.userType == (i + 1)
      }
    }, [_vm._v("\n                          " + _vm._s(s) + "\n                     ")])
  }), 0)]), _vm._v(" "), (_vm.user.userType == 3) ? _c('div', {
    staticClass: "form-group"
  }, [_c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.$t('userOptionsConsultant')), function(s, i) {
    return _c('li', {
      key: i,
      staticClass: "list-group-item"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.user.userOptionsConsultant),
        expression: "user.userOptionsConsultant"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.user.userOptionsConsultant.includes(i),
        "value": i,
        "checked": Array.isArray(_vm.user.userOptionsConsultant) ? _vm._i(_vm.user.userOptionsConsultant, i) > -1 : (_vm.user.userOptionsConsultant)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.user.userOptionsConsultant,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = i,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.user, "userOptionsConsultant", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.user, "userOptionsConsultant", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.user, "userOptionsConsultant", $$c)
          }
        }
      }
    }), _vm._v("\n                           " + _vm._s(s) + "\n                           ")])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.user.userType == 4) ? _c('div', {
    staticClass: "form-group"
  }, [_c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.$t('userOptionsAmbulance')), function(s, i) {
    return _c('li', {
      key: i,
      staticClass: "list-group-item"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.user.userOptionsAmbulance),
        expression: "user.userOptionsAmbulance"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.user.userOptionsAmbulance.includes(i),
        "value": i,
        "checked": Array.isArray(_vm.user.userOptionsAmbulance) ? _vm._i(_vm.user.userOptionsAmbulance, i) > -1 : (_vm.user.userOptionsAmbulance)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.user.userOptionsAmbulance,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = i,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.user, "userOptionsAmbulance", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.user, "userOptionsAmbulance", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.user, "userOptionsAmbulance", $$c)
          }
        }
      }
    }), _vm._v("\n                           " + _vm._s(s) + "\n                           ")])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.user.userType == 5) ? _c('div', {
    staticClass: "form-group"
  }, [_c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.$t('userOptionsDelivery')), function(s, i) {
    return _c('li', {
      key: i,
      staticClass: "list-group-item"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.user.userOptionsDelivery),
        expression: "user.userOptionsDelivery"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.user.userOptionsDelivery.includes(i),
        "value": i,
        "checked": Array.isArray(_vm.user.userOptionsDelivery) ? _vm._i(_vm.user.userOptionsDelivery, i) > -1 : (_vm.user.userOptionsDelivery)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.user.userOptionsDelivery,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = i,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.user, "userOptionsDelivery", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.user, "userOptionsDelivery", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.user, "userOptionsDelivery", $$c)
          }
        }
      }
    }), _vm._v("\n                           " + _vm._s(s) + "\n                           ")])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.user._id) ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.status),
      expression: "user.status"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": ("" + (_vm.$t('status')))
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$t('userStatus')), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i,
        "selected": _vm.user.status == i
      }
    }, [_vm._v("\n                          " + _vm._s(s) + "\n                     ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', [_c('i', {
    staticClass: "fa fa-spin fa-spinner fa-3x"
  })]) : _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-success ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('submit')))])]), _vm._v(" "), (_vm.error.length > 0) ? _c('div', {
    staticClass: "alert alert-danger padding5"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "alert alert-info  padding5"
  }, [_vm._v(_vm._s(_vm.$t('password_will_sent_to_mobile')) + "\n                 ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": _vm.openUserFrom
    }
  }, [_vm._v(_vm._s(_vm.$t('add_new')))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "input-group-text ",
    attrs: {
      "type": "text",
      "placeholder": ("" + (_vm.$t('name')))
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.contactNumber),
      expression: "form.contactNumber"
    }],
    staticClass: "input-group-text ",
    attrs: {
      "type": "text",
      "placeholder": ("" + (_vm.$t('contactNumber')))
    },
    domProps: {
      "value": (_vm.form.contactNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "contactNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.location),
      expression: "form.location"
    }],
    staticClass: "input-group-text ",
    attrs: {
      "type": "text",
      "placeholder": ("" + (_vm.$t('location')))
    },
    domProps: {
      "value": (_vm.form.location)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "location", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.userType),
      expression: "form.userType"
    }],
    staticClass: "input-group-select",
    attrs: {
      "name": "userType"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "userType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.resetAllSelect]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('userTypeLbl')))]), _vm._v(" "), _vm._l((_vm.$t('userType')), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i + 1
      }
    }, [_vm._v("\n                          " + _vm._s(s) + "\n                         ")])
  })], 2), _vm._v(" "), (_vm.form.userType == 3) ? _c('span', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.userOptionsConsultant),
      expression: "form.userOptionsConsultant"
    }],
    staticClass: "input-group-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "userOptionsConsultant", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('ConsultantLbl')))]), _vm._v(" "), _vm._l((_vm.$t('userOptionsConsultant')), function(w, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n                          " + _vm._s(w) + "\n                         ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.form.userType == 4) ? _c('span', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.userOptionsAmbulance),
      expression: "form.userOptionsAmbulance"
    }],
    staticClass: "input-group-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "userOptionsAmbulance", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('AmbulanceLbl')))]), _vm._v(" "), _vm._l((_vm.$t('userOptionsAmbulance')), function(w, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n                          " + _vm._s(w) + "\n                         ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.form.userType == 5) ? _c('span', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.userOptionsDelivery),
      expression: "form.userOptionsDelivery"
    }],
    staticClass: "input-group-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "userOptionsDelivery", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('DeliveryLbl')))]), _vm._v(" "), _vm._l((_vm.$t('userOptionsDelivery')), function(w, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n                          " + _vm._s(w) + "\n                         ")])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success padding5",
    on: {
      "click": _vm.searchClick
    }
  }, [_vm._v(_vm._s(_vm.$t('search')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-success padding5",
    on: {
      "click": _vm.clearClick
    }
  }, [_vm._v(_vm._s(_vm.$t('clear')))])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10px"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('contactNumber')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('location')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('userTypeLbl')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('optionsLbl')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('insertTime')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('status')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('action')) + " ")])]), _vm._v(" "), _vm._l((_vm.users), function(usr) {
    return _c('tr', {
      key: usr.id
    }, [_c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(usr.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(usr.contactNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(usr.location))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('userType')[[usr.userType - 1]]))]), _vm._v(" "), _c('td', [(usr.userType == 3) ? _c('span', _vm._l((_vm.$t('userOptionsConsultant')), function(w, i) {
      return _c('i', {
        key: i
      }, [_vm._v("\n                             " + _vm._s(usr.userOptionsConsultant.indexOf(i) >= 0 ? w : '') + "\n                     ")])
    }), 0) : _vm._e(), _vm._v(" "), (usr.userType == 4) ? _c('span', _vm._l((_vm.$t('userOptionsAmbulance')), function(w, i) {
      return _c('i', {
        key: i
      }, [_vm._v("\n                             " + _vm._s(usr.userOptionsAmbulance.indexOf(i) >= 0 ? w : '') + "\n                     ")])
    }), 0) : _vm._e(), _vm._v(" "), (usr.userType == 5) ? _c('span', _vm._l((_vm.$t('userOptionsDelivery')), function(w, i) {
      return _c('i', {
        key: i
      }, [_vm._v("\n                             " + _vm._s(usr.userOptionsDelivery.indexOf(i) >= 0 ? w : '') + "\n                     ")])
    }), 0) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.moment(usr.insertTime).startOf('hour').fromNow()))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('userStatus')[[usr.status]]))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.openUserFrom(usr)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit fa-2x"
    })])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer pb-0 pt-3"
  }, [_c('simple-pagination', {
    attrs: {
      "currentpage": _vm.form.page,
      "pages": _vm.form.totalpages
    },
    on: {
      "changePage": _vm.pageChange
    }
  })], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}

/***/ }),
/* 721 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.name,
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "bsModalLabel",
      "data-toggle": "modal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "bsModalLabel"
    }
  }, [_vm._v(_vm._s(_vm.$t('tasklist')[[_vm.userType - 3]]) + " -> " + _vm._s(_vm.$t('name')) + ":" + _vm._s(_vm.patientInfo.name) + " ,  " + _vm._s(_vm.$t('age')) + " : " + _vm._s(new Date().getFullYear() - _vm.patientInfo.yob) + "  " + _vm._s(_vm.$t('years')))])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "modal-body center",
    staticStyle: {
      "min-height": "450px"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin fa-5x text-primary",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "input-group",
    staticStyle: {
      "width": "100%",
      "paddingBottom": "15px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.contactNumber),
      expression: "search.contactNumber"
    }],
    staticClass: "input-group-text ",
    attrs: {
      "type": "text",
      "placeholder": ("" + (_vm.$t('contactNumber_name')))
    },
    domProps: {
      "value": (_vm.search.contactNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "contactNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.locationName),
      expression: "search.locationName"
    }],
    staticClass: "input-group-text ",
    attrs: {
      "type": "text",
      "placeholder": ("" + (_vm.$t('location')))
    },
    domProps: {
      "value": (_vm.search.locationName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "locationName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.search.userType == 3) ? _c('span', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.userOptionsConsultant),
      expression: "search.userOptionsConsultant"
    }],
    staticClass: "input-group-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.search, "userOptionsConsultant", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('ConsultantLbl')))]), _vm._v(" "), _vm._l((_vm.$t('userOptionsConsultant')), function(w, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n                           " + _vm._s(w) + "\n                          ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.search.userType == 4) ? _c('span', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.userOptionsAmbulance),
      expression: "search.userOptionsAmbulance"
    }],
    staticClass: "input-group-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.search, "userOptionsAmbulance", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('AmbulanceLbl')))]), _vm._v(" "), _vm._l((_vm.$t('userOptionsAmbulance')), function(w, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n                           " + _vm._s(w) + "\n                          ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.search.userType == 5) ? _c('span', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.userOptionsDelivery),
      expression: "search.userOptionsDelivery"
    }],
    staticClass: "input-group-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.search, "userOptionsDelivery", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('DeliveryLbl')))]), _vm._v(" "), _vm._l((_vm.$t('userOptionsDelivery')), function(w, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n                           " + _vm._s(w) + "\n                          ")])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success padding5",
    on: {
      "click": function($event) {
        return _vm.searchClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('search')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-success padding5",
    on: {
      "click": function($event) {
        return _vm.clearClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('clear')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "scrollbar scrollbar-black bordered-black square",
    staticStyle: {
      "max-height": "250px",
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('name')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('contactNumber')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('optionsLbl')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('cases')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('action')) + " ")])]), _vm._v(" "), _vm._l((_vm.forwards), function(usr) {
    return _c('tr', {
      key: usr.id
    }, [_c('td', [_vm._v(_vm._s(usr.name) + "/" + _vm._s(usr.locationName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(usr.contactNumber))]), _vm._v(" "), _c('td', [(_vm.search.userType == 3) ? _c('span', _vm._l((_vm.$t('userOptionsConsultant')), function(w, i) {
      return _c('i', {
        key: i
      }, [_vm._v("\n                                    " + _vm._s(usr.userOptionsConsultant.indexOf(i) >= 0 ? w : '') + "\n                            ")])
    }), 0) : _vm._e(), _vm._v(" "), (_vm.search.userType == 4) ? _c('span', _vm._l((_vm.$t('userOptionsAmbulance')), function(w, i) {
      return _c('i', {
        key: i
      }, [_vm._v("\n                              " + _vm._s(usr.userOptionsAmbulance.indexOf(i) >= 0 ? w : '') + "\n                      ")])
    }), 0) : _vm._e(), _vm._v(" "), (_vm.search.userType == 5) ? _c('span', _vm._l((_vm.$t('userOptionsDelivery')), function(w, i) {
      return _c('i', {
        key: i
      }, [_vm._v("\n                              " + _vm._s(usr.userOptionsDelivery.indexOf(i) >= 0 ? w : '') + "\n                      ")])
    }), 0) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(usr.activeCases))]), _vm._v(" "), _c('td', [_c('input', {
      attrs: {
        "type": "radio",
        "name": "fuser"
      },
      domProps: {
        "value": usr.id
      },
      on: {
        "change": function($event) {
          return _vm.selectThis(usr)
        }
      }
    })])])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('warning')))]), _vm._v(" "), (_vm.search.userType == 3) ? _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.$t('consultantTasks')), function(s, i) {
    return _c('li', {
      key: i,
      staticClass: "list-group-item"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.taskForward.taskType),
        expression: "taskForward.taskType"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": i,
        "checked": Array.isArray(_vm.taskForward.taskType) ? _vm._i(_vm.taskForward.taskType, i) > -1 : (_vm.taskForward.taskType)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.taskForward.taskType,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = i,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.taskForward, "taskType", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.taskForward, "taskType", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.taskForward, "taskType", $$c)
          }
        }
      }
    }), _vm._v("\n                            " + _vm._s(s) + "\n                            ")])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.search.userType == 4) ? _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.$t('ambulanceTasks')), function(s, i) {
    return _c('li', {
      key: i,
      staticClass: "list-group-item"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.taskForward.taskType),
        expression: "taskForward.taskType"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": i,
        "checked": Array.isArray(_vm.taskForward.taskType) ? _vm._i(_vm.taskForward.taskType, i) > -1 : (_vm.taskForward.taskType)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.taskForward.taskType,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = i,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.taskForward, "taskType", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.taskForward, "taskType", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.taskForward, "taskType", $$c)
          }
        }
      }
    }), _vm._v("\n                            " + _vm._s(s) + "\n                            ")])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.search.userType == 5) ? _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.$t('deliveryTasks')), function(s, i) {
    return _c('li', {
      key: i,
      staticClass: "list-group-item"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.taskForward.taskType),
        expression: "taskForward.taskType"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": i,
        "checked": Array.isArray(_vm.taskForward.taskType) ? _vm._i(_vm.taskForward.taskType, i) > -1 : (_vm.taskForward.taskType)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.taskForward.taskType,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = i,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.taskForward, "taskType", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.taskForward, "taskType", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.taskForward, "taskType", $$c)
          }
        }
      }
    }), _vm._v("\n                            " + _vm._s(s) + "\n                            ")])])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.taskForward.priority),
      expression: "taskForward.priority"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": ("" + (_vm.$t('priorityLbl')))
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.taskForward, "priority", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$t('priorityData')), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n        " + _vm._s(s) + "\n        ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.taskForward.comments),
      expression: "taskForward.comments"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "comments",
      "id": "comments",
      "placeholder": ("" + (_vm.$t('comments')))
    },
    domProps: {
      "value": (_vm.taskForward.comments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.taskForward, "comments", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-success ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submit($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('submit')))])]), _vm._v(" "), (_vm.error.length > 0) ? _c('div', {
    staticClass: "alert alert-danger padding5"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}

/***/ }),
/* 722 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('rationdistributor_list')))]), _vm._v(" "), _c('loading', {
    attrs: {
      "loadingText": ("" + (_vm.$t('loading'))),
      "id": "loadMe",
      "loadinSubText": ("" + (_vm.$t('please_wait')))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "bsModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "bsModalLabel",
      "data-toggle": "modal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "bsModalLabel"
    }
  }, [_vm._v(_vm._s(_vm.$t('rationdistributor_form')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.contactNumber),
      expression: "form.contactNumber"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "contactNumber",
      "id": "contactNumber",
      "placeholder": ("" + (_vm.$t('contactNumber')))
    },
    domProps: {
      "value": (_vm.form.contactNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "contactNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "name",
      "id": "name",
      "placeholder": ("" + (_vm.$t('name')))
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.idNumber),
      expression: "form.idNumber"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "idNumber",
      "id": "idNumber",
      "placeholder": ("" + (_vm.$t('idNumber')))
    },
    domProps: {
      "value": (_vm.form.idNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "idNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('distributorType')))]), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.$t('distributorTypeData')), function(s, i) {
    return _c('li', {
      key: i,
      staticClass: "list-group-item"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.distributorType),
        expression: "form.distributorType"
      }],
      attrs: {
        "type": "radio",
        "name": "distributorType"
      },
      domProps: {
        "value": i,
        "checked": _vm._q(_vm.form.distributorType, i)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.form, "distributorType", i)
        }
      }
    }), _vm._v("\n          " + _vm._s(s) + "\n          ")])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.distributorOrgName),
      expression: "form.distributorOrgName"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "distributorOrgName",
      "id": "distributorOrgName",
      "placeholder": ("" + (_vm.$t('distributorOrgName')))
    },
    domProps: {
      "value": (_vm.form.distributorOrgName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "distributorOrgName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.location),
      expression: "form.location"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": ("" + (_vm.$t('locationName')))
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.updateDistrict]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('locationName')))]), _vm._v(" "), _vm._l((_vm.locationNames), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": {
          lat: s.latitude,
          lng: s.longitude,
          district: s.district,
          state: s.state,
          name: s.locationName
        }
      }
    }, [_vm._v("\n          " + _vm._s(s.locationName) + "\n        ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.ward_village),
      expression: "form.ward_village"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "ward_village",
      "id": "ward_village",
      "placeholder": ("" + (_vm.$t('ward_village')))
    },
    domProps: {
      "value": (_vm.form.ward_village)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "ward_village", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.city_union),
      expression: "form.city_union"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "city_union",
      "id": "city_union",
      "placeholder": ("" + (_vm.$t('city_union')))
    },
    domProps: {
      "value": (_vm.form.city_union)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "city_union", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.form._id) ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.active),
      expression: "form.active"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": ("" + (_vm.$t('activeLbl')))
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "active", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$t('activeData')), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n          " + _vm._s(s) + "\n          ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', [_c('i', {
    staticClass: "fa fa-spin fa-spinner fa-3x"
  })]) : _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-success ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('submit')))])]), _vm._v(" "), (_vm.error.length > 0) ? _c('div', {
    staticClass: "alert alert-danger padding5"
  }, _vm._l((_vm.error), function(s, i) {
    return _c('p', {
      key: i
    }, [_vm._v("\n                           \n                            \n                            " + _vm._s(_vm.$t(s)) + "\n                           \n                        ")])
  }), 0) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": _vm.openFrom
    }
  }, [_vm._v(_vm._s(_vm.$t('add_new')))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.contactNumber),
      expression: "search.contactNumber"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "contactNumber",
      "placeholder": ("" + (_vm.$t('contactNumber')))
    },
    domProps: {
      "value": (_vm.search.contactNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "contactNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.name),
      expression: "search.name"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "name",
      "placeholder": ("" + (_vm.$t('name')))
    },
    domProps: {
      "value": (_vm.search.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.idNumber),
      expression: "search.idNumber"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "idNumber",
      "placeholder": ("" + (_vm.$t('idNumber')))
    },
    domProps: {
      "value": (_vm.search.idNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "idNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.locationName),
      expression: "search.locationName"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "locationName",
      "placeholder": ("" + (_vm.$t('locationName')))
    },
    domProps: {
      "value": (_vm.search.locationName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "locationName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.district),
      expression: "search.district"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "district",
      "placeholder": ("" + (_vm.$t('district')))
    },
    domProps: {
      "value": (_vm.search.district)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "district", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.ward_village),
      expression: "search.ward_village"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "ward_village",
      "placeholder": ("" + (_vm.$t('ward_village')))
    },
    domProps: {
      "value": (_vm.search.ward_village)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "ward_village", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.city_union),
      expression: "search.city_union"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "city_union",
      "placeholder": ("" + (_vm.$t('city_union')))
    },
    domProps: {
      "value": (_vm.search.city_union)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "city_union", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.active),
      expression: "search.active"
    }],
    staticClass: "input-group-select",
    attrs: {
      "placeholder": ("" + (_vm.$t('activeLbl')))
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.search, "active", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('activeLbl')))]), _vm._v(" "), _vm._l((_vm.$t('activeData')), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n          " + _vm._s(s) + "\n          ")])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success padding5",
    on: {
      "click": _vm.searchClick
    }
  }, [_vm._v(_vm._s(_vm.$t('search')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-success padding5",
    on: {
      "click": _vm.clearClick
    }
  }, [_vm._v(_vm._s(_vm.$t('clear')))])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10px"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('contactNumber')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('idNumber')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('locationName')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('ward_village')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('city_union')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('district')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('state')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('enterBy')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('active')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('action')) + " ")])]), _vm._v(" "), _vm._l((_vm.rationdistributors), function(rationdistributor) {
    return _c('tr', {
      key: rationdistributor.id
    }, [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(rationdistributor.contactNumber) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(rationdistributor.name) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(rationdistributor.location.name != undefined ? rationdistributor.location.district : '') + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(rationdistributor.idNumber) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(rationdistributor.ward_village) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(rationdistributor.city_union) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(rationdistributor.location.district != undefined ? rationdistributor.location.district : '') + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(rationdistributor.location.state != undefined ? rationdistributor.location.state : '') + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(rationdistributor.enterBy) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n\n      " + _vm._s(_vm.$t('activeData')[[rationdistributor.active]]) + "\n      \n")]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.openFrom(rationdistributor)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit fa-2x"
    })])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer pb-0 pt-3"
  }, [_c('simple-pagination', {
    attrs: {
      "currentpage": _vm.search.page,
      "pages": _vm.search.totalpages
    },
    on: {
      "changePage": _vm.pageChange
    }
  })], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}

/***/ }),
/* 723 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar",
    attrs: {
      "id": "slider"
    }
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "user-panel"
  }, [_c('div', {
    staticClass: "pull-left image"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": _vm.avatar,
      "alt": "User Image"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pull-left info"
  }, [_c('p', [_vm._v(_vm._s(_vm.currentUser.name))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle",
    style: (("color:" + (_vm.currentUser.state.color)))
  }), _vm._v(" " + _vm._s(_vm.currentUser.state.name))])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "sidebar-menu",
    attrs: {
      "data-widget": "tree"
    }
  }, _vm._l((_vm.slideMenuItems), function(item, index) {
    return _c('va-slide-item', {
      key: index,
      attrs: {
        "data": item,
        "type": item.type,
        "isHeader": item.isHeader,
        "icon": item.icon,
        "name": item.name,
        "badge": item.badge,
        "items": item.items,
        "router": item.router,
        "link": item.link,
        "permission": item.permission,
        "userRole": _vm.userRole
      }
    })
  }), 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "sidebar-form",
    attrs: {
      "action": "#",
      "method": "get"
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "q",
      "placeholder": "Search..."
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-flat",
    attrs: {
      "type": "submit",
      "name": "search",
      "id": "search-btn"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])
}]}

/***/ }),
/* 724 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 box"
  }, [_c('div', {
    staticClass: "roomTitle"
  }, [(_vm.loading) ? _c('span', [_vm._v(" Loading... " + _vm._s(_vm.roomName))]) : (!_vm.loading && _vm.roomName) ? _c('span', [_vm._v(" Connected to " + _vm._s(_vm.roomName))]) : _c('span', [_vm._v("Select a room to get started")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "spacing"
  }), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row remote_video_container"
  }, [_c('div', {
    attrs: {
      "id": "remoteTrack"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    attrs: {
      "id": "localTrack"
    }
  })])
}]}

/***/ }),
/* 725 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row roomForm"
  }, [_c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createNewRoom(_vm.room_name)
      }
    }
  }, [_c('div', {
    staticClass: "form-group mb-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.room_name),
      expression: "room_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.room_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.room_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary mb-2 createRoomBotton",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Create Room")])])])
},staticRenderFns: []}

/***/ }),
/* 726 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('transportvehicle_list')))]), _vm._v(" "), _c('loading', {
    attrs: {
      "loadingText": ("" + (_vm.$t('loading'))),
      "id": "loadMe",
      "loadinSubText": ("" + (_vm.$t('please_wait')))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "bsModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "bsModalLabel",
      "data-toggle": "modal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "bsModalLabel"
    }
  }, [_vm._v(_vm._s(_vm.$t('transportvehicle_form')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.contactNumber),
      expression: "form.contactNumber"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "contactNumber",
      "id": "contactNumber",
      "placeholder": ("" + (_vm.$t('contactNumber')))
    },
    domProps: {
      "value": (_vm.form.contactNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "contactNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "name",
      "id": "name",
      "placeholder": ("" + (_vm.$t('name')))
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.idNumber),
      expression: "form.idNumber"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "idNumber",
      "id": "idNumber",
      "placeholder": ("" + (_vm.$t('idNumber')))
    },
    domProps: {
      "value": (_vm.form.idNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "idNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.registrationNumber),
      expression: "form.registrationNumber"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "registrationNumber",
      "id": "registrationNumber",
      "placeholder": ("" + (_vm.$t('registrationNumber')))
    },
    domProps: {
      "value": (_vm.form.registrationNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "registrationNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.capacity),
      expression: "form.capacity"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": ("" + (_vm.$t('capacityLbl')))
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "capacity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$t('capacityData')), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i,
        "selected": _vm.form.capacity == i
      }
    }, [_vm._v("\n        " + _vm._s(s) + "\n        ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('loadingSetting')))]), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.$t('loadingSettingData')), function(s, i) {
    return _c('li', {
      key: i,
      staticClass: "list-group-item"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.loadingSetting),
        expression: "form.loadingSetting"
      }],
      attrs: {
        "type": "checkbox",
        "name": "loadingSetting",
        "true-value": i
      },
      domProps: {
        "value": i,
        "checked": Array.isArray(_vm.form.loadingSetting) ? _vm._i(_vm.form.loadingSetting, i) > -1 : _vm._q(_vm.form.loadingSetting, i)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.form.loadingSetting,
            $$el = $event.target,
            $$c = $$el.checked ? (i) : (false);
          if (Array.isArray($$a)) {
            var $$v = i,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.form, "loadingSetting", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.form, "loadingSetting", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.form, "loadingSetting", $$c)
          }
        }
      }
    }), _vm._v("\n                            " + _vm._s(s) + "\n                            ")])])
  }), 0)]), _vm._v(" "), (_vm.loading) ? _c('div', [_c('i', {
    staticClass: "fa fa-spin fa-spinner fa-3x"
  })]) : _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-success ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('submit')))])]), _vm._v(" "), (_vm.error.length > 0) ? _c('div', {
    staticClass: "alert alert-danger padding5"
  }, _vm._l((_vm.error), function(s, i) {
    return _c('p', {
      key: i
    }, [_vm._v("\n                           \n                            \n                            " + _vm._s(_vm.$t(s)) + "\n                           \n                        ")])
  }), 0) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": _vm.openFrom
    }
  }, [_vm._v(_vm._s(_vm.$t('add_new')))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.contactNumber),
      expression: "search.contactNumber"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "contactNumber",
      "placeholder": ("" + (_vm.$t('contactNumber')))
    },
    domProps: {
      "value": (_vm.search.contactNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "contactNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.name),
      expression: "search.name"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "name",
      "placeholder": ("" + (_vm.$t('name')))
    },
    domProps: {
      "value": (_vm.search.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.idNumber),
      expression: "search.idNumber"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "idNumber",
      "placeholder": ("" + (_vm.$t('idNumber')))
    },
    domProps: {
      "value": (_vm.search.idNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "idNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.registrationNumber),
      expression: "search.registrationNumber"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "registrationNumber",
      "placeholder": ("" + (_vm.$t('registrationNumber')))
    },
    domProps: {
      "value": (_vm.search.registrationNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "registrationNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.capacity),
      expression: "search.capacity"
    }],
    staticClass: "input-group-select",
    attrs: {
      "placeholder": ("" + (_vm.$t('capacityLbl')))
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.search, "capacity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('capacityLbl')))]), _vm._v(" "), _vm._l((_vm.$t('capacityData')), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n          " + _vm._s(s) + "\n          ")])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.status),
      expression: "search.status"
    }],
    staticClass: "input-group-select",
    attrs: {
      "placeholder": ("" + (_vm.$t('statusLbl')))
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.search, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('statusLbl')))]), _vm._v(" "), _vm._l((_vm.$t('vehicleStatusData')), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n          " + _vm._s(s) + "\n          ")])
  })], 2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.loadingSetting),
      expression: "search.loadingSetting"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "loadingSetting",
      "placeholder": ("" + (_vm.$t('loadingSetting')))
    },
    domProps: {
      "value": (_vm.search.loadingSetting)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "loadingSetting", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success padding5",
    on: {
      "click": _vm.searchClick
    }
  }, [_vm._v(_vm._s(_vm.$t('search')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-success padding5",
    on: {
      "click": _vm.clearClick
    }
  }, [_vm._v(_vm._s(_vm.$t('clear')))])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10px"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('contactNumber')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('idNumber')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('registrationNumber')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('capacity')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('insertTime')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('status')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('loadingSetting')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('action')) + " ")])]), _vm._v(" "), _vm._l((_vm.transportvehicles), function(transportvehicle) {
    return _c('tr', {
      key: transportvehicle.id
    }, [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(transportvehicle.contactNumber) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(transportvehicle.name) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(transportvehicle.idNumber) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(transportvehicle.registrationNumber) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n\n      " + _vm._s(_vm.$t('capacityData')[[transportvehicle.capacity]]) + "\n      \n")]), _vm._v(" "), _c('td', [_vm._v("\n\n        " + _vm._s(_vm.moment(transportvehicle.insertTime).startOf('hour').fromNow()) + "\n        \n")]), _vm._v(" "), _c('td', [_vm._v("\n\n      " + _vm._s(_vm.$t('vehicleStatusData')[[transportvehicle.status]]) + "\n      \n")]), _vm._v(" "), _c('td', _vm._l((_vm.$t('loadingSettingData')), function(w, i) {
      return _c('i', {
        key: i
      }, [_vm._v("\n                              " + _vm._s(transportvehicle.loadingSetting.indexOf(i) >= 0 ? w : '') + "\n                      ")])
    }), 0), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.openFrom(transportvehicle)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit fa-2x"
    })])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer pb-0 pt-3"
  }, [_c('simple-pagination', {
    attrs: {
      "currentpage": _vm.search.page,
      "pages": _vm.search.totalpages
    },
    on: {
      "changePage": _vm.pageChange
    }
  })], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}

/***/ }),
/* 727 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patient-list-row"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.$t('patient_list')))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "input-group-text ",
    attrs: {
      "type": "text",
      "placeholder": ("" + (_vm.$t('name')))
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.address),
      expression: "form.address"
    }],
    staticClass: "input-group-text ",
    attrs: {
      "type": "text",
      "placeholder": ("" + (_vm.$t('address')))
    },
    domProps: {
      "value": (_vm.form.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "address", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.contactNumber),
      expression: "form.contactNumber"
    }],
    staticClass: "input-group-text ",
    attrs: {
      "type": "text",
      "placeholder": ("" + (_vm.$t('contactNumber')))
    },
    domProps: {
      "value": (_vm.form.contactNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "contactNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.gender),
      expression: "form.gender"
    }],
    staticClass: "input-group-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('gender')))]), _vm._v(" "), _vm._l((_vm.$t('sex')), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n                         " + _vm._s(s) + "\n                        ")])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.weight),
      expression: "form.weight"
    }],
    staticClass: "input-group-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "weight", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('weight')))]), _vm._v(" "), _vm._l((_vm.$t('weightData')), function(w, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n                         " + _vm._s(w) + "\n                        ")])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.condition),
      expression: "form.condition"
    }],
    staticClass: "input-group-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "condition", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('condition')))]), _vm._v(" "), _vm._l((_vm.$t('conditionData')), function(w, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n                         " + _vm._s(w) + "\n                        ")])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.status),
      expression: "form.status"
    }],
    staticClass: "input-group-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('status')))]), _vm._v(" "), _vm._l((_vm.$t('statusData')), function(w, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n                         " + _vm._s(w) + "\n                        ")])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.riskFactor),
      expression: "form.riskFactor"
    }],
    staticClass: "input-group-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "riskFactor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('riskFactorLbl')))]), _vm._v(" "), _vm._l((_vm.$t('riskFactor')), function(w, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n                         " + _vm._s(w) + "\n                        ")])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.currentRating),
      expression: "form.currentRating"
    }],
    staticClass: "input-group-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "currentRating", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('symptom')))]), _vm._v(" "), _vm._l((_vm.$t('riskFactor')), function(w, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n                         " + _vm._s(w) + "\n                        ")])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.trend),
      expression: "form.trend"
    }],
    staticClass: "input-group-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "trend", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('trend')))]), _vm._v(" "), _vm._l((_vm.$t('trendData')), function(w, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n                         " + _vm._s(w) + "\n                        ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "inlineDiv"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.age1),
      expression: "form.age1"
    }],
    staticClass: "input-group-text-small",
    attrs: {
      "type": "text",
      "placeholder": ("" + (_vm.$t('ageFrom')))
    },
    domProps: {
      "value": (_vm.form.age1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "age1", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.age2),
      expression: "form.age2"
    }],
    staticClass: "input-group-text-small ",
    attrs: {
      "type": "text",
      "placeholder": ("" + (_vm.$t('ageTo')))
    },
    domProps: {
      "value": (_vm.form.age2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "age2", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-success padding5",
    on: {
      "click": _vm.searchClick
    }
  }, [_vm._v(_vm._s(_vm.$t('search')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-success padding5",
    on: {
      "click": _vm.clearClick
    }
  }, [_vm._v(_vm._s(_vm.$t('clear')))])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10px"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('age')) + " / " + _vm._s(_vm.$t('gender')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40px"
    }
  }, [_vm._v(_vm._s(_vm.$t('address')) + " ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40px"
    }
  }, [_vm._v(_vm._s(_vm.$t('weight')) + "/" + _vm._s(_vm.$t('height')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('contactNumber')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('status')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('risk')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('symptom')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('trend')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('registerDate')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('lastUpdate')) + " ")])]), _vm._v(" "), _vm._l((_vm.patients), function(pateint) {
    return _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": ("/patient-details?id=" + (pateint.id))
      }
    }, [_vm._v(_vm._s(pateint.name))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pateint.age) + " " + _vm._s(_vm.$t('sex')[[pateint.gender]]) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pateint.address) + " " + _vm._s(pateint.city))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('weightData')[[pateint.wight]]) + " /" + _vm._s(_vm.$t('heightData')[[pateint.height]]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pateint.contactNumber) + " , " + _vm._s(pateint.enterBy != pateint.contactNumber ? pateint.enterBy : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('statusData')[[pateint.status]]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('riskFactor')[[_vm.calRiskFactor_(pateint.riskFactor)]]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('riskFactor')[[_vm.calSymptom_(pateint.currentRating)]]))]), _vm._v(" "), _c('td', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.showTrend_(pateint.trend))
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.moment(pateint.insertTime).startOf('hour').fromNow()))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pateint.updateTime > 0 ? _vm.moment(pateint.updateTime).startOf('hour').fromNow() : 'Never'))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer pb-0 pt-3"
  }, [_c('simple-pagination', {
    attrs: {
      "currentpage": _vm.form.page,
      "pages": _vm.form.totalpages
    },
    on: {
      "changePage": _vm.pageChange
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 728 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('canvas')
},staticRenderFns: []}

/***/ }),
/* 729 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('requestforration_list')))]), _vm._v(" "), _c('loading', {
    attrs: {
      "loadingText": ("" + (_vm.$t('loading'))),
      "id": "loadMe",
      "loadinSubText": ("" + (_vm.$t('please_wait')))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "bsModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "bsModalLabel",
      "data-toggle": "modal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "bsModalLabel"
    }
  }, [_vm._v(_vm._s(_vm.$t('requestforration_form')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.contactNumber),
      expression: "form.contactNumber"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "contactNumber",
      "id": "contactNumber",
      "placeholder": ("" + (_vm.$t('contactNumber')))
    },
    domProps: {
      "value": (_vm.form.contactNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "contactNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "name",
      "id": "name",
      "placeholder": ("" + (_vm.$t('name')))
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.idNumber),
      expression: "form.idNumber"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "idNumber",
      "id": "idNumber",
      "placeholder": ("" + (_vm.$t('idNumber')))
    },
    domProps: {
      "value": (_vm.form.idNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "idNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.age),
      expression: "form.age"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "age",
      "id": "age",
      "placeholder": ("" + (_vm.$t('age')))
    },
    domProps: {
      "value": (_vm.form.age)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "age", $event.target.value)
      }, function($event) {
        return _vm.$emit('input', $event)
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.yob),
      expression: "form.yob"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "yob",
      "id": "yob",
      "placeholder": ("" + (_vm.$t('yob')))
    },
    domProps: {
      "value": (_vm.form.yob)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "yob", $event.target.value)
      }, function($event) {
        return _vm.$emit('input', $event)
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.gender),
      expression: "form.gender"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('gender')))]), _vm._v(" "), _vm._l((_vm.$t('sex')), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n                           " + _vm._s(s) + "\n                          ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.address),
      expression: "form.address"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "address",
      "id": "address",
      "placeholder": ("" + (_vm.$t('address')))
    },
    domProps: {
      "value": (_vm.form.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "address", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.city),
      expression: "form.city"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "city",
      "id": "city",
      "placeholder": ("" + (_vm.$t('city')))
    },
    domProps: {
      "value": (_vm.form.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "city", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.state),
      expression: "form.state"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "state",
      "id": "state",
      "placeholder": ("" + (_vm.$t('state')))
    },
    domProps: {
      "value": (_vm.form.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "state", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.zipcode),
      expression: "form.zipcode"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "zipcode",
      "id": "zipcode",
      "placeholder": ("" + (_vm.$t('zipcode')))
    },
    domProps: {
      "value": (_vm.form.zipcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "zipcode", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.loading) ? _c('div', [_c('i', {
    staticClass: "fa fa-spin fa-spinner fa-3x"
  })]) : _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-success ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('submit')))])]), _vm._v(" "), (_vm.error.length > 0) ? _c('div', {
    staticClass: "alert alert-danger padding5"
  }, _vm._l((_vm.error), function(s, i) {
    return _c('p', {
      key: i
    }, [_vm._v("\n                           \n                            \n                            " + _vm._s(_vm.$t(s)) + "\n                           \n                        ")])
  }), 0) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": _vm.openFrom
    }
  }, [_vm._v(_vm._s(_vm.$t('add_new')))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.contactNumber),
      expression: "search.contactNumber"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "contactNumber",
      "placeholder": ("" + (_vm.$t('contactNumber')))
    },
    domProps: {
      "value": (_vm.search.contactNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "contactNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.name),
      expression: "search.name"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "name",
      "placeholder": ("" + (_vm.$t('name')))
    },
    domProps: {
      "value": (_vm.search.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.idNumber),
      expression: "search.idNumber"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "idNumber",
      "placeholder": ("" + (_vm.$t('idNumber')))
    },
    domProps: {
      "value": (_vm.search.idNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "idNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.yob1),
      expression: "search.yob1"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "yob1",
      "placeholder": ("" + (_vm.$t('ageMin')))
    },
    domProps: {
      "value": (_vm.search.yob1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "yob1", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.yob2),
      expression: "search.yob2"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "yob2",
      "placeholder": ("" + (_vm.$t('ageMax')))
    },
    domProps: {
      "value": (_vm.search.yob2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "yob2", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.gender),
      expression: "search.gender"
    }],
    staticClass: "input-group-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.search, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('gender')))]), _vm._v(" "), _vm._l((_vm.$t('sex')), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n                           " + _vm._s(s) + "\n                          ")])
  })], 2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.address),
      expression: "search.address"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "address",
      "placeholder": ("" + (_vm.$t('address')))
    },
    domProps: {
      "value": (_vm.search.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "address", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.city),
      expression: "search.city"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "city",
      "placeholder": ("" + (_vm.$t('city')))
    },
    domProps: {
      "value": (_vm.search.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "city", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.zipcode),
      expression: "search.zipcode"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "zipcode",
      "placeholder": ("" + (_vm.$t('zipcode')))
    },
    domProps: {
      "value": (_vm.search.zipcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "zipcode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.status),
      expression: "search.status"
    }],
    staticClass: "input-group-select",
    attrs: {
      "placeholder": ("" + (_vm.$t('statusLbl')))
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.search, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('statusLbl')))]), _vm._v(" "), _vm._l((_vm.$t('rationRequestStatus')), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n          " + _vm._s(s) + "\n          ")])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success padding5",
    on: {
      "click": _vm.searchClick
    }
  }, [_vm._v(_vm._s(_vm.$t('search')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-success padding5",
    on: {
      "click": _vm.clearClick
    }
  }, [_vm._v(_vm._s(_vm.$t('clear')))])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10px"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('contactNumber')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('idNumber')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('age')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('gender')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('address')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('city')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('state')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('zipcode')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('insertTime')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('status')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('action')) + " ")])]), _vm._v(" "), _vm._l((_vm.requestforrations), function(requestforration) {
    return _c('tr', {
      key: requestforration.id
    }, [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(requestforration.contactNumber) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(requestforration.name) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(requestforration.idNumber) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(_vm.currentYear - requestforration.yob) + " \n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(_vm.$t('sex')[[requestforration.gender]]) + "\n\t")]), _c('td', [_vm._v("\n" + _vm._s(requestforration.address) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(requestforration.city) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(requestforration.state) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(requestforration.zipcode) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n\n        " + _vm._s(_vm.moment(requestforration.insertTime).startOf('hour').fromNow()) + "\n        \n")]), _vm._v(" "), _c('td', [_vm._v("\n\n      " + _vm._s(_vm.$t('rationRequestStatus')[[requestforration.status]]) + "\n      \n")]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.openFrom(requestforration)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit fa-2x"
    })])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer pb-0 pt-3"
  }, [_c('simple-pagination', {
    attrs: {
      "currentpage": _vm.search.page,
      "pages": _vm.search.totalpages
    },
    on: {
      "changePage": _vm.pageChange
    }
  })], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}

/***/ }),
/* 730 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}

/***/ }),
/* 731 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Quick Email")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right box-tools"
  }, [_c('button', {
    staticClass: "btn btn-info btn-sm",
    attrs: {
      "type": "button",
      "data-widget": "remove",
      "data-toggle": "tooltip",
      "title": "Remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "emailto",
      "placeholder": "Email to:"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "subject",
      "placeholder": "Subject"
    }
  })]), _vm._v(" "), _c('div', [_c('textarea', {
    staticClass: "textarea",
    staticStyle: {
      "width": "100%",
      "height": "125px",
      "font-size": "14px",
      "line-height": "18px",
      "border": "1px solid #dddddd",
      "padding": "10px"
    },
    attrs: {
      "placeholder": "Message"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer clearfix"
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "id": "sendEmail"
    }
  }, [_vm._v("Send\n      "), _c('i', {
    staticClass: "fa fa-arrow-circle-right"
  })])])])
}]}

/***/ }),
/* 732 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('textarea', {
    staticClass: "form-control",
    attrs: {
      "rows": _vm.rowCount,
      "placeholder": _vm.placeholder,
      "disabled": _vm.isDisabled
    }
  })
},staticRenderFns: []}

/***/ }),
/* 733 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    attrs: {
      "id": "content-wrap"
    }
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('transition', {
    attrs: {
      "name": "page",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      Dashboard\n      "), _c('small', [_vm._v("Version 2.0.23")])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Dashboard")])])])
}]}

/***/ }),
/* 734 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "bsModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "bsModalLabel",
      "data-toggle": "modal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "bsModalLabel"
    }
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v("\n        " + _vm._s(_vm.description) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.cancelText))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(_vm._s(_vm.confirmText))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}

/***/ }),
/* 735 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isHorizontal) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": _vm.vaId
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    class: [_vm.formControl, _vm.getSize],
    attrs: {
      "type": _vm.type,
      "id": _vm.vaId,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  })])]) : _c('input', {
    class: [_vm.formControl, _vm.getSize],
    attrs: {
      "type": _vm.type,
      "id": _vm.vaId,
      "placeholder": _vm.placeholder,
      "disabled": _vm.isDisabled
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}

/***/ }),
/* 736 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login"
    }
  }, [_c('h1', [_vm._v(" Loggin Out ")])])
}]}

/***/ }),
/* 737 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_c('row', _vm._l((_vm.preconditions), function(precondition) {
    return _c('div', {
      key: precondition.id,
      staticClass: "col-lg-3 col-xs-6"
    }, [_c('va-small-box', {
      attrs: {
        "color": _vm.customClass(precondition.status, 'pre'),
        "icon": _vm.customClass(precondition.preCondition, 'icon'),
        "title": _vm.$t(precondition.preCondition),
        "description": _vm.getDescriptions(precondition.status, precondition.preCondition),
        "moreText": _vm.$t(_vm.customClass(precondition.duration, 'duration'))
      },
      on: {
        "more-click": _vm.clickToSmallBox
      }
    })], 1)
  }), 0), _vm._v(" "), _c('task', {
    attrs: {
      "patientInfo": _vm.patientInfo,
      "name": "bsForward",
      "userType": _vm.userType
    }
  }), _vm._v(" "), _c('prescription', {
    attrs: {
      "patientInfo": _vm.patientInfo,
      "name": "bsMedicine"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "well profile"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-8"
  }, [_c('h2', [_c('i', {
    staticClass: "fa fa-female"
  }), _vm._v(_vm._s(_vm.patientInfo.name) + "    "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.showTrend(_vm.patientInfo.trend))
    }
  })]), _vm._v(" "), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.$t('contactNumber')) + ": ")]), _c('a', {
    attrs: {
      "href": ("tel:+" + (_vm.patientInfo.contactNumber))
    }
  }, [_c('i', {
    staticClass: "fa fa-mobile fa-2x"
  }), _vm._v(" " + _vm._s(_vm.patientInfo.contactNumber))]), _vm._v("   |  "), _c('a', {
    attrs: {
      "href": ("tel:+" + (_vm.patientInfo.enterBy))
    }
  }, [_c('i', {
    staticClass: "fa fa-mobile fa-2x"
  }), _vm._v(" " + _vm._s(_vm.patientInfo.enterBy))])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v(" " + _vm._s(_vm.$t('address')) + ": ")]), _vm._v(_vm._s(_vm.patientInfo.locationName) + " " + _vm._s(_vm.patientInfo.address) + " " + _vm._s(_vm.patientInfo.city) + " " + _vm._s(_vm.patientInfo.zipcode) + " " + _vm._s(_vm.patientInfo.state) + " ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.$t('physical')) + ": ")]), _vm._v(" "), _c('span', {
    staticClass: "tags"
  }, [_vm._v(_vm._s(_vm.$t('heightData')[[_vm.patientInfo.height]]))]), _vm._v(" "), _c('span', {
    class: _vm.customClass(_vm.patientInfo.wight)
  }, [_vm._v(_vm._s(_vm.$t('weightData')[[_vm.patientInfo.wight]]))])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.$t('age')) + ": ")]), _vm._v(" "), _c('span', {
    class: _vm.customClass(_vm.patientInfo.yob, 'age')
  }, [_vm._v(_vm._s(new Date().getFullYear() - _vm.patientInfo.yob) + "  " + _vm._s(_vm.$t('years')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 text-center"
  }, [_c('figure', [_c('figcaption', {
    staticClass: "ratings"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('risk')) + ":" + _vm._s(_vm.$t('riskFactor')[[_vm.calRiskFactor(_vm.patientInfo.riskFactor)]]) + "\n                           " + _vm._s(_vm.$t('symptom')) + ":" + _vm._s(_vm.$t('riskFactor')[[_vm.calRiskFactor(_vm.patientInfo.currentRating)]]) + "\n                            ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 divider text-center"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-3 emphasis"
  }, [_c('h4', [_c('strong', [_vm._v(" " + _vm._s(_vm.moment(_vm.patientInfo.insertTime).startOf('hour').fromNow()))])]), _vm._v(" "), _c('p', [_c('small', [_vm._v(_vm._s(_vm.$t('registerDate')))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-block",
    on: {
      "click": function($event) {
        return _vm.openTaskFrom(3, $event)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-user-md"
  }), _vm._v(" " + _vm._s(_vm.$t('consultant')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3 emphasis"
  }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.patientInfo.updateTime > 0 ? _vm.moment(_vm.patientInfo.updateTime).startOf('hour').fromNow() : 'Never'))])]), _vm._v(" "), _c('p', [_c('small', [_vm._v(_vm._s(_vm.$t('lastUpdate')))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-block",
    on: {
      "click": function($event) {
        return _vm.openTaskFrom(4, $event)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-ambulance"
  }), _vm._v(" " + _vm._s(_vm.$t('ambulance')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3 emphasis"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_c('small', [_vm._v(_vm._s(_vm.$t('lastUpdate')))])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group dropup btn-block"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openTaskFrom(5, $event)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-motorcycle"
  }), _vm._v(" " + _vm._s(_vm.$t('filed_staff')) + "  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3 emphasis"
  }, [_vm._m(1), _vm._v(" "), _c('p', [_c('small', [_vm._v(_vm._s(_vm.$t('lastUpdate')))])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group dropup btn-block"
  }, [_c('button', {
    staticClass: "btn btn-warning btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openTaskFrom(6, $event)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-hospital-o"
  }), _vm._v(" " + _vm._s(_vm.$t('prescribtion')) + "  ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Symptoms')))])]), _vm._v(" "), (_vm.chartData.data.datasets.length > 0) ? _c('va-chart', {
    attrs: {
      "chart-config": _vm.chartData
    }
  }) : _c('div', {
    staticClass: "center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin fa-5x text-primary",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)]), _vm._v(" "), _c('row', [_c('section', {
    staticClass: "col-lg-6 connectedSortable ui-sortable"
  }, [_c('va-chat-box', {
    attrs: {
      "patient": _vm.patientInfo
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "col-lg-6 connectedSortable ui-sortable"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('Rooms'), _vm._v(" "), _c('Video', {
    attrs: {
      "username": _vm.patientInfo.name
    }
  }), _vm._v(" "), _c('Logs')], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('strong', [_vm._v("43")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('strong', [_vm._v("43")])])
}]}

/***/ }),
/* 738 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('profile')))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('loading', {
    attrs: {
      "loadingText": ("" + (_vm.$t('loading'))),
      "id": "loadMe",
      "loadinSubText": ("" + (_vm.$t('please_wait')))
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    attrs: {
      "type": "file",
      "name": "image",
      "accept": "image/*"
    },
    on: {
      "change": _vm.setImage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "cropper-area"
  }, [_c('div', {
    staticClass: "img-cropper"
  }, [_c('vue-cropper', {
    ref: "cropper",
    attrs: {
      "aspect-ratio": 16 / 16,
      "src": _vm.imgSrc,
      "preview": ".preview"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "role": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showFileChooser($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-image-o"
  }), _vm._v("\n          Upload Image\n        ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "role": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.zoom(0.2)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search-plus"
  }), _vm._v("\n          Zoom In\n        ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "role": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.zoom(-0.2)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search-minus"
  }), _vm._v("\n          Zoom Out\n        ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "role": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.rotate(90)
      }
    }
  }, [_vm._v("\n          Rotate +90deg\n        ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "role": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.rotate(-90)
      }
    }
  }, [_vm._v("\n          Rotate -90deg\n        ")]), _vm._v(" "), _c('a', {
    ref: "flipX",
    attrs: {
      "href": "#",
      "role": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.flipX($event)
      }
    }
  }, [_vm._v("\n          Flip X\n        ")]), _vm._v(" "), _c('a', {
    ref: "flipY",
    attrs: {
      "href": "#",
      "role": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.flipY($event)
      }
    }
  }, [_vm._v("\n          Flip Y\n        ")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "background": "#ff0000"
    },
    attrs: {
      "href": "#",
      "role": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cropImage($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-crop"
  }), _vm._v("\n          Crop\n        ")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "background": "#1fad45"
    },
    attrs: {
      "href": "#",
      "role": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.upload($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v("\n          Save\n        ")])])]), _vm._v(" "), _c('section', {
    staticClass: "preview-area"
  }, [_c('p', [_vm._v("Preview")]), _vm._v(" "), _c('div', {
    staticClass: "preview"
  }), _vm._v(" "), _c('p', [_vm._v("Cropped Image")]), _vm._v(" "), _c('div', {
    staticClass: "cropped-image"
  }, [(_vm.cropImg) ? _c('img', {
    attrs: {
      "src": _vm.cropImg,
      "alt": "Cropped Image"
    }
  }) : _c('div', {
    staticClass: "crop-placeholder"
  })])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 739 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 740 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    attrs: {
      "id": _vm.id,
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "loadMeLabel",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body text-center"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "clas": "loader-txt"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.loadingText)), _c('br'), _c('br'), _c('small', [_vm._v(_vm._s(_vm.loadingSubText))])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader"
  }, [_c('i', {
    staticClass: "fa fa-spinner  fa-pulse fa-3x fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),
/* 741 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('transportrequest_list')))]), _vm._v(" "), _c('loading', {
    attrs: {
      "loadingText": ("" + (_vm.$t('loading'))),
      "id": "loadMe",
      "loadinSubText": ("" + (_vm.$t('please_wait')))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "bsModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "bsModalLabel",
      "data-toggle": "modal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "bsModalLabel"
    }
  }, [_vm._v(_vm._s(_vm.$t('transportrequest_form')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.contactNumber),
      expression: "form.contactNumber"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "contactNumber",
      "id": "contactNumber",
      "placeholder": ("" + (_vm.$t('contactNumber')))
    },
    domProps: {
      "value": (_vm.form.contactNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "contactNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "name",
      "id": "name",
      "placeholder": ("" + (_vm.$t('name')))
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.itemType),
      expression: "form.itemType"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": ("" + (_vm.$t('itemTypeLbl')))
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "itemType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$t('itemTypeData')), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i,
        "selected": _vm.form.itemType == i
      }
    }, [_vm._v("\n        " + _vm._s(s) + "\n        ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.approxQuantity),
      expression: "form.approxQuantity"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "approxQuantity",
      "id": "approxQuantity",
      "placeholder": ("" + (_vm.$t('approxQuantity')))
    },
    domProps: {
      "value": (_vm.form.approxQuantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "approxQuantity", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.packagingType),
      expression: "form.packagingType"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": ("" + (_vm.$t('packagingTypeLbl')))
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "packagingType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$t('packagingTypeData')), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i,
        "selected": _vm.form.packagingType == i
      }
    }, [_vm._v("\n        " + _vm._s(s) + "\n        ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.packageQuantity),
      expression: "form.packageQuantity"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "packageQuantity",
      "id": "packageQuantity",
      "placeholder": ("" + (_vm.$t('packageQuantity')))
    },
    domProps: {
      "value": (_vm.form.packageQuantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "packageQuantity", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.pickupPointName),
      expression: "form.pickupPointName"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "pickupPointName",
      "id": "pickupPointName",
      "placeholder": ("" + (_vm.$t('pickupPointName')))
    },
    domProps: {
      "value": (_vm.form.pickupPointName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "pickupPointName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.deliveryName),
      expression: "form.deliveryName"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "deliveryName",
      "id": "deliveryName",
      "placeholder": ("" + (_vm.$t('deliveryName')))
    },
    domProps: {
      "value": (_vm.form.deliveryName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "deliveryName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-success ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('submit')))])]), _vm._v(" "), (_vm.error.length > 0) ? _c('div', {
    staticClass: "alert alert-danger padding5"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": _vm.openFrom
    }
  }, [_vm._v(_vm._s(_vm.$t('add_new')))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.contactNumber),
      expression: "search.contactNumber"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "contactNumber",
      "placeholder": ("" + (_vm.$t('contactNumber')))
    },
    domProps: {
      "value": (_vm.search.contactNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "contactNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.itemType),
      expression: "search.itemType"
    }],
    staticClass: "input-group-select",
    attrs: {
      "placeholder": ("" + (_vm.$t('itemTypeLbl')))
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.search, "itemType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('itemTypeLbl')))]), _vm._v(" "), _vm._l((_vm.$t('itemTypeData')), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n          " + _vm._s(s) + "\n          ")])
  })], 2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.approxQuantity),
      expression: "search.approxQuantity"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "approxQuantity",
      "placeholder": ("" + (_vm.$t('approxQuantity')))
    },
    domProps: {
      "value": (_vm.search.approxQuantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "approxQuantity", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.packagingType),
      expression: "search.packagingType"
    }],
    staticClass: "input-group-select",
    attrs: {
      "placeholder": ("" + (_vm.$t('packagingTypeLbl')))
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.search, "packagingType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('packagingTypeLbl')))]), _vm._v(" "), _vm._l((_vm.$t('packagingTypeData')), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n          " + _vm._s(s) + "\n          ")])
  })], 2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.pickupPointName),
      expression: "search.pickupPointName"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "pickupPointName",
      "placeholder": ("" + (_vm.$t('pickupPointName')))
    },
    domProps: {
      "value": (_vm.search.pickupPointName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "pickupPointName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.deliveryAddress),
      expression: "search.deliveryAddress"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "deliveryAddress",
      "placeholder": ("" + (_vm.$t('deliveryAddress')))
    },
    domProps: {
      "value": (_vm.search.deliveryAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "deliveryAddress", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.requestType),
      expression: "search.requestType"
    }],
    staticClass: "input-group-select",
    attrs: {
      "placeholder": ("" + (_vm.$t('requestTypeLbl')))
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.search, "requestType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('requestTypeLbl')))]), _vm._v(" "), _vm._l((_vm.$t('requestTypeData')), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n          " + _vm._s(s) + "\n          ")])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.requestType),
      expression: "search.requestType"
    }],
    staticClass: "input-group-select",
    attrs: {
      "placeholder": ("" + (_vm.$t('requestTypeLbl')))
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.search, "requestType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('requestTypeLbl')))]), _vm._v(" "), _vm._l((_vm.$t('requestTypeData')), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n          " + _vm._s(s) + "\n          ")])
  })], 2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.plateNumber),
      expression: "search.plateNumber"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "plateNumber",
      "placeholder": ("" + (_vm.$t('plateNumber')))
    },
    domProps: {
      "value": (_vm.search.plateNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "plateNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.driverContact),
      expression: "search.driverContact"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "driverContact",
      "placeholder": ("" + (_vm.$t('driverContact')))
    },
    domProps: {
      "value": (_vm.search.driverContact)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "driverContact", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.status),
      expression: "search.status"
    }],
    staticClass: "input-group-select",
    attrs: {
      "placeholder": ("" + (_vm.$t('statusLbl')))
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.search, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('statusLbl')))]), _vm._v(" "), _vm._l((_vm.$t('statusData')), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n          " + _vm._s(s) + "\n          ")])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success padding5",
    on: {
      "click": _vm.searchClick
    }
  }, [_vm._v(_vm._s(_vm.$t('search')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-success padding5",
    on: {
      "click": _vm.clearClick
    }
  }, [_vm._v(_vm._s(_vm.$t('clear')))])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10px"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('contactNumber')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('itemType')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('approxQuantity')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('packagingType')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('packageQuantity')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('pickupPointName')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('deliveryPoint')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('requestType')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('enterBy')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('insertTime')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('plateNumber')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('driverContact')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('status')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('action')) + " ")])]), _vm._v(" "), _vm._l((_vm.transportrequests), function(transportrequest) {
    return _c('tr', {
      key: transportrequest.id
    }, [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(transportrequest.contactNumber) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(transportrequest.name) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n\n      " + _vm._s(_vm.$t('itemTypeData')[[transportrequest.itemType]]) + "\n      \n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(transportrequest.approxQuantity) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n\n      " + _vm._s(_vm.$t('packagingTypeData')[[transportrequest.packagingType]]) + "\n      \n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(transportrequest.packageQuantity) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(transportrequest.pickupPointName) + "\n")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("\n\n      " + _vm._s(_vm.$t('requestTypeData')[[transportrequest.requestType]]) + "\n      \n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(transportrequest.enterBy) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n\n        " + _vm._s(_vm.moment(transportrequest.insertTime).startOf('hour').fromNow()) + "\n        \n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(transportrequest.plateNumber) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(transportrequest.driverContact) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n\n      " + _vm._s(_vm.$t('statusData')[[transportrequest.status]]) + "\n      \n")]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.openFrom(transportrequest)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit fa-2x"
    })])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer pb-0 pt-3"
  }, [_c('simple-pagination', {
    attrs: {
      "currentpage": _vm.search.page,
      "pages": _vm.search.totalpages
    },
    on: {
      "changePage": _vm.pageChange
    }
  })], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}

/***/ }),
/* 742 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small-box",
    class: _vm.bgColor
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h3', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.description))])]), _vm._v(" "), _c('div', {
    staticClass: "icon"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": _vm.icon
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "small-box-footer",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.moreEvent
    }
  }, [_vm._v(_vm._s(_vm.moreText) + " ")])])
},staticRenderFns: []}

/***/ }),
/* 743 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isHorizontal) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": _vm.vaId
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('select', {
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.isDisabled,
      "multiple": _vm.isMultiple
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('option', {
      key: index,
      attrs: {
        "data": item
      }
    }, [_vm._v("\n        " + _vm._s(item) + "\n      ")])
  }), 0)])]) : _c('select', {
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.isDisabled,
      "multiple": _vm.isMultiple
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('option', {
      key: index,
      attrs: {
        "data": item
      }
    }, [_vm._v("\n    " + _vm._s(item) + "\n  ")])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 744 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "center"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner fa-5x"
  })]) : _c('div', [_c('va-chart', {
    attrs: {
      "chart-config": _vm.chartData
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7"
  }, [(_vm.loading_case) ? _c('div', {
    staticClass: "center"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner fa-5x"
  })]) : _c('div', [_c('p', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('case_summary')) + " : " + _vm._s(_vm.caseSummary.total))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('P', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-male fa-2x text-primary"
  }), _c('br'), _vm._v(_vm._s(_vm.caseSummary.male))]), _vm._v(" "), _c('va-chart', {
    attrs: {
      "chart-config": _vm.chartCaseDataMale
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('P', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-female fa-2x text-warning"
  }), _c('br'), _vm._v(_vm._s(_vm.caseSummary.female))]), _vm._v(" "), _c('va-chart', {
    attrs: {
      "chart-config": _vm.chartCaseDataFemale
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.loading_age) ? _c('div', {
    staticClass: "center"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner fa-5x"
  })]) : _c('div', [_c('div', {
    staticClass: "border-top my-3",
    staticStyle: {
      "border-top": "1"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('age_group_active')) + " :" + _vm._s(_vm.ageSummary.total))]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('P', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-male fa-3x text-primary"
  })]), _vm._v(" "), _c('va-chart', {
    attrs: {
      "chart-config": _vm.chartAgeDataMale
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('P', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-female fa-3x text-warning"
  })]), _vm._v(" "), _c('va-chart', {
    attrs: {
      "chart-config": _vm.chartAgeDataFemale
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.loading_death) ? _c('div', {
    staticClass: "center"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner fa-5x"
  })]) : _c('div', [_c('div', {
    staticClass: "border-top my-3",
    staticStyle: {
      "border-top": "1"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('age_group_death')) + " : " + _vm._s(_vm.deathSummary.total))]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('P', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-male fa-2x text-primary"
  }), _c('br'), _vm._v(_vm._s(_vm.deathSummary.male))]), _vm._v(" "), _c('va-chart', {
    attrs: {
      "chart-config": _vm.chartDeathDataMale
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('P', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-female fa-2x text-warning"
  }), _c('br'), _vm._v(_vm._s(_vm.deathSummary.female))]), _vm._v(" "), _c('va-chart', {
    attrs: {
      "chart-config": _vm.chartDeathDataFemale
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},staticRenderFns: []}

/***/ }),
/* 745 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('procedure_list')))]), _vm._v(" "), _c('loading', {
    attrs: {
      "loadingText": ("" + (_vm.$t('loading'))),
      "id": "loadMe",
      "loadinSubText": ("" + (_vm.$t('please_wait')))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "bsModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "bsModalLabel",
      "data-toggle": "modal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "bsModalLabel"
    }
  }, [_vm._v(_vm._s(_vm.$t('procedure_form')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.medicines),
      expression: "form.medicines"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "medicines",
      "id": "medicines",
      "placeholder": ("" + (_vm.$t('medicines')))
    },
    domProps: {
      "value": (_vm.form.medicines)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "medicines", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-success ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('submit')))])]), _vm._v(" "), (_vm.error.length > 0) ? _c('div', {
    staticClass: "alert alert-danger padding5"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": _vm.openFrom
    }
  }, [_vm._v(_vm._s(_vm.$t('add_new')))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.medicines),
      expression: "search.medicines"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "medicines",
      "placeholder": ("" + (_vm.$t('medicines')))
    },
    domProps: {
      "value": (_vm.search.medicines)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "medicines", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.status),
      expression: "search.status"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "status",
      "placeholder": ("" + (_vm.$t('status')))
    },
    domProps: {
      "value": (_vm.search.status)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "status", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success padding5",
    on: {
      "click": _vm.searchClick
    }
  }, [_vm._v(_vm._s(_vm.$t('search')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-success padding5",
    on: {
      "click": _vm.clearClick
    }
  }, [_vm._v(_vm._s(_vm.$t('clear')))])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10px"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('patientName')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('consultantName')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('consultantId')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('medicines')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('insertTime')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('status')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('action')) + " ")])]), _vm._v(" "), _vm._l((_vm.procedures), function(procedure) {
    return _c('tr', {
      key: procedure.id
    }, [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(procedure.patientName) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(procedure.consultantName) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(procedure.consultantId) + "\n")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("\n\n        " + _vm._s(_vm.moment(procedure.insertTime).startOf('hour').fromNow()) + "\n        \n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(procedure.status) + "\n")]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.openFrom(procedure)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit fa-2x"
    })])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer pb-0 pt-3"
  }, [_c('simple-pagination', {
    attrs: {
      "currentpage": _vm.search.page,
      "pages": _vm.search.totalpages
    },
    on: {
      "changePage": _vm.pageChange
    }
  })], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}

/***/ }),
/* 746 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_c('row', [_c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('va-small-box', {
    attrs: {
      "color": "aqua",
      "icon": "ion-bag",
      "title": "150",
      "description": "New Order",
      "moreText": "More info"
    },
    on: {
      "more-click": _vm.clickToSmallBox
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('va-small-box', {
    attrs: {
      "color": "green",
      "icon": "ion-stats-bars",
      "title": "53%",
      "description": "Bounce Rate",
      "moreText": "More info"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('va-small-box', {
    attrs: {
      "color": "yellow",
      "icon": "ion-person-add",
      "title": "44",
      "description": "User Registrations",
      "moreText": "More info"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('va-small-box', {
    attrs: {
      "color": "red",
      "icon": "ion-pie-graph",
      "title": "65",
      "description": "Unique Visitors",
      "moreText": "More info"
    }
  })], 1)]), _vm._v(" "), _c('row', [_c('section', {
    staticClass: "col-lg-7 connectedSortable ui-sortable"
  }, [_c('va-chat-box'), _vm._v(" "), _c('va-todo-list'), _vm._v(" "), _c('va-quick-mail')], 1), _vm._v(" "), _c('section', {
    staticClass: "col-lg-5 connectedSortable ui-sortable"
  }, [_c('va-calendar')], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 747 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('row', [_c('column', {
    staticClass: "col-md-6"
  }, [_c('va-box', {
    attrs: {
      "title": "Quick Example",
      "theme": "box-primary",
      "isBorder": true,
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('va-input-group', {
    attrs: {
      "title": "Email address",
      "vaId": "exampleInputEmail1",
      "type": "email",
      "placeholder": "Enter email"
    }
  }), _vm._v(" "), _c('va-input-group', {
    attrs: {
      "title": "Password",
      "vaId": "exampleInputPassword1",
      "type": "password",
      "placeholder": "Password"
    }
  }), _vm._v(" "), _c('va-input-group', {
    attrs: {
      "title": "File input",
      "vaId": "exampleInputFile",
      "type": "file",
      "helpBlock": "Example block-level help text here."
    }
  }), _vm._v(" "), _c('va-checkbox', {
    attrs: {
      "text": "Check me out..."
    }
  })], 1)]), _vm._v(" "), _c('va-box', {
    attrs: {
      "title": "Different Height",
      "theme": "box-success",
      "isBorder": true,
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('va-input', {
    attrs: {
      "size": "lg",
      "placeholder": ".input-lg"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('va-input', {
    attrs: {
      "placeholder": "Default input"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('va-input', {
    attrs: {
      "size": "sm",
      "placeholder": ".input-sm"
    }
  })], 1)]), _vm._v(" "), _c('va-box', {
    attrs: {
      "title": "Different Width",
      "theme": "box-danger",
      "isBorder": true,
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('column', {
    staticClass: "col-xs-3"
  }, [_c('va-input', {
    attrs: {
      "placeholder": ".col-xs-3"
    }
  })], 1), _vm._v(" "), _c('column', {
    staticClass: "col-xs-4"
  }, [_c('va-input', {
    attrs: {
      "placeholder": ".col-xs-4"
    }
  })], 1), _vm._v(" "), _c('column', {
    staticClass: "col-xs-5"
  }, [_c('va-input', {
    attrs: {
      "placeholder": ".col-xs-5"
    }
  })], 1)], 1)]), _vm._v(" "), _c('va-box', {
    attrs: {
      "title": "Input Addon",
      "theme": "box-info",
      "isBorder": true,
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('va-input-group', {
    attrs: {
      "groupType": "input",
      "placeholder": "Username",
      "prefixAddonText": "@"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('va-input-group', {
    attrs: {
      "groupType": "input",
      "suffixAddonText": ".00"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('va-input-group', {
    attrs: {
      "groupType": "input",
      "prefixAddonText": "$",
      "suffixAddonText": ".00"
    }
  }), _vm._v(" "), _c('h4', [_vm._v("With icons")]), _vm._v(" "), _c('va-input-group', {
    attrs: {
      "groupType": "input",
      "placeholder": "Email",
      "type": "email"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope",
    attrs: {
      "slot": "slotPrefixAddonText"
    },
    slot: "slotPrefixAddonText"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('va-input-group', {
    attrs: {
      "groupType": "input"
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "slot": "slotSuffixAddonText"
    },
    slot: "slotSuffixAddonText"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('va-input-group', {
    attrs: {
      "groupType": "input"
    }
  }, [_c('i', {
    staticClass: "fa fa-dollar",
    attrs: {
      "slot": "slotPrefixAddonText"
    },
    slot: "slotPrefixAddonText"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-ambulance",
    attrs: {
      "slot": "slotSuffixAddonText"
    },
    slot: "slotSuffixAddonText"
  })]), _vm._v(" "), _c('h4', [_vm._v("With checkbox and radio inputs")]), _vm._v(" "), _c('row', [_c('column', {
    staticClass: "col-lg-6"
  }, [_c('va-input-group', {
    attrs: {
      "groupType": "input"
    }
  }, [_c('input', {
    attrs: {
      "slot": "slotPrefixAddonText",
      "type": "checkbox"
    },
    slot: "slotPrefixAddonText"
  })])], 1), _vm._v(" "), _c('column', {
    staticClass: "col-lg-6"
  }, [_c('va-input-group', {
    attrs: {
      "groupType": "input"
    }
  }, [_c('input', {
    attrs: {
      "slot": "slotPrefixAddonText",
      "type": "radio"
    },
    slot: "slotPrefixAddonText"
  })])], 1)], 1), _vm._v(" "), _c('h4', [_vm._v("With buttons")]), _vm._v(" "), _c('p', {
    staticClass: "margin"
  }, [_vm._v("Large: "), _c('code', [_vm._v(".input-group.input-group-lg")])]), _vm._v(" "), _c('va-input-group', {
    staticClass: "input-group-lg",
    attrs: {
      "groupType": "input"
    }
  }, [_c('va-button', {
    staticClass: "dropdown-toggle",
    attrs: {
      "slot": "slotPrefixButton",
      "name": "Action",
      "theme": "warning",
      "data-toggle": "dropdown"
    },
    slot: "slotPrefixButton"
  }, [_vm._t("default", [_c('span', {
    staticClass: "fa fa-caret-down"
  })])], 2), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "slot": "slotPrefixDropdown"
    },
    slot: "slotPrefixDropdown"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Something else here")])]), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Separated link")])])])], 1), _vm._v(" "), _c('p', {
    staticClass: "margin"
  }, [_vm._v("Normal")]), _vm._v(" "), _c('va-input-group', {
    attrs: {
      "groupType": "input",
      "placeholer": ""
    }
  }, [_c('va-button', {
    attrs: {
      "slot": "slotPrefixButton",
      "name": "Action",
      "theme": "danger"
    },
    slot: "slotPrefixButton"
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "margin"
  }, [_vm._v("Small "), _c('code', [_vm._v(".input-group.input-group-sm")])]), _vm._v(" "), _c('va-input-group', {
    attrs: {
      "groupType": "input",
      "placeholer": ""
    }
  }, [_c('va-button', {
    attrs: {
      "slot": "slotSuffixButton",
      "name": "Go!",
      "theme": "info"
    },
    slot: "slotSuffixButton"
  })], 1)], 1)])], 1), _vm._v(" "), _c('column', {
    staticClass: "col-md-6"
  }, [_c('va-box', {
    attrs: {
      "title": "Horizontal Form",
      "theme": "box-info",
      "isBorder": true,
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('va-input', {
    attrs: {
      "isHorizontal": true,
      "title": "Email",
      "placeholder": "Email",
      "type": "email",
      "vaId": "horizontal-email"
    }
  }), _vm._v(" "), _c('va-input', {
    attrs: {
      "isHorizontal": true,
      "title": "Password",
      "placeholder": "Password",
      "type": "password",
      "vaId": "horizontal-email"
    }
  }), _vm._v(" "), _c('va-checkbox', {
    attrs: {
      "isHorizontal": true,
      "text": "Check me out..."
    }
  })], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('va-button', {
    attrs: {
      "isBlock": false,
      "name": "Cancel"
    }
  }), _vm._v(" "), _c('va-button', {
    attrs: {
      "isBlock": false,
      "theme": "info",
      "align": "right",
      "name": "Sign in"
    }
  })], 1)]), _vm._v(" "), _c('va-box', {
    attrs: {
      "title": "General Elements",
      "isBorder": true,
      "theme": "box-warning",
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('va-input-group', {
    attrs: {
      "title": "Text",
      "vaId": "ge-text-input",
      "placeholder": "Enter ..."
    }
  }), _vm._v(" "), _c('va-input-group', {
    attrs: {
      "title": "Text Disabled",
      "vaId": "ge-text-input-disabled",
      "placeholder": "Enter ...",
      "isDisabled": true
    }
  }), _vm._v(" "), _c('va-textarea-group', {
    attrs: {
      "title": "Textarea",
      "isDisabled": true,
      "placeholder": "Enter ..."
    }
  }), _vm._v(" "), _c('va-input-group', {
    attrs: {
      "theme": "success",
      "helpBlock": "Help block with success"
    }
  }, [_c('label', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Input with success")])]), _vm._v(" "), _c('va-input-group', {
    attrs: {
      "theme": "warning",
      "helpBlock": "Help block with success"
    }
  }, [_c('label', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-bell-o"
  }), _vm._v(" Input with warning")])]), _vm._v(" "), _c('va-input-group', {
    attrs: {
      "theme": "error",
      "helpBlock": "Help block with success"
    }
  }, [_c('label', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-times-circle-o"
  }), _vm._v(" Input with error")])]), _vm._v(" "), _c('va-form-group', [_c('va-checkbox', {
    attrs: {
      "text": "Checkbox 1"
    }
  }), _vm._v(" "), _c('va-checkbox', {
    attrs: {
      "text": "Checkbox 2"
    }
  }), _vm._v(" "), _c('va-checkbox', {
    attrs: {
      "text": "Checkbox disabled",
      "isDisabled": true
    }
  })], 1), _vm._v(" "), _c('va-form-group', [_c('va-radio', {
    attrs: {
      "name": "optionsRadios",
      "vaId": "optionsRadios1",
      "value": "option1",
      "isChecked": true
    }
  }, [_vm._v("\n            Option one is this and that—be sure to include why it's great\n          ")]), _vm._v(" "), _c('va-radio', {
    attrs: {
      "name": "optionsRadios",
      "vaId": "optionsRadios2",
      "value": "option2"
    }
  }, [_vm._v("\n            Option two can be something else and selecting it will deselect option one\n          ")]), _vm._v(" "), _c('va-radio', {
    attrs: {
      "name": "optionsRadios",
      "vaId": "optionsRadios3",
      "value": "option3",
      "isDisabled": true
    }
  }, [_vm._v("\n            Option three is disabled\n          ")])], 1), _vm._v(" "), _c('va-form-group', [_c('label', [_vm._v("Select")]), _vm._v(" "), _c('va-select', {
    attrs: {
      "list": _vm.selectList
    }
  })], 1), _vm._v(" "), _c('va-form-group', [_c('label', [_vm._v("Select Disabled")]), _vm._v(" "), _c('va-select', {
    attrs: {
      "list": _vm.selectList,
      "isDisabled": true
    }
  })], 1), _vm._v(" "), _c('va-form-group', [_c('label', [_vm._v("Select Multiple")]), _vm._v(" "), _c('va-select', {
    attrs: {
      "list": _vm.selectList,
      "isMultiple": true
    }
  })], 1), _vm._v(" "), _c('va-form-group', [_c('label', [_vm._v("Select Multiple Disabled")]), _vm._v(" "), _c('va-select', {
    attrs: {
      "list": _vm.selectList,
      "isMultiple": true,
      "isDisabled": true
    }
  })], 1)], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 748 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box",
    class: [_vm.theme, this.isOpen ? '' : 'collapsed-box', _vm.isSolid ? 'box-solid' : '']
  }, [_c('div', {
    staticClass: "box-header",
    class: (_vm.isBorder || _vm.isSolid) ? 'with-border' : ''
  }, [_vm._t("icon-title"), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": _vm.widgetType
    }
  }, [_c('i', {
    class: _vm.btnIcon
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_vm._t("content")], 2), _vm._v(" "), (_vm.$slots.footer) ? _c('div', {
    staticClass: "box-footer"
  }, [_vm._t("footer")], 2) : _vm._e(), _vm._v(" "), (this.isLoading) ? _c('div', {
    staticClass: "overlay"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 749 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', _vm._g(_vm._b({
    ref: "input"
  }, 'input', _vm.$attrs, false), _vm.$listeners))
},staticRenderFns: []}

/***/ }),
/* 750 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('loading', {
    attrs: {
      "loadingText": ("" + (_vm.$t('loading'))),
      "id": "loadMe",
      "loadinSubText": ("" + (_vm.$t('please_wait')))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box",
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('location')))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('gmap-autocomplete', {
    staticClass: "introInput form-control",
    attrs: {
      "value": _vm.description
    },
    on: {
      "place_changed": _vm.setPlace
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function(slotProps) {
        return [_c('v-text-field', {
          ref: "input",
          attrs: {
            "outlined": "",
            "prepend-inner-icon": "place",
            "placeholder": "Location Of Event"
          },
          on: {
            "listeners": slotProps.listeners,
            "attrs": slotProps.attrs
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('GmapMap', {
    staticStyle: {
      "width": "99%",
      "height": "400px"
    },
    attrs: {
      "id": "map",
      "center": _vm.center,
      "zoom": 15,
      "map-type-id": "terrain"
    },
    on: {
      "click": _vm.getPos
    }
  }, _vm._l((_vm.markers), function(m, index) {
    return _c('GmapMarker', {
      key: index,
      attrs: {
        "position": m.position,
        "clickable": true,
        "draggable": true
      },
      on: {
        "click": function($event) {
          _vm.center = m.position
        }
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.locationName),
      expression: "form.locationName"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "locationName",
      "id": "locationName",
      "placeholder": ("" + (_vm.$t('locationName')))
    },
    domProps: {
      "value": (_vm.form.locationName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "locationName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.district),
      expression: "form.district"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "district",
      "id": "district",
      "placeholder": ("" + (_vm.$t('district')))
    },
    domProps: {
      "value": (_vm.form.district)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "district", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.state),
      expression: "form.state"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "state",
      "id": "state",
      "placeholder": ("" + (_vm.$t('state')))
    },
    domProps: {
      "value": (_vm.form.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "state", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.latitude),
      expression: "form.latitude"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "latitude",
      "id": "latitude",
      "placeholder": ("" + (_vm.$t('latitude')))
    },
    domProps: {
      "value": (_vm.form.latitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "latitude", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.longitude),
      expression: "form.longitude"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "longitude",
      "id": "longitude",
      "placeholder": ("" + (_vm.$t('longitude')))
    },
    domProps: {
      "value": (_vm.form.longitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "longitude", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('submit')))])]), _vm._v(" "), (_vm.error.length > 0) ? _c('div', {
    staticClass: "alert alert-danger padding5"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), (_vm.success.length > 0) ? _c('div', {
    staticClass: "alert alert-success padding5"
  }, [_c('i', {
    staticClass: "fa fa-check fa-5x text-success",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 751 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.name,
      "tabindex": "-1",
      "role": "dialog",
      "size": "lg",
      "aria-labelledby": "bsModalLabel",
      "data-toggle": "modal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "bsModalLabel"
    }
  }, [_vm._v(_vm._s(_vm.$t('tasklist')[[3]]) + "  ->   " + _vm._s(_vm.$t('name')) + ":" + _vm._s(_vm.patientInfo.name) + " ,  " + _vm._s(_vm.$t('age')) + " : " + _vm._s(new Date().getFullYear() - _vm.patientInfo.yob) + "  " + _vm._s(_vm.$t('years')))])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "modal-body center",
    staticStyle: {
      "min-height": "450px"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin fa-5x text-primary",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "input-group",
    staticStyle: {
      "width": "100%",
      "paddingBottom": "15px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchMedicine.name),
      expression: "searchMedicine.name"
    }],
    staticClass: "input-group-text ",
    attrs: {
      "type": "text",
      "placeholder": ("" + (_vm.$t('medicine_name')))
    },
    domProps: {
      "value": (_vm.searchMedicine.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.searchMedicine, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchMedicine.productType),
      expression: "searchMedicine.productType"
    }],
    staticClass: "input-group-select",
    attrs: {
      "placeholder": ("" + (_vm.$t('medicineTypeName')))
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.searchMedicine, "productType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('medicineGroupName')))]), _vm._v(" "), _vm._l((_vm.$t('medicineType')), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n                      " + _vm._s(s) + "\n                    ")])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchMedicine.groupName),
      expression: "searchMedicine.groupName"
    }],
    staticClass: "input-group-select",
    attrs: {
      "name": "groupName"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.searchMedicine, "groupName", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('medicineGroupName')))]), _vm._v(" "), _vm._l((_vm.$t('medicineGroups')), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n                           " + _vm._s(s) + "\n                  ")])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchMedicine.warnings),
      expression: "searchMedicine.warnings"
    }],
    staticClass: "input-group-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.searchMedicine, "warnings", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('warning')))]), _vm._v(" "), _vm._l((_vm.$t('medicineWarning')), function(w, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n                           " + _vm._s(w) + "\n                    ")])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success padding5",
    on: {
      "click": function($event) {
        return _vm.searchMedicineClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('search')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-success padding5",
    on: {
      "click": function($event) {
        return _vm.clearMedicineClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('clear')))])])]), _vm._v(" "), _c('div', {
    staticClass: "scrollbar scrollbar-black bordered-black square overflow-auto",
    staticStyle: {
      "max-height": "250px",
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('medicineGroupName')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('medicineTypeName')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('warning')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('quantity')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('duration')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('before_after_meal')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('action')) + " ")])]), _vm._v(" "), _vm._l((_vm.medicines), function(med) {
    return _c('tr', {
      key: med.id
    }, [_c('td', [_vm._v(_vm._s(med.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('medicineGroups')[[med.groupName]]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('medicineType')[[med.productType]]))]), _vm._v(" "), _c('td', _vm._l((_vm.$t('medicineWarning')), function(w, i) {
      return _c('i', {
        key: i
      }, [_vm._v("\n                              " + _vm._s(med.warnings.indexOf(i) >= 0 ? w : '') + "\n                      ")])
    }), 0), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (med.quantity),
        expression: "med.quantity"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(med, "quantity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.$t('quantityData')), function(w, i) {
      return _c('option', {
        key: i,
        domProps: {
          "value": i
        }
      }, [_vm._v("\n                           " + _vm._s(w) + "\n                          ")])
    }), 0)]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (med.duration),
        expression: "med.duration"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(med, "duration", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.$t('durationData')), function(w, i) {
      return _c('option', {
        key: i,
        domProps: {
          "value": i
        }
      }, [_vm._v("\n                           " + _vm._s(w) + "\n                          ")])
    }), 0)]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (med.beforeAfterMeal),
        expression: "med.beforeAfterMeal"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(med, "beforeAfterMeal", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.$t('beforeAftermealData')), function(w, i) {
      return _c('option', {
        key: i,
        domProps: {
          "value": i
        }
      }, [_vm._v("\n                           " + _vm._s(w) + "\n                          ")])
    }), 0)]), _vm._v(" "), (_vm.medicineSelected(med._id)) ? _c('td', [_c('i', {
      staticClass: "fa fa-check fa-2x text-success"
    })]) : _c('td', [(!_vm.medicineSelected(med._id)) ? _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.selectMedicine(med)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit fa-2x"
    })]) : _vm._e()])])
  })], 2)])]), _vm._v(" "), _c('hr', {
    staticClass: "text-warning"
  }), _vm._v(" "), _c('div', {
    staticClass: "scrollbar scrollbar-black bordered-black square overflow-auto",
    staticStyle: {
      "max-height": "250px",
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-dark table-bordered"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('medicineGroupName')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('medicineTypeName')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('warning')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('quantity')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('duration')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('before_after_meal')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('action')) + " ")])]), _vm._v(" "), _vm._l((_vm.prescription.medicines), function(med) {
    return _c('tr', {
      key: med.id
    }, [_c('td', [_vm._v(_vm._s(med.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('medicineGroups')[[med.groupName]]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('medicineType')[[med.productType]]))]), _vm._v(" "), _c('td', _vm._l((_vm.$t('medicineWarning')), function(w, i) {
      return _c('i', {
        key: i
      }, [_vm._v("\n                              " + _vm._s(med.warnings.indexOf(i) >= 0 ? w : '') + "\n                      ")])
    }), 0), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('quantityData')[[med.quantity]]) + " "), (med.productType == 2) ? _c('span', [_vm._v(_vm._s(_vm.$t('spoon')))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('durationData')[[med.duration]]) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('beforeAftermealData')[[med.beforeAfterMeal]]) + "\n                ")]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.removeMedicine(med)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove fa-2x text-danger"
    })])])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.$t('prescriptionTasks')), function(s, i) {
    return _c('li', {
      key: i,
      staticClass: "list-group-item"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.prescription.taskType),
        expression: "prescription.taskType"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": i,
        "checked": Array.isArray(_vm.prescription.taskType) ? _vm._i(_vm.prescription.taskType, i) > -1 : (_vm.prescription.taskType)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.prescription.taskType,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = i,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.prescription, "taskType", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.prescription, "taskType", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.prescription, "taskType", $$c)
          }
        }
      }
    }), _vm._v("\n                            " + _vm._s(s) + "\n                            ")])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prescription.priority),
      expression: "prescription.priority"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": ("" + (_vm.$t('priorityLbl')))
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.prescription, "priority", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$t('priorityData')), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n        " + _vm._s(s) + "\n        ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prescription.comments),
      expression: "prescription.comments"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "comments",
      "id": "comments",
      "placeholder": ("" + (_vm.$t('comments')))
    },
    domProps: {
      "value": (_vm.prescription.comments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.prescription, "comments", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-success ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submitPrescription($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('submit')))])]), _vm._v(" "), (_vm.error.length > 0) ? _c('div', {
    staticClass: "alert alert-danger padding5"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}

/***/ }),
/* 752 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('i', {
    staticClass: "ion ion-clipboard"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("To Do List")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('ul', {
    staticClass: "pagination pagination-sm inline"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("«")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("»")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('ul', {
    staticClass: "todo-list"
  }, [_c('li', [_c('span', {
    staticClass: "handle"
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-v"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-ellipsis-v"
  })]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "checkbox",
      "value": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Design a nice theme")]), _vm._v(" "), _c('small', {
    staticClass: "label label-danger"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" 2 mins")]), _vm._v(" "), _c('div', {
    staticClass: "tools"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-trash-o"
  })])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "handle"
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-v"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-ellipsis-v"
  })]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "checkbox",
      "value": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Make the theme responsive")]), _vm._v(" "), _c('small', {
    staticClass: "label label-info"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" 4 hours")]), _vm._v(" "), _c('div', {
    staticClass: "tools"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-trash-o"
  })])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "handle"
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-v"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-ellipsis-v"
  })]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "checkbox",
      "value": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Let theme shine like a star")]), _vm._v(" "), _c('small', {
    staticClass: "label label-warning"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" 1 day")]), _vm._v(" "), _c('div', {
    staticClass: "tools"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-trash-o"
  })])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "handle"
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-v"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-ellipsis-v"
  })]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "checkbox",
      "value": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Let theme shine like a star")]), _vm._v(" "), _c('small', {
    staticClass: "label label-success"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" 3 days")]), _vm._v(" "), _c('div', {
    staticClass: "tools"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-trash-o"
  })])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "handle"
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-v"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-ellipsis-v"
  })]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "checkbox",
      "value": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Check your messages and notifications")]), _vm._v(" "), _c('small', {
    staticClass: "label label-primary"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" 1 week")]), _vm._v(" "), _c('div', {
    staticClass: "tools"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-trash-o"
  })])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "handle"
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-v"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-ellipsis-v"
  })]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "checkbox",
      "value": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Let theme shine like a star")]), _vm._v(" "), _c('small', {
    staticClass: "label label-default"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" 1 month")]), _vm._v(" "), _c('div', {
    staticClass: "tools"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-trash-o"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer clearfix no-border"
  }, [_c('button', {
    staticClass: "btn btn-default pull-right",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add item")])])])
}]}

/***/ }),
/* 753 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: this['class']
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./index.js": 100,
	"./language.js": 353,
	"./messages.js": 354,
	"./notifications.js": 355,
	"./products.js": 356,
	"./tasks.js": 357,
	"./user.js": 358
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 769;

/***/ })
],[333]);


// WEBPACK FOOTER //
// static/js/app.fd4fb861956449f10b90.js